/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "//static.glanacion.com/v2/ingresar/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 553);
/******/ })
/************************************************************************/
/******/ ({

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


LN.CustomDimension = new function (LocalStorage) {
    var self = this;
    var key = 'CustomDimension';
    var objCustomDimension = {};
    this.get = function () {
        objCustomDimension = LocalStorage.getItem(key);
        return objCustomDimension;
    };

    this.clear = function () {
        objCustomDimension = {};
        LocalStorage.removeItem(key);
    };

    this.set = function (prop, value) {
        if (!objCustomDimension) objCustomDimension = {};
        objCustomDimension[prop] = value;
        return objCustomDimension;
    };

    this.save = function () {
        LocalStorage.setItem(key, objCustomDimension);
    };

    this.exist = function () {
        return this.get() !== null;
    };

    this.setSuscriptorType = function (value) {
        this.set('suscriptorType', value);
    };
    this.setRegistrado = function (value) {
        this.set('usuarioRegistrado', value);
    };
    this.setUserId = function (value) {
        this.set('userId', value);
    };
}(LN.LocalStorage);

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


LN.LocalStorage = new function (Config) {
    var self = this;

    self.removeItem = function (key) {
        localStorage.removeItem(key);
    };

    self.setExpiredItem = function (key, value) {
        var item = {
            'value': value,
            'expiration': new Date()
        };

        localStorage.setItem(key, JSON.stringify(item));
    };

    self.setItem = function (key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    };
    self.getItem = function (key) {
        return JSON.parse(localStorage.getItem(key));
    };

    self.renew = function (key) {
        var item = self.getItem(key);
        if (item.expiration) {
            item.expiration = new Date();

            localStorage.setItem(key, JSON.stringify(item));
        }
    };

    self.checkExpiration = function (key, expiration) {
        var item = self.getItem(key);
        if (item.expiration) {
            var itemexpiration = new Date(item.expiration);

            var lifetime = expiration || Config.StorageExpiration;

            if (new Date() - itemexpiration < lifetime) {
                return item;
            } else {
                return null;
            }
        }
        return null;
    };

    self.checkIfExists = function (key) {
        return localStorage.getItem(key) !== null;
    };
}(LN.Config);

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function SmartLock() {
    var self = this;
    var providers = {
        fb: 'https://www.facebook.com',
        gm: 'https://accounts.google.com'
    };
    this.savePassword = function (email, password, name, iconUrl) {
        if (navigator.credentials && email && existCredential('PasswordCredential')) {
            this.signOut();

            var cred = new PasswordCredential({
                id: email,
                password: password,
                name: name,
                iconURL: iconUrl
            });
            navigator.credentials.store(cred);
        }
    };

    this.saveGmail = function (id, name, iconUrl) {
        if (navigator.credentials && id && existCredential('FederatedCredential')) {
            this.signOut();
            var c = new FederatedCredential({
                id: id,
                name: name,
                provider: 'https://accounts.google.com',
                iconURL: iconUrl
            });
            navigator.credentials.store(c);
            return c;
        }
        return null;
    };
    this.saveFacebook = function (id, name, iconUrl) {
        if (navigator.credentials && id && existCredential('FederatedCredential')) {
            this.signOut();

            var cred = new FederatedCredential({
                id: id,
                name: name,
                provider: providers.fb,
                iconURL: iconUrl
            });
            navigator.credentials.store(cred);
            return cred;
        }
    };

    this.get = function (cb, password, optional) {
        if (navigator.credentials) {
            optional = optional || false;
            password = password || false;
            navigator.credentials.get({
                password: password,
                //unmediated: false,
                mediation: 'optional',
                federated: {
                    providers: [providers.gm, providers.fb]
                }

            }).then(function (cred) {
                processGet(cb, cred);
            });
        }
    };

    var processGet = function processGet(cb, cred) {
        var response = {
            credential: cred,
            type: null
        };
        if (cred) {
            switch (cred.type) {
                case 'password':
                    response.type = 'nativo';
                    break;
                case 'federated':
                    if (cred.provider == providers.fb) response.type = 'fb';else if (cred.provider == providers.gm) response.type = 'gm';
                    break;
            }
        }
        cb && cb(response);
    };

    this.signOut = function () {
        if (navigator.credentials) {
            navigator.credentials.preventSilentAccess();
        }
    };

    var existCredential = function existCredential(credential) {
        return typeof window[credential] == 'function';
    };
}

window.smartlock = new SmartLock();

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


LN.Wcentrix = new function (Config) {
    'use strict';

    this.initChat = function (page) {
        $(document).ready(function () {
            if (Config.idWcentrix) {
                setTimeout(function () {
                    var s;
                    if (window.innerWidth >= 767) {
                        console.log('initWc');
                        s = document.createElement("script");
                        s.defer = true;
                        s.src = "https://wcentrix.net/tabhelp/wctabs.aspx?id=" + Config.idWcentrix + "&" + new Date().getTime(), document.head.appendChild(s);
                    }
                }, Config.wCentrixTime);
            }
        });
    };
}(LN.Config);

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Autotab - jQuery plugin 1.9.2
 * https://github.com/Mathachew/jquery-autotab
 * 
 * Copyright (c) 2008, 2015 Matthew Miller
 * 
 * Licensed under the MIT licensing:
 *   http://www.opensource.org/licenses/mit-license.php
 */

(function ($) {
    var platform = navigator.platform,
        settings = {
        tabPause: 800,
        focusChange: null,
        iOS: platform === 'iPad' || platform === 'iPhone' || platform === 'iPod',
        firefox: typeof InstallTrigger !== 'undefined',
        ie11: !window.ActiveXObject && "ActiveXObject" in window
    };

    var setSettings = function setSettings(e, settings) {
        if (settings === null || typeof settings === 'undefined') {
            return;
        }

        for (var key in settings) {
            $(e).data('autotab-' + key, settings[key]);
        }
    };

    var getSettings = function getSettings(e) {
        var settings = {
            arrowKey: false,
            format: 'all',
            loaded: false,
            disabled: false,
            pattern: null,
            uppercase: false,
            lowercase: false,
            nospace: false,
            maxlength: 2147483647,
            target: null,
            previous: null,
            trigger: null,
            originalValue: '',
            changed: false,
            editable: e.type === 'text' || e.type === 'password' || e.type === 'textarea' || e.type === 'tel' || e.type === 'number' || e.type === 'email' || e.type === 'search' || e.type === 'url',
            filterable: e.type === 'text' || e.type === 'password' || e.type === 'textarea',
            tabOnSelect: false
        };

        // If $.autotab.selectFilterByClas is true and the format not specified, automatically select an element's format based on a matching class name.
        // The first matched element becomes the selected format for the filter.
        if ($.autotab.selectFilterByClass === true && typeof $(e).data('autotab-format') === 'undefined') {
            var classes = ['all', 'text', 'alpha', 'number', 'numeric', 'alphanumeric', 'hex', 'hexadecimal', 'custom'];

            for (var key in classes) {
                if ($(e).hasClass(classes[key])) {
                    settings.format = classes[key];
                    break;
                }
            }
        }

        for (var key in settings) {
            if (typeof $(e).data('autotab-' + key) !== 'undefined') {
                settings[key] = $(e).data('autotab-' + key);
            }
        }

        // Save settings on first run
        if (!settings.loaded) {
            if (settings.trigger !== null && typeof settings.trigger === 'string') {
                settings.trigger = settings.trigger.toString();
            }

            setSettings(e, settings);
        }

        return settings;
    };

    var queryObject = function queryObject(e) {
        return typeof e !== 'undefined' && (typeof e === 'string' || !(e instanceof jQuery));
    };

    var getSelection = function getSelection(e) {
        var start = 0,
            end = 0,
            selectionType = 0;

        if (e.type === 'text' || e.type === 'password' || e.type === 'textarea') {
            if (typeof e.selectionStart === 'number' && typeof e.selectionEnd === 'number') {
                // Non-IE browsers and IE 9+
                start = e.selectionStart;
                end = e.selectionEnd;
                selectionType = 1;
            } else if (document.selection && document.selection.createRange) {
                // For IE up to version 8
                var selectionRange = document.selection.createRange(),
                    textInputRange = e.createTextRange(),
                    precedingRange = e.createTextRange(),
                    bookmark = selectionRange.getBookmark();
                textInputRange.moveToBookmark(bookmark);
                precedingRange.setEndPoint("EndToStart", textInputRange);
                start = precedingRange.text.length;
                end = start + selectionRange.text.length;
                selectionType = 2;
            }
        }

        return {
            start: start,
            end: end,
            selectionType: selectionType
        };
    };

    $.autotab = function (options) {
        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
            options = {};
        }

        $(':input').autotab(options);
    };

    $.autotab.selectFilterByClass = false;

    $.autotab.next = function () {
        var e = $(document.activeElement);

        if (e.length) {
            e.trigger('autotab-next');
        }
    };

    $.autotab.previous = function () {
        var e = $(document.activeElement);

        if (e.length) {
            e.trigger('autotab-previous');
        }
    };

    $.autotab.remove = function (e) {
        queryObject(e) ? $(e).autotab('remove') : $(':input').autotab('remove');
    };

    $.autotab.restore = function (e) {
        queryObject(e) ? $(e).autotab('restore') : $(':input').autotab('restore');
    };

    $.autotab.refresh = function (e) {
        queryObject(e) ? $(e).autotab('refresh') : $(':input').autotab('refresh');
    };

    $.fn.autotab = function (method, options) {
        if (!this.length) {
            return this;
        }

        // Remove hidden fields since tabbing backwards is supported on different form elements
        var filtered = $.grep(this, function (e, i) {
            return e.type != 'hidden';
        });

        // Apply filter options
        if (method == 'filter') {
            if (typeof options === 'string' || typeof options === 'function') {
                options = { format: options };
            }

            for (var i = 0, length = filtered.length; i < length; i++) {
                var defaults = getSettings(filtered[i]),
                    newOptions = options;

                // Retain the established target/previous values as this area is for filtering only
                newOptions.target = defaults.target;
                newOptions.previous = defaults.previous;

                $.extend(defaults, newOptions);

                if (!defaults.loaded) {
                    defaults.disabled = true;
                    autotabBind(filtered[i], newOptions);
                } else {
                    setSettings(filtered[i], defaults);
                }
            }
        }
        // Disable auto tab and filtering
        else if (method == 'remove' || method == 'destroy' || method == 'disable') {
                for (var i = 0, length = filtered.length; i < length; i++) {
                    var defaults = getSettings(filtered[i]);

                    defaults.disabled = true;

                    setSettings(filtered[i], defaults);
                }
            }
            // Re-enable auto tab and filtering
            else if (method == 'restore' || method == 'enable') {
                    for (var i = 0, length = filtered.length; i < length; i++) {
                        var defaults = getSettings(filtered[i]);

                        defaults.disabled = false;

                        setSettings(filtered[i], defaults);
                    }
                }
                // Refresh target/previous elements
                else if (method == 'refresh') {
                        for (var i = 0, length = filtered.length; i < length; i++) {
                            var defaults = getSettings(filtered[i]),
                                n = i + 1,
                                p = i - 1,
                                selectTarget = function selectTarget() {
                                if (i > 0 && n < length) {
                                    defaults.target = filtered[n];
                                } else if (i > 0) {
                                    defaults.target = null;
                                } else {
                                    defaults.target = filtered[n];
                                }
                            },
                                selectPrevious = function selectPrevious() {
                                if (i > 0 && n < length) {
                                    defaults.previous = filtered[p];
                                } else if (i > 0) {
                                    defaults.previous = filtered[p];
                                } else {
                                    defaults.previous = null;
                                }
                            };

                            // Nothing was specified for the target element, so automatically set it
                            if (defaults.target === null || defaults.target.selector === '') {
                                selectTarget();
                            } else if (typeof defaults.target === 'string' || defaults.target.selector) {
                                defaults.target = $(typeof defaults.target === 'string' ? defaults.target : defaults.target.selector);

                                if (defaults.target.length === 0) {
                                    selectTarget();
                                }
                            }

                            // Nothing was specified for the previous element, so automatically set it
                            if (defaults.previous === null || defaults.previous.selector === '') {
                                selectPrevious();
                            } else if (typeof defaults.previous === 'string' || defaults.previous.selector) {
                                defaults.previous = $(typeof defaults.previous === 'string' ? defaults.previous : defaults.previous.selector);

                                if (defaults.previous.length === 0) {
                                    selectPrevious();
                                }
                            }

                            if (!defaults.loaded) {
                                autotabBind(filtered[i], defaults);
                            } else {
                                if (queryObject(defaults.target)) {
                                    defaults.target = $(defaults.target);
                                }

                                if (queryObject(defaults.previous)) {
                                    defaults.previous = $(defaults.previous);
                                }

                                setSettings(filtered[i], defaults);
                            }
                        }
                    } else {
                        if (method === null || typeof method === 'undefined') {
                            options = {};
                        } else if (typeof method === 'string' || typeof method === 'function') {
                            options = { format: method };
                        } else if ((typeof method === 'undefined' ? 'undefined' : _typeof(method)) === 'object') {
                            options = method;
                        }

                        // Bind key events to element(s) passed
                        if (filtered.length > 1) {
                            for (var i = 0, length = filtered.length; i < length; i++) {
                                var n = i + 1,
                                    p = i - 1,
                                    newOptions = options;

                                if (i > 0 && n < length) {
                                    newOptions.target = filtered[n];
                                    newOptions.previous = filtered[p];
                                } else if (i > 0) {
                                    newOptions.target = null;
                                    newOptions.previous = filtered[p];
                                } else {
                                    newOptions.target = filtered[n];
                                    newOptions.previous = null;
                                }

                                autotabBind(filtered[i], newOptions);
                            }
                        } else {
                            autotabBind(filtered[0], options);
                        }
                    }

        return this;
    };

    var filterValue = function filterValue(e, value, defaults) {
        if (typeof defaults.format === 'function') {
            return defaults.format(value, e);
        }

        var pattern = null;

        switch (defaults.format) {
            case 'text':
                pattern = new RegExp('[0-9]+', 'g');
                break;

            case 'alpha':
                pattern = new RegExp('[^a-zA-Z]+', 'g');
                break;

            case 'number':
            case 'numeric':
                pattern = new RegExp('[^0-9]+', 'g');
                break;

            case 'alphanumeric':
                pattern = new RegExp('[^0-9a-zA-Z]+', 'g');
                break;

            case 'hex':
            case 'hexadecimal':
                pattern = new RegExp('[^0-9A-Fa-f]+', 'g');
                break;

            case 'custom':
                pattern = new RegExp(defaults.pattern, 'g');
                break;

            case 'all':
            default:
                break;
        }

        if (pattern !== null) {
            value = value.replace(pattern, '');
        }

        if (defaults.nospace) {
            pattern = new RegExp('[ ]+', 'g');
            value = value.replace(pattern, '');
        }

        if (defaults.uppercase) {
            value = value.toUpperCase();
        }

        if (defaults.lowercase) {
            value = value.toLowerCase();
        }

        return value;
    };

    var autotabBind = function autotabBind(element, options) {
        var defaults = getSettings(element);

        if (defaults.disabled) {
            defaults.disabled = false;
            defaults.target = null;
            defaults.previous = null;
        }

        $.extend(defaults, options);

        // Sets targets to element based on the name or ID passed if they are not currently objects
        if (queryObject(defaults.target)) {
            defaults.target = $(defaults.target);
        }

        if (queryObject(defaults.previous)) {
            defaults.previous = $(defaults.previous);
        }

        var oldMaxlength = element.maxLength;

        if (typeof element.maxLength === 'undefined' && element.type == 'textarea') {
            oldMaxlength = element.maxLength = element.getAttribute('maxlength');
        }

        // defaults.maxlength has not changed and maxlength was specified
        if (defaults.maxlength == 2147483647 && oldMaxlength != 2147483647 && oldMaxlength != -1) {
            defaults.maxlength = oldMaxlength;
        }
        // defaults.maxlength overrides maxlength
        else if (defaults.maxlength > 0) {
                element.maxLength = defaults.maxlength;
            }
            // defaults.maxlength and maxlength have not been specified
            // A target cannot be used since there is no defined maxlength
            else {
                    defaults.target = null;
                }

        if (!defaults.loaded) {
            defaults.loaded = true;
            setSettings(element, defaults);
        } else {
            setSettings(element, defaults);
            return;
        }

        // Add a change event to select lists only so that we can auto tab when a value is selected
        if (element.type == 'select-one') {
            $(element).on('change', function (e) {
                var defaults = getSettings(this);

                if (defaults.tabOnSelect) {
                    $(this).trigger('autotab-next');
                }
            });
        }

        // The 1ms timeouts allow for keypress events to complete in case a
        // custom function or exterior method calls for a manual auto tab
        $(element).on('autotab-next', function (event, defaults) {
            var self = this;
            setTimeout(function () {
                if (!defaults) {
                    defaults = getSettings(self);
                }

                var target = defaults.target;

                if (!defaults.disabled && target.length) {
                    // Using focus on iOS devices is a pain, so use the browser's next/previous buttons to proceed
                    if (!settings.iOS) {

                        // Field is disabled/readonly, so tab to next element
                        if (target.prop('disabled') || target.prop('readonly')) {
                            target.trigger('autotab-next');
                        } else {
                            // Allows the user to navigate between each charater with arrow keys
                            if (defaults.arrowKey) {
                                target.focus();
                            } else {
                                target.focus().select();
                            }
                        }

                        settings.focusChange = new Date();
                    }
                }
            }, 1);
        }).on('autotab-previous', function (event, defaults) {
            var self = this;
            setTimeout(function () {
                if (!defaults) {
                    defaults = getSettings(self);
                }

                var previous = defaults.previous;

                if (!defaults.disabled && previous.length) {
                    var value = previous.val();

                    // Field is disabled/readonly, so tab to previous element
                    if (previous.prop('disabled') || previous.prop('readonly')) {
                        previous.trigger('autotab-previous');
                    } else if (value.length && previous.data('autotab-editable') && !defaults.arrowKey) {
                        if (settings.ie11) {
                            previous.val(value.substring(0, value.length - 1)).focus();
                        } else {
                            previous.focus().val(value.substring(0, value.length - 1));
                        }

                        setSettings(previous, { changed: true });
                    } else {
                        if (defaults.arrowKey) {
                            setSettings(this, { arrowKey: false });
                        }

                        if (settings.ie11) {
                            previous.val(value).focus();
                        } else {
                            previous.focus().val(value);
                        }
                    }

                    settings.focusChange = null;
                }
            }, 1);
        }).on('focus', function () {
            setSettings(this, { originalValue: this.value });
        }).on('blur', function () {
            var defaults = getSettings(this);

            if (defaults.changed && this.value != defaults.originalValue) {
                setSettings(this, { changed: false });
                $(this).change();
            }
        }).on('keydown.autotab', function (e) {
            var defaults = getSettings(this);

            if (!defaults || defaults.disabled) {
                return true;
            }

            var selection = getSelection(this),
                keyCode = e.which || e.charCode;

            // Go to the previous element when backspace
            // is pressed in an empty input field
            if (keyCode == 8) {
                defaults.arrowKey = false;

                // Prevent the browser from of navigating to the previous page
                if (!defaults.editable) {
                    $(this).trigger('autotab-previous', defaults);
                    return false;
                }

                setSettings(this, { changed: this.value !== defaults.originalValue });

                if (this.value.length === 0) {
                    $(this).trigger('autotab-previous', defaults);
                    return;
                }
            } else if (keyCode == 9 && settings.focusChange !== null) {
                // Tab backwards
                if (e.shiftKey) {
                    settings.focusChange = null;
                    return;
                }

                if (new Date().getTime() - settings.focusChange.getTime() < settings.tabPause) {
                    settings.focusChange = null;
                    return false;
                }
            } else if (this.type !== 'range' && this.type !== 'select-one' && this.type !== 'select-multiple') {
                if (this.type !== 'tel' && this.type !== 'number' || (this.type === 'tel' || this.type === 'number') && this.value.length == 0) {
                    if (keyCode == 37 && (!defaults.editable || selection.start == 0)) {
                        defaults.arrowKey = true;
                        $(this).trigger('autotab-previous', defaults);
                    } else if (keyCode == 39 && (!defaults.editable || !defaults.filterable || selection.end == this.value.length || this.value.length == 0)) {
                        defaults.arrowKey = true;
                        $(this).trigger('autotab-next', defaults);
                    }
                }
            }
        }).on('keypress.autotab', function (e) {
            var defaults = getSettings(this),
                keyCode = e.which || e.keyCode;

            // e.charCode == 0 indicates a special key has been pressed, which only Firefox triggers
            if (!defaults || defaults.disabled || settings.firefox && e.charCode === 0 || e.ctrlKey || e.altKey || keyCode == 13 || this.disabled) {
                return true;
            }

            var keyChar = String.fromCharCode(keyCode);

            if (this.type != 'text' && this.type != 'password' && this.type != 'textarea') {
                // this.value.length is the length before the keypress event was trigged
                if (this.value.length + 1 >= defaults.maxlength) {
                    defaults.arrowKey = false;
                    $(this).trigger('autotab-next', defaults);
                }

                return !(this.value.length == defaults.maxlength);
            }

            // Prevents auto tabbing when defaults.trigger is pressed
            if (defaults.trigger !== null && defaults.trigger.indexOf(keyChar) >= 0) {
                if (settings.focusChange !== null && new Date().getTime() - settings.focusChange.getTime() < settings.tabPause) {
                    settings.focusChange = null;
                } else {
                    defaults.arrowKey = false;
                    $(this).trigger('autotab-next', defaults);
                }

                return false;
            }

            settings.focusChange = null;

            var hasValue = document.selection && document.selection.createRange ? true : keyCode > 0;

            keyChar = filterValue(this, keyChar, defaults);

            if (hasValue && (keyChar === null || keyChar === '')) {
                return false;
            }

            // Many, many thanks to Tim Down for this solution: http://stackoverflow.com/a/3923320/94656
            if (hasValue && this.value.length <= this.maxLength) {
                var selection = getSelection(this);

                // Text is fully selected, so it needs to be replaced
                if (selection.start === 0 && selection.end == this.value.length) {
                    this.value = keyChar;
                    setSettings(this, { changed: this.value != defaults.originalValue });
                } else {
                    if (this.value.length == this.maxLength && selection.start === selection.end) {
                        defaults.arrowKey = false;
                        $(this).trigger('autotab-next', defaults);
                        return false;
                    }

                    this.value = this.value.slice(0, selection.start) + keyChar + this.value.slice(selection.end);
                    setSettings(this, { changed: this.value != defaults.originalValue });
                }

                // Prevents the cursor position from being set to the end of the text box
                // This is called even if the text is fully selected and replaced due to an unexpected behavior in IE6 and up (#32)
                if (this.value.length != defaults.maxlength) {
                    selection.start++;

                    if (selection.selectionType == 1) {
                        this.selectionStart = this.selectionEnd = selection.start;
                    } else if (selection.selectionType == 2) {
                        var range = this.createTextRange();
                        range.collapse(true);
                        range.moveEnd('character', selection.start);
                        range.moveStart('character', selection.start);
                        range.select();
                    }
                }
            }

            if (this.value.length == defaults.maxlength) {
                defaults.arrowKey = false;
                $(this).trigger('autotab-next', defaults);
            }

            return false;
        }).on('drop paste', function (e) {
            var defaults = getSettings(this);

            if (!defaults) {
                return true;
            }

            this.maxLength = 2147483647;

            (function (e, originDefaults) {
                setTimeout(function () {
                    var lastIndex = -1,
                        hiddenInput = document.createElement('input');
                    hiddenInput.type = 'hidden';
                    hiddenInput.value = e.value.toLowerCase();
                    hiddenInput.originalValue = e.value;

                    e.value = filterValue(e, e.value, originDefaults).substr(0, originDefaults.maxlength);

                    var handlePaste = function handlePaste(e, previousValue) {
                        if (!e) {
                            return;
                        }

                        var defaults = getSettings(e);

                        if ($(e).prop('disabled') || $(e).prop('readonly') || !defaults.editable) {
                            $(e).trigger('autotab-next');

                            if (!settings.iOS) {
                                handlePaste(defaults.target[0], previousValue);
                            }
                            return;
                        }

                        for (var i = 0, count = previousValue.length; i < count; i++) {
                            lastIndex = hiddenInput.value.indexOf(previousValue.charAt(i).toLowerCase(), lastIndex) + 1;
                        }

                        var trimmedValue = hiddenInput.originalValue.substr(lastIndex),
                            filteredValue = filterValue(e, trimmedValue, defaults).substr(0, defaults.maxlength);

                        if (!filteredValue) {
                            return;
                        }

                        e.value = filteredValue;

                        if (filteredValue.length == defaults.maxlength) {
                            defaults.arrowKey = false;
                            $(e).trigger('autotab-next', defaults);

                            // Firefox causes all but the first and last elements to retain a select all state, so in order to
                            // effectively support arrow keys, the starting point of the selection is to the last possible cursor
                            if (settings.firefox) {
                                setTimeout(function () {
                                    e.selectionStart = e.value.length;
                                }, 1);
                            }

                            if (!settings.iOS) {
                                handlePaste(defaults.target[0], filteredValue);
                            }
                        }
                    };

                    if (e.value.length == originDefaults.maxlength) {
                        defaults.arrowKey = false;
                        $(e).trigger('autotab-next', defaults);

                        if (!settings.iOS) {
                            handlePaste(originDefaults.target[0], e.value.toLowerCase());
                        }
                    }

                    e.maxLength = originDefaults.maxlength;
                }, 1);
            })(this, defaults);
        });
    };

    // Deprecated, here for backwards compatibility
    $.fn.autotab_magic = function (focus) {
        return $(this).autotab();
    };
    $.fn.autotab_filter = function (options) {
        var defaults = {};

        if (typeof options === 'string' || typeof options === 'function') {
            defaults.format = options;
        } else {
            $.extend(defaults, options);
        }

        return $(this).autotab('filter', defaults);
    };
})(jQuery);

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*  jQuery Nice Select - v1.1.0
    https://github.com/hernansartorio/jquery-nice-select
    Made by Hernán Sartorio  */

(function ($) {

  $.fn.niceSelect = function (method) {

    // Methods
    if (typeof method == 'string') {
      if (method == 'update') {
        this.each(function () {
          var $select = $(this);
          var $dropdown = $(this).next('.nice-select');
          var open = $dropdown.hasClass('open');

          if ($dropdown.length) {
            $dropdown.remove();
            create_nice_select($select);

            if (open) {
              $select.next().trigger('click');
            }
          }
        });
      } else if (method == 'destroy') {
        this.each(function () {
          var $select = $(this);
          var $dropdown = $(this).next('.nice-select');

          if ($dropdown.length) {
            $dropdown.remove();
            $select.css('display', '');
          }
        });
        if ($('.nice-select').length == 0) {
          $(document).off('.nice_select');
        }
      } else {
        console.log('Method "' + method + '" does not exist.');
      }
      return this;
    }

    // Hide native select
    this.hide();

    // Create custom markup
    this.each(function () {
      var $select = $(this);

      if (!$select.next().hasClass('nice-select')) {
        create_nice_select($select);
      }
    });

    function create_nice_select($select) {
      $select.after($('<div></div>').addClass('nice-select').addClass($select.attr('class') || '').addClass($select.attr('disabled') ? 'disabled' : '').attr('tabindex', $select.attr('disabled') ? null : '0').html('<span class="current"></span><ul class="list"></ul>'));

      var $dropdown = $select.next();
      var $options = $select.find('option');
      var $selected = $select.find('option:selected');

      $dropdown.find('.current').html($selected.data('display') || $selected.text());

      $options.each(function (i) {
        var $option = $(this);
        var display = $option.data('display');

        $dropdown.find('ul').append($('<li></li>').attr('data-value', $option.val()).attr('data-display', display || null).addClass('option' + ($option.is(':selected') ? ' selected' : '') + ($option.is(':disabled') ? ' disabled' : '')).html($option.text()));
      });
    }

    /* Event listeners */

    // Unbind existing events in case that the plugin has been initialized before
    $(document).off('.nice_select');

    // Open/close
    $(document).on('click.nice_select', '.nice-select', function (event) {
      var $dropdown = $(this);

      $('.nice-select').not($dropdown).removeClass('open');
      $dropdown.toggleClass('open');

      if ($dropdown.hasClass('open')) {
        $dropdown.find('.option');
        $dropdown.find('.focus').removeClass('focus');
        $dropdown.find('.selected').addClass('focus');
      } else {
        $dropdown.focus();
      }
    });

    // Close when clicking outside
    $(document).on('click.nice_select', function (event) {
      if ($(event.target).closest('.nice-select').length === 0) {
        $('.nice-select').removeClass('open').find('.option');
      }
    });

    // Option click
    $(document).on('click.nice_select', '.nice-select .option:not(.disabled)', function (event) {
      var $option = $(this);
      var $dropdown = $option.closest('.nice-select');
      var oldSelectedValue = $dropdown.find('.selected').data('value');
      $dropdown.find('.selected').removeClass('selected');
      $option.addClass('selected');

      var text = $option.data('display') || $option.text();
      $dropdown.find('.current').text(text);

      $dropdown.prev('select').find('option[value="' + oldSelectedValue + '"]').attr('selected', false);
      $dropdown.prev('select').find('option[value="' + $option.data('value') + '"]').attr('selected', 'true');
      $dropdown.prev('select').val($option.data('value')).change();
    });

    // Keyboard events
    $(document).on('keydown.nice_select', '.nice-select', function (event) {
      var $dropdown = $(this);
      var $focused_option = $($dropdown.find('.focus') || $dropdown.find('.list .option.selected'));

      // Space or Enter
      if (event.keyCode == 32 || event.keyCode == 13) {
        if ($dropdown.hasClass('open')) {
          $focused_option.trigger('click');
        } else {
          $dropdown.trigger('click');
        }
        return false;
        // Down
      } else if (event.keyCode == 40) {
        if (!$dropdown.hasClass('open')) {
          $dropdown.trigger('click');
        } else {
          var $next = $focused_option.nextAll('.option:not(.disabled)').first();
          if ($next.length > 0) {
            $dropdown.find('.focus').removeClass('focus');
            $next.addClass('focus');
          }
        }
        return false;
        // Up
      } else if (event.keyCode == 38) {
        if (!$dropdown.hasClass('open')) {
          $dropdown.trigger('click');
        } else {
          var $prev = $focused_option.prevAll('.option:not(.disabled)').first();
          if ($prev.length > 0) {
            $dropdown.find('.focus').removeClass('focus');
            $prev.addClass('focus');
          }
        }
        return false;
        // Esc
      } else if (event.keyCode == 27) {
        if ($dropdown.hasClass('open')) {
          $dropdown.trigger('click');
        }
        // Tab
      } else if (event.keyCode == 9) {
        if ($dropdown.hasClass('open')) {
          return false;
        }
      }
    });

    // Detect CSS pointer-events support, for IE <= 10. From Modernizr.
    var style = document.createElement('a').style;
    style.cssText = 'pointer-events:auto';
    if (style.pointerEvents !== 'auto') {
      $('html').addClass('no-csspointerevents');
    }

    return this;
  };
})(jQuery);

/***/ }),

/***/ 184:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 185:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 186:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    if (!LN.Config) throw new Error("LN.Config missing");
})();

(function (Config, Constantes) {
    'use strict';

    Config.defaultModo = 'D';
    Config.urlViews = window.location.origin + '/views/login/';

    Config.defaultUrl = window.location.origin + '/ingresar/' + Config.defaultModo + '/' + Config.defaultSitioId + '/';

    Config.ingresarPrefix = /ingresar/;
    Config.cambiarClavePrefix = /clave/;

    Config.HotjarHeatmapLogin = Constantes.HotjarHeatmapLogin;

    Config.smartLockEnabled = Constantes.smartLockEnabled;
    Config.smartlockPasswordEnable = Constantes.smartlockPasswordEnable;
    // ==================================================
    // Modos permitidos
    // modo (char) = (D) - default / (S) - signwall / (B) - black / (P) - paywall / (C) - cambiar PASSWORD / (V) - VALIDAR CREDENCIAL / (A) - Asignar credencial / (CLA) - Club LN vincular credencial
    // ==================================================      
    Config.Modos = ['D', 'S', 'B', 'P', 'C', 'AT', 'V', 'A', 'GLA', 'CLA'];

    // ==================================================
    // Constantes de backgrounds
    // ==================================================  
    Config.Background = {
        'D': {
            'file': 'default',
            'class': 'info-signwall'
        },
        'C': {
            'file': 'default',
            'class': 'info-signwall'
        },
        'S': {
            'file': 'signwall',
            'class': 'info-signwall'
        },
        'B': {
            'file': 'black',
            'class': 'fondo-black'
        },
        'V': {
            'file': 'black',
            'class': 'fondo-black'
        },
        'P': {
            'file': 'paywall',
            'class': 'info-signwall'
        },
        'A': {
            'file': 'default',
            'class': 'info-signwall'
        },
        'GLA': {
            'file': 'default',
            'class': 'info-signwall'
        },
        'CLA': {
            'file': 'default',
            'class': 'info-signwall'
        }
    };

    Config.Header = {
        'D': {
            'file': 'default',
            'class': 'info-signwall'
        },
        'C': {
            'file': 'default',
            'class': 'info-signwall'
        },
        'S': {
            'file': 'signwall',
            'class': 'info-signwall'
        },
        'B': {
            'file': 'black',
            'class': 'fondo-black'
        },
        'V': {
            'file': 'black',
            'class': 'fondo-black'
        },
        'P': {
            'file': 'paywall',
            'class': 'info-signwall'
        },
        'A': {
            'file': 'default',
            'class': 'info-signwall'
        },
        'GLA': {
            'file': 'default',
            'class': 'info-signwall'
        },
        'CLA': {
            'file': 'default',
            'class': 'info-signwall'
        }
    };

    Config.Titles = {
        'D': {
            'file': 'default'
        },
        'C': {
            'file': 'default',
            'class': 'info-signwall'
        },
        'S': {
            'file': 'signwall'
        },
        'B': {
            'file': 'black'
        },
        'V': {
            'file': 'black'
        },
        'P': {
            'file': 'default'
        },
        'A': {
            'file': 'default'
        },
        'GLA': {
            'file': 'default'
        },
        'CLA': {
            'file': 'default'
        }
    };

    // ==================================================
    // Constantes de steps o pasos
    // ==================================================  
    Config.Step = {
        COOKIES_DESHABILITADAS: {
            file: 'cookies_deshabilitadas',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: []
        },
        INICIO: {
            file: 'inicio',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: []
        },
        ACCEDER_NATIVO_INGRESAR_PASSWORD: {
            file: 'acceder_nativo_ingresar_password',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['inicio', 'acceder_nativo_ingresar_password']
        },
        CREAR_CUENTA_NATIVO: {
            file: 'crear_cuenta_nativo',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['crear_cuenta_gracias']
        },
        CREAR_CUENTA_DIRECTO: {
            file: 'crear_cuenta_directo_unica',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['inicio', 'crear_cuenta_datos', 'crear_cuenta_directo_unica', 'acceder_red_social', 'facilitar_acceso_google']
        },
        CREAR_CUENTA_DATOS: {
            file: 'crear_cuenta_datos',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['crear_cuenta_gracias']
        },
        CREAR_CUENTA_PASSWORD: {
            file: 'crear_cuenta_password',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['crear_cuenta_gracias']
        },
        CREAR_CUENTA_VALIDAR_CODIGO: {
            file: 'crear_cuenta_validar_codigo',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['crear_cuenta_directo_unica', 'crear_cuenta_password', 'acceder_nativo_ingresar_password', 'crear_cuenta_red_social', 'crear_cuenta_validar_codigo', 'inicio']
        },
        CREAR_CUENTA_GRACIAS: {
            file: 'crear_cuenta_gracias',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['crear_cuenta_validar_codigo']
        },
        CREAR_CUENTA_RED_SOCIAL: {
            file: 'crear_cuenta_red_social',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['inicio', 'acceder_nativo_caso_1']
        },
        VINCULAR_TARJETA: {
            file: 'vincular_tarjeta',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: []
        },
        ACCEDER_NATIVO_CASO_1: {
            file: 'acceder_nativo_caso_1',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['acceder_nativo_ingresar_password']
        },
        ACCEDER_NATIVO_CASO_2: {
            file: 'acceder_nativo_caso_2',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['acceder_nativo_ingresar_password']
        },
        ACCEDER_RED_SOCIAL: {
            file: 'acceder_red_social',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['inicio']
        },
        REESTABLECER_PASSWORD: {
            file: 'reestablecer_password',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['inicio', 'acceder_nativo_ingresar_password', 'crear_cuenta_gracias']
        },
        REESTABLECER_PASSWORD_CODIGO: {
            file: 'reestablecer_password_codigo',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: []
        },
        REESTABLECER_PASSWORD_CODIGO_GRACIAS: {
            file: 'reestablecer_password_codigo_gracias',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: []
        },
        REESTABLECER_PASSWORD_EXPIRADO: {
            file: 'reestablecer_password_expirado',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['acceder_nativo_caso_1']
        },
        MOSTRAR_ERROR: {
            file: 'mostrar_error',
            title: 'Error',
            flow: []
        },
        ASOCIAR_TARJETA_NO_BLACK: {
            file: 'asociar_tarjeta_no_black',
            title: 'Tarjeta no válida',
            flow: []
        },
        ASOCIAR_TARJETA: {
            file: 'asociar_tarjeta',
            title: 'Asociar Tarjeta',
            flow: []
        },
        REESTABLECER_PASSWORD_ENVIO: {
            file: 'reestablecer_password_envio',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['reestablecer_password']
        },
        FACILITAR_ACCESO_GOOGLE: {
            file: 'facilitar_acceso_google',
            title: 'Ingresá o registrate gratis a LA NACION y aprovechá los beneficios de estar registrado.',
            flow: ['inicio', 'crear_cuenta_directo_unica']
        }
    };
})(LN.Config, window.config.Constantes);

/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  if (!LN.Core || !LN.Model) throw new Error("LN.Core || LN.Model missing");
})();

(function (Model, Config, Helper) {
  'use strict';

  Model.Usuario = {
    UsuarioId: "",
    AccessToken: "",
    OrigenLoginTipoId: "",
    TipoAsociarCredencial: "",
    xToken: "",
    xValue: "",
    xKey: "", // Este par�metro solo va para requests de token temporal 
    Retorno: "",
    UsuarioUsuario: "",
    Avatar: 0,
    Email: "",
    EmailCodificado: "",
    UsuarioDetalleNombre: "",
    UsuarioDetalleApellido: "",
    Clave: "",
    Credencial: "",
    Credenciales: [],
    tipoDocumento: "",
    dni: "",
    tipoParticipacion: "",
    UserAgent: "",
    Recaptcha: "",
    Codigo: "",
    SitioId: 1,
    EstadoId: "",
    Ip: "",
    Guid: "",
    UsuarioFacebookId: "",
    FbName: "",
    FbFirstName: "",
    FbLastName: "",
    FbGender: "",
    FbLocale: "",
    FbAgeRange: "",
    FbEmail: "",
    FbBirthday: "",
    FbHometown: "",
    FbLocation: "",
    UsuarioGmailId: "",
    GName: "",
    GFamilyName: "",
    GGivenName: "",
    GBirthday: "",
    GGender: "",
    GCurrentLocation: "",
    GMail: "",
    IsNewUser: false,
    NeedRecaptchaValidation: false,
    HayCookie: 0,
    Experiments: []
  };

  Model.Window = {
    width: "",
    height: "",
    body: "",
    html: "",
    origenId: "",
    sitioId: "",
    modo: "",
    pagina: "",
    referer: "",
    userAgent: "",
    origenLoginTipoId: "",
    currentStep: "",
    canSubmit: true,
    ip: "",
    keyPress: 0,
    firstStart: true,
    location: window.location.href,
    origin: window.location.origin,
    islockedGmail: false,
    islockedFacebook: false
  };

  Model.Embed = {
    Mobile: false,
    Article: false
  };

  Model.CheckForUpdateArticleContext = function () {
    if (Helper.getURLParameter1('article') != null) {
      Model.Embed.Article = true;
    }
  };

  // ==================================================
  // Inicializacion de las variables de entorno
  // ==================================================       

  Model.updateAccesoWindowModel = function () {
    Model.Window.modo = Helper.getURLParameter('param1') !== null && Helper.modoPermitido(Helper.getURLParameter('param1')) ? Helper.getURLParameter('param1') : Config.defaultModo;
    Model.Window.SitioId = Helper.getURLParameter('param2') !== null && Helper.sitioPermitido(parseInt(Helper.getURLParameter('param2'))) ? parseInt(Helper.getURLParameter('param2')) : Config.defaultSitioId;
    Model.Embed.Mobile = Helper.readCookie("platform") !== '' && Helper.readCookie("platform") != null ? Helper.readCookie("platform") : false;
    Model.CheckForUpdateArticleContext();

    /*
        Todo esto es para el modo = GLA de Google para obtener el callback sin estar hasheado
    
        Todo este parche sigue en Controller.finalizarAcceder, ahí modifico Model.Window.pagina para que la url concuerde con :
            [Redirect_Uri]#access_token=[ACCESS_TOKEN]&token_type=bearer&state=[STATE_STRING]
          Después de eso sigue el camino original del login. Practicamente todo esto es para modificar la url de redireccionamiento y mandarla a donde necesita google.
          Si cuando estás queriendo acceder a la URL con modo GLA, te aparece un error de Client ID o Redirect URI, está pasando adentro de este método : Controller.inicioView, fijate.
        
          (será un parche feo, pero es un parche feo documentado)            
     */

    if (Model.Window.modo === "GLA") {
      var url = new URL(LN.Model.Window.location);
      var googleParams = {
        response_type: Helper.findGetParameter(url, 'response_type'),
        client_id: Helper.findGetParameter(url, 'client_id'),
        redirect_uri: Helper.findGetParameter(url, 'redirect_uri'),
        scope: Helper.findGetParameter(url, 'scope'),
        state: Helper.findGetParameter(url, 'state')

        ///* Validación de client_id */
        //if (Config.gmId != googleParams.client_id) googleParams.errorGLA = "ERROR GOOGLE CLIENT ID"; /*alert("ERROR GOOGLE CLIENT ID");*/

        ///* Validación de redirect_url  */
        //const splitedRedirectUrl = googleParams.redirect_uri.split("/r/");
        //if (Config.gmRedirect != splitedRedirectUrl[0]) googleParams.errorGLA = "ERROR GOOGLE REDIRECT URL";   /*alert("ERROR GOOGLE REDIRECT URL");*/

      };Model.Window.googleParams = googleParams;
    } else {
      // Pagina
      var base64Matcher = new RegExp("^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})$");
      if (Helper.getURLParameter1('callback') != null) {
        if (base64Matcher.test(LN.Helper.getURLParameter1('callback'))) {
          Model.Window.pagina = Config.dominiosPermitidos.test(window.atob(Helper.getURLParameter1('callback'))) ? window.atob(Helper.getURLParameter1('callback')) : Config.defaultRedirectUrl;
        } else {
          Model.Window.pagina = Config.defaultRedirectUrl;
        }
      } else {
        if (base64Matcher.test(LN.Helper.getURLQueryString())) {
          Model.Window.pagina = Config.dominiosPermitidos.test(window.atob(Helper.getURLQueryString())) ? window.atob(Helper.getURLQueryString()) : Config.defaultRedirectUrl;
        } else {
          Model.Window.pagina = Config.defaultRedirectUrl;
        }
      }
    }

    //Model.Window.pagina = ((Config.dominiosPermitidos.test(window.atob(Helper.getURLQueryString()))) ? window.atob(Helper.getURLQueryString()) : ((Helper.getURLParameter('param3') !== null && Config.dominiosPermitidos.test(window.atob(Helper.getURLParameter('param3')))) ? window.atob(Helper.getURLParameter('param3')) : Config.defaultRedirectUrl)) ;        
    Model.Usuario.SitioId = Model.Window.SitioId;
  };

  Model.updateCambioClaveWindowModel = function () {
    Model.Window.modo = Helper.getURLParameter('param1') !== null && Helper.modoPermitido(Helper.getURLParameter('param1')) ? Helper.getURLParameter('param1') : Config.defaultModo;
    //Model.Window.pagina = ((Config.dominiosPermitidos.test(window.atob(Helper.getURLQueryString()))) ? window.atob(Helper.getURLQueryString()) : Config.defaultRedirectUrl);
    if (Helper.getURLParameter1('callback') != null) {
      Model.Window.pagina = Config.dominiosPermitidos.test(window.atob(Helper.getURLParameter1('callback'))) ? window.atob(Helper.getURLParameter1('callback')) : Config.defaultRedirectUrl;
    } else {
      Model.Window.pagina = Config.defaultRedirectUrl;
    }
  };

  Model.updateCambioClaveUsuarioModel = function () {
    Model.Usuario.Guid = Helper.getURLParameter('param2') !== null ? Helper.getURLParameter('param2') : null;
    Model.Usuario.UsuarioId = Helper.getURLParameter('param3') !== null ? Helper.getURLParameter('param3') : null;
  };

  Model.setXKey = function () {
    Model.Usuario.xKey = Helper.guid();
  };

  Model.unsetXKey = function () {
    Model.Usuario.xKey = '';
  };
})(LN.Model, LN.Config, LN.Helper);

/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    if (!LN.Core) throw new Error("LN.Core missing");
})();
(function (App, Service, Handler, Controller, Config, Model, Helper, Analytics, gapi, FB, smartlock, CustomDimension, $) {
    'use strict';

    // ==================================================
    // Llamada ajax generica
    // Params : {url} {data} {success} {error}
    // ==================================================

    Service.ajaxPost = function (url, data, done, _error, options) {
        var sentHeader = !Helper.isEmpty(options) && 'sentHeader' in options ? true : false;
        var showPreloader = !Helper.isEmpty(options) && 'showPreloader' in options ? true : false;
        var hidePreloader = !Helper.isEmpty(options) && 'hidePreloader' in options ? true : false;
        var api = !Helper.isEmpty(options) && 'paywallApi' in options ? Config.apiPaywallUrl : Config.apiLoginUrl;
        var headers = {
            'X-Token': Model.Usuario.xToken || '',
            'X-Value': Model.Usuario.xValue || '',
            'X-Key': Model.Usuario.xKey || ''
        };
        showPreloader && Helper.showPreloader();
        $.ajax({
            url: api + url,
            type: 'POST',
            crossDomain: true,
            data: data || null,
            headers: sentHeader == true ? headers : null,
            success: function success(response, status, xhr) {
                //success && success(response,status,xhr);
            },
            error: function error(response) {
                _error && _error(response);
            },
            complete: function complete(response, status, xhr) {
                if (Config.env === "develop") console.log("Load", url);
            }
        }).done(function (res, status, xhr) {
            try {
                Helper.setCanSubmit(true);
                var r = res;
                if (typeof res == 'string') r = JSON.parse(res);
                done && done(r, status, xhr);
            } catch (e) {
                console.log(e);

                Handler.OnFaildefaultErrorMessage();
            }
        }).fail(function (jqXHR, textStatus, errorThrown) {
            try {
                Handler.failHandler(jqXHR.status);
            } catch (e) {
                console.log(e);

                Handler.OnFaildefaultErrorMessage();
            }
        });
    };
    // ==================================================
    // Inicializacion de la API de Gmail
    // ==================================================   
    Service.startGmailApi = function () {

        gapi && gapi.load('client:auth2', function () {
            var auth2 = gapi.auth2.init({
                client_id: Config.gmId
            });
        });
    };

    Service.onGmailLogin = function (cb) {
        gapi && gapi.auth2.getAuthInstance().isSignedIn.listen(cb);
    };

    // ==================================================
    // Inicializacion de la API de Facebook
    // ==================================================   
    Service.startFacebookApi = function () {
        FB && FB.init({
            appId: Config.fbId,
            version: 'v2.11',
            status: true,
            cookie: true,
            xfbml: true
        });
    };

    Service.getFbMe = function (cb) {
        window.FB && window.FB.api('/me?fields=name,email,age_range,currency,first_name,last_name,gender,locale,birthday,hometown,location', function (response) {
            cb && cb(response);
            //Controller.accederFacebookProcesar(response);
        });
    };

    Service.startHotjar = function () {
        (function (h, o, t, j, a, r) {
            h.hj = h.hj || function () {
                (h.hj.q = h.hj.q || []).push(arguments);
            };
            h._hjSettings = { hjid: parseInt(Config.hotjarId), hjsv: 6 };
            a = o.getElementsByTagName('head')[0];
            r = o.createElement('script');r.async = 1;
            r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
            a.appendChild(r);
        })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
    };

    Service.createCustomDimension = function () {

        if (!CustomDimension.exist()) {
            CustomDimension.setRegistrado('no');
            CustomDimension.setSuscriptorType('N/A');
            CustomDimension.setUserId('');
            CustomDimension.save();
        }

        var CD = CustomDimension.get();
        var withToken = Helper.isEmpty(Helper.readCookie('token'));
        var usuarioLogeado = withToken ? 'no' : 'yes';
        var payUser = Helper.isEmpty(Helper.readCookie('ProductoPremiumId')) ? 'no' : 'yes';
        var userId = Helper.readCookie('usuario%5Fid');
        var clubLN = Helper.readCookie('usuarioDetalleClubNacion');
        var notasLeidas = Helper.readCookie('countNotas');

        if (!window.dataLayer) {
            window.dataLayer = [{}];
        }

        dataLayer[0].notasLeidas = notasLeidas ? notasLeidas : 0;
        dataLayer[0].usuarioLogeado = usuarioLogeado;
        dataLayer[0].usuarioRegistrado = CD.usuarioRegistrado;
        dataLayer[0].payUser = payUser;
        dataLayer[0].suscriptorType = CD.suscriptorType;
        dataLayer[0].userId = CD.userId;
        dataLayer[0].credentialType = clubLN ? clubLN : 'N/A';
    };

    Service.startGoogleAnalytics = function () {
        (function (i, s, o, g, r, a, m) {
            i['GoogleAnalyticsObject'] = r;i[r] = i[r] || function () {
                (i[r].q = i[r].q || []).push(arguments);
            }, i[r].l = 1 * new Date();a = s.createElement(o), m = s.getElementsByTagName(o)[0];a.async = 1;a.src = g;m.parentNode.insertBefore(a, m);
        })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');
        ga && ga('create', Config.gaId, 'auto');
    };

    Service.initializeGoogleAnalytics = function () {
        if (typeof ga === 'function' && ga.loaded) {
            return;
        }

        (function init() {
            if (typeof ga === 'function') {
                ga('create', Config.gaId, 'auto');
            } else {
                setTimeout(init, 100);
            }
        })();
    };

    Service.startGoogleTagManager = function () {
        (function (w, d, s, l, i) {
            w[l] = w[l] || [];w[l].push({
                'gtm.start': new Date().getTime(), event: 'gtm.js'
            });var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l != 'dataLayer' ? '&amp;l=' + l : '';j.async = true;j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl;f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', Config.gtmId);
    };

    Service.startComscore = function () {
        var _comscore = _comscore || [];
        _comscore.push({ c1: "2", c2: "6906398" });
        (function () {
            var s = document.createElement("script"),
                el = document.getElementsByTagName("script")[0];s.async = true;
            s.src = (document.location.protocol == "https:" ? "https://sb" : "http://b") + ".scorecardresearch.com/beacon.js";
            el.parentNode.insertBefore(s, el);
        })();
    };

    Service.startEstadisticas = function () {
        var rand_no = Math.random();
        var ip = '190.220.56.0'; /* NO SOY FELIZ HACIENDO ESTO -- ALE */
        rand_no = Math.ceil(rand_no * 1000000000);
        $("body").append('<img src="https://estadisticas.lanacion.com.ar/diario/default.gif?pagina=' + Model.Window.location + '&amp;servidor=' + ip + '&amp;nro=' + rand_no + '" width="1" height="1" />');
    };

    Service.mostrarError = function (message, analyticsError, error) {
        Analytics.error(analyticsError || message);
        Helper.callView('MOSTRAR_ERROR', {
            message: message,
            error: error
        });
    };

    Service.mostrarErrorTrackeaForm = function (message, analyticsError, error) {
        Analytics.formError(Helper.getCurrentStep() + '-' + analyticsError);
        Helper.callView('MOSTRAR_ERROR', {
            message: message,
            error: error
        });
    };

    Service.isLogged = function () {
        Model.Usuario.xToken = Helper.readCookie("token");
        var usuario_detalle_guid = Helper.readCookie("usuario%5Fdetalle%5Fguid");
        var cookieLogin = Helper.readCookie("cookieLogin");
        if (Helper.isEmpty(usuario_detalle_guid) || Helper.isEmpty(cookieLogin) || Helper.isEmpty(Model.Usuario.xToken) || Helper.Validators.temporary.test(Model.Usuario.xToken)) return false;
        Service.ajaxPost('/Usuario/Me', false, function (res, status, xhr) {
            if (!Helper.isEmpty(res.code) && res.code === '0000') {

                Helper.returnBack({
                    url: Model.Window.pagina
                });
            }
        }, null, {
            sentHeader: true
        });
    };

    Service.isLoggedONLY = function () {
        Model.Usuario.xToken = Helper.readCookie("token");
        var usuario_detalle_guid = Helper.readCookie("usuario%5Fdetalle%5Fguid");
        var cookieLogin = Helper.readCookie("cookieLogin");
        if (Helper.isEmpty(usuario_detalle_guid) || Helper.isEmpty(cookieLogin) || Helper.isEmpty(Model.Usuario.xToken) || Helper.Validators.temporary.test(Model.Usuario.xToken)) return false;
        return true;
    };

    Service.ifLoggedNextStep = function () {
        if (Service.isLoggedONLY()) {
            var step = $('.next-step').data('step');
            if (step) Handler.stepHandler(step);
        }
    };

    Service.ifLoggedReturnBack = function () {
        setInterval(function () {
            Service.isLogged();
        }, Config.returnBackInterval);
    };

    Service.getFacebookInfo = function () {
        window.FB && window.FB.getLoginStatus(function (response) {
            if (response.status == 'connected') {
                FB.api('/' + response.authResponse.userID, 'GET', {
                    "fields": "first_name,last_name"
                }, function (response) {
                    if (!Helper.isEmpty(response.first_name)) {
                        var mensaje = '&iquest;No sos ' + response.first_name + ' ' + response.last_name + '?';
                        $('.boton-fb a').html(mensaje);
                        $(".boton-fb a").fadeIn("slow");
                    } else {
                        $(".boton-fb a").fadeOut("slow");
                    }
                });
            } else {
                $(".boton-fb a").fadeOut("slow");
            }
        });
    };

    Service.getGmailInfo = function () {
        gapi && gapi.client.load('plus', 'v1', function () {
            var request = gapi.client.plus.people.get({ 'userId': 'me' });
            request.execute(function (profile) {
                if (!Helper.isEmpty(profile.displayName)) {
                    var mensaje = '&iquest;No sos ' + profile.displayName + '?';
                    $(".boton-gm a").html(mensaje);
                    $(".boton-gm a").fadeIn("slow");
                }
            });
        });
    };

    Service.logoutFacebook = function () {
        var url = window.location.href;
        window.FB && window.FB.logout(function (response) {
            $(".boton-fb a").fadeOut("slow");
            window.location.href = url;
        });
    };

    Service.logoutGmail = function () {
        var gaInstance = gapi.auth2.getAuthInstance();

        if (gaInstance.isSignedIn.get()) {
            gaInstance.disconnect().then(function () {
                $(".boton-gm a").fadeOut("slow");
            });
        }
    };

    // ==================================================
    // Setup App
    // ==================================================   
    Service.setup = function () {};

    // =================================================
    // Smart Lock
    // =================================================
    Service.autoLogin = function () {
        if (Config.smartLockEnabled) {
            smartlock && smartlock.get(function (r) {
                var cred = r.credential;
                if (cred) {

                    var logTest = /Contrase�a|Email/;
                    if (logTest.test(cred.id)) {
                        // El nombre de la credencial se un dato incorrecto, logea en elmah
                        logger && logger.error('Smartlock | nombre credencial incorrecta', cred);
                    }

                    switch (r.type) {
                        case 'nativo':
                            Controller.accerNativoAutomatico(cred.id, cred.password);
                            console.log('acceso automatico nativo: ' + cred.name);
                            break;
                        case 'fb':
                            Controller.accederFacebookAutomatico(cred.id);
                            console.log('acceso automatico Facebook: ' + cred.name);
                            break;
                        case 'gm':
                            Controller.accederGmailAutomatico(cred.id);
                            console.log('acceso automatico Google: ' + cred.name);
                            break;
                    }
                }
            }, Config.smartlockPasswordEnable);
        }
    };
    Service.storeFB = function (profile) {
        if (!Config.smartLockEnabled) return;
        if (!profile) return;
        var email = profile.email;
        var name = profile.name;
        var iconUrl = 'https://graph.facebook.com/' + profile.id + '/picture?type=small';
        smartlock && smartlock.saveFacebook(email, name, iconUrl);
    };
    Service.storeGM = function (profile) {
        if (!Config.smartLockEnabled) return;
        if (!profile) return;
        var email = profile.getEmail();
        var name = profile.getName();
        var iconUrl = profile.getImageUrl();
        smartlock && smartlock.saveGmail(email, name, iconUrl);
    };
    Service.storeNativo = function (usuario) {
        if (!Config.smartLockEnabled) return;
        if (!Config.smartlockPasswordEnable) return;
        var email = usuario.Email;
        var password = usuario.Clave;
        var name = usuario.UsuarioDetalleNombre + ' ' + usuario.UsuarioDetalleApellido;
        var iconUrl = Config.urlImages + '/avatar/avatar-' + usuario.Avatar + '.jpg';
        smartlock && smartlock.savePassword(email, password, name, iconUrl);
    };

    Service.smartlockSignOut = function () {
        smartlock && smartlock.signOut();
    };

    Service.displayCookiesDeshabilitadasView = function () {
        Handler.setOrigin();
        Helper.addBackground(function () {
            Helper.addHeader();
            Helper.callView('COOKIES_DESHABILITADAS', null, function () {
                $('#btnReloadPage').click(function () {
                    location.reload();
                });
            });
            Helper.resizeHandler();
        });
    };
})(LN.App, LN.Service, LN.Handler, LN.Controller, LN.Config, LN.Model, LN.Helper, LN.Analytics, window.gapi, window.FB, window.smartlock, LN.CustomDimension, jQuery);

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


window.LN = window.LN || {};
LN.App = {};
LN.Core = {};
LN.Config = {};
LN.Model = {};
LN.Service = {};
LN.Helper = {};
LN.LocalStorage = {};
LN.Controller = {};
LN.Handler = {};
LN.Message = {};
LN.Message.Analytics = {};
LN.Analytics = {};
LN.Hotjar = {};
LN.CustomDimension = {};
// Quitar cuando se defina el logger en Login.
window.logger = null;

if (!Object.values) {
    Object.values = function (object) {
        return Object.keys(object).map(function (key) {
            return object[key];
        });
    };
}

/***/ }),

/***/ 482:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    if (!LN.Core || !LN.Config) throw new Error("LN.Core || LN.Config missing");
})();

(function (Controller, Config, Helper, Service, Handler, Model, Message, $) {
    'use strict';

    Controller.validarTipoAsociacionClub = function () {
        Helper.updateToken();
        Service.ajaxPost('/Usuario/ObtenerDatosClub', false, function (res, status, xhr) {
            Handler.obtenerDatosClubHandler(res, status, xhr);
        }, null, {
            sentHeader: true
        });
    };

    Controller.asociarCredencialView = function (error, tipoError) {
        var modoBlack = Model.Window.modo == "V" || Model.Window.modo == "B" ? true : false;
        Helper.callView('ASOCIAR_TARJETA', {
            modoBlack: modoBlack,
            modoPremium: !modoBlack,
            mode: Model.Window.modo,
            code: Model.Usuario.TipoAsociarCredencial,
            error: error,
            tipoError: tipoError
        }, Controller.asociarCredencialBindings, true);
    };

    Controller.asociarCredencialBindings = function () {
        $(".num-cred").autotab();
        $('select').niceSelect();

        if (Model.Window.modo == "B") $("main").addClass("black-default");

        $(document).on("keypress", "#nro-credencial-1, #nro-credencial-2, #nro-credencial-3", function (e) {
            // Solo permito ingresar numero y enter . 
            var keycode = event.which;
            if (!(event.shiftKey == false && (keycode == 13 || keycode >= 48 && keycode <= 57))) {
                e.preventDefault();
            }
        });

        $(document).on("keyup focusout", "#nro-credencial-1", function () {
            if ($(this).val() === '') Helper.cleanStatus($(this));else if (Helper.Validators.credencialClub1.test($(this).val()) && $(this).val() !== '') Helper.changeStatus($(this), true);else Helper.changeStatus($(this), false);
        });

        $(document).on("keyup focusout", "#nro-credencial-2", function () {
            if ($(this).val() === '') Helper.cleanStatus($(this));else if (Helper.Validators.credencialClub2.test($(this).val()) && $(this).val() !== '') Helper.changeStatus($(this), true);else Helper.changeStatus($(this), false);
        });

        $(document).on("keyup focusout", "#nro-credencial-3", function () {
            if ($(this).val() === '') Helper.cleanStatus($(this));else if (Helper.Validators.credencialClub3.test($(this).val()) && $(this).val() !== '') Helper.changeStatus($(this), true);else Helper.changeStatus($(this), false);
        });

        $(document).on('keypress', '#nro-documento', function (e) {
            var optionSelected = $("#tipo-documento option:selected").data('validator');
            if (this.value.length >= Helper.Validators.Max[optionSelected]) return false;
        });

        $(document).on('change', '#tipo-documento', function (e) {
            var optionSelected = $("#tipo-documento option:selected").val();
            optionSelected == 'PAS' ? $("#nro-documento").attr('type', 'text') : $("#nro-documento").attr('type', 'number');
        });

        // Eventos de popup credencial dos últimos números . 
        // TODO : ver si puede ir en formularios.js
        $("b.burbuja").click(function () {
            $(".burbuja-inner").toggle();
        });
        $(document).on("click", function (e) {
            if ($(e.target).is("b.burbuja, .burbuja-inner") === false) {
                $(".burbuja-inner").hide();
            }
        });

        // Dependiendo el modo y cantidad de credenciales levantadas cargo en inputs valor de credencial . 

        switch (Model.Usuario.TipoAsociarCredencial) {
            case "1":
                if (Model.Usuario.Credenciales.length == 1) {
                    var credencialAsociada = LN.Model.Usuario.Credenciales[0].nroTarjeta.replace(/-/gi, "");
                    $("#nro-credencial-1").prop("readonly", true).val(credencialAsociada.substring(0, 6));
                    Helper.changeStatus($("#nro-credencial-1"), true);
                    $("#nro-credencial-2").attr("type", "text").prop("readonly", true).val("XXXXXXXX");
                    Helper.changeStatus($("#nro-credencial-2"), true);
                    $("#nro-credencial-3").focus().click();
                    $(".nro-credencial").removeClass("completa");
                    $("#asociar_tarjeta").addClass("cargado");
                }
                break;
            case "2":
                $("#nro-documento").focus().click();
                break;
        }
    };

    Controller.buscarCredencial = function (credencial) {
        var crm = null;
        $(Model.Usuario.Credenciales).each(function () {
            if (this.nroTarjeta.replace(/-/gi, "") == credencial) crm = this.CrmId;
        });
        return crm;
    };

    Controller.asociarCrendecialValidaciones = function () {

        var credencial1 = $("#nro-credencial-1");
        var credencial2 = $("#nro-credencial-2");
        var credencial3 = $("#nro-credencial-3");
        var nroDocumento = $("#nro-documento");
        var tipoDocumentoValidacion = $("#tipo-documento option:selected").data('validator');

        var credencial = credencial1.val() + credencial2.val() + credencial3.val();
        var cantInputs = nroDocumento.length > 0 ? 2 : 1;
        var cantInputsOk = 0;

        // Validación nro de credencial 
        var bStatusCred1 = Helper.Validators.credencialClub1.test(credencial1.val());
        var bStatusCred2 = Helper.Validators.credencialClub2.test(credencial2.val());
        var bStatusCred3 = Helper.Validators.credencialClub3.test(credencial3.val());
        Helper.changeStatus(credencial1, bStatusCred1);
        Helper.changeStatus(credencial2, bStatusCred2);
        Helper.changeStatus(credencial3, bStatusCred3);

        var credencialErrorMensaje = $("#credencial-error");
        if (!bStatusCred1 || !bStatusCred2 || !bStatusCred3) credencialErrorMensaje.html(Message.Credencial['INCORRECTA']);else credencialErrorMensaje.html('');

        if (bStatusCred1 && bStatusCred2 && bStatusCred3) {
            if (Model.Usuario.Credenciales.length == 1 && Model.Usuario.TipoAsociarCredencial == "1") {
                // Caso de asociación rápida (solo ingreso los dos últimos dígitos)
                cantInputsOk++;
                Model.Usuario.Credencial = Model.Usuario.Credenciales[0].nroTarjeta.replace(/-/gi, "").substr(0, 14) + credencial3.val();
            } else if (Helper.Validators.credencialClub.test(credencial)) {
                cantInputsOk++;
                Model.Usuario.Credencial = credencial;
            }
        }

        // Validación nro de documento 
        if (nroDocumento.length > 0) {
            if (nroDocumento.val() != "" && Helper.Validators[tipoDocumentoValidacion].test(nroDocumento.val())) {
                cantInputsOk++;
                Helper.changeStatus(nroDocumento, true);
            } else {
                Helper.changeStatus(nroDocumento, false, Message.Credencial['DNI_INCOMPLETO'], Message.Analytics.Credencial['DNI_INCOMPLETO']);
            }
        }
        return cantInputs === cantInputsOk;
    };

    Controller.asociarCredencialCall = function (data) {
        Helper.updateToken();
        Service.ajaxPost('/Usuario/AsociarCredencial', data, function (res, status, xhr) {
            Handler.asociarResponseHandler(res, status, xhr);
        }, null, {
            sentHeader: true,
            showPreloader: true
        });
    };

    // Asociación directa . Tengo que autocompletar nro-crendencial-1 y nro-credencial-2, hacer que el usuario complete nro-credencial-3 (para caso 1 ) 
    // Para caso 3 tengo que completar la credencial completa . 
    // Tengo en memoria crm y nro-credencial . Voy al servicio con usuario-id y crm . 
    Controller.asociarCredencialCorto = function () {
        if (Controller.asociarCrendecialValidaciones()) {
            if (Controller.buscarCredencial(Model.Usuario.Credencial) === null) {
                // Le erró al ingresar la credencial y redirige al ingreso de DNI - Credencial . 
                Model.Usuario.TipoAsociarCredencial = "2";
                Controller.asociarCredencialView();
            } else {
                var data = {
                    crmId: Controller.buscarCredencial(Model.Usuario.Credencial),
                    estado: Model.Usuario.Credenciales.length == 1 ? 1 : 2
                };
                Controller.asociarCredencialCall(data);
            }
        }
    };

    // Asociación largo . Tengo que completar nro-credencial y nro-documento . 
    Controller.asociarCredencialLargo = function () {
        if (Controller.asociarCrendecialValidaciones()) {
            var data = {
                tipo_doc: $("#tipo-documento").val(),
                nro_doc: $("#nro-documento").val(),
                nro_tarjeta: Model.Usuario.Credencial
            };
            Controller.asociarCredencialCall(data);
        }
    };

    Controller.finalizarAsociar = function () {

        Service.ajaxPost('/Usuario/Me', false, function (res, status, xhr) {
            if (!Helper.isEmpty(res.response)) {
                var usuario = JSON.parse(res.response);
                Model.Usuario.ClubNacion = usuario.Usuario.ClubNacion === undefined ? "" : usuario.Usuario.ClubNacion;
                Helper.setupCookies(usuario.Usuario);

                // TODO . 
                if (Model.Window.modo == "B" || Model.Window.modo == "V") {
                    Controller.validarCredencialBlack(); // Tengo que validar si la credencial asociada es Black . 
                } else Helper.returnBack(); // Circuito solo de asociación . Tengo que redirigir a url callback .
            }
        }, null, {
            sentHeader: true
        });
    };
})(LN.Controller, LN.Config, LN.Helper, LN.Service, LN.Handler, LN.Model, LN.Message, jQuery);

/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    if (!LN.Core || !LN.Config) throw new Error("LN.Core || LN.Config missing");
})();

(function (Controller, Helper, Config, Model, Service, Handler, Analytics, FB, LocalStorage, $) {
    'use strict';

    Controller.accederFacebook = function () {

        window.FB && window.FB.Event.subscribe('auth.login', function (response) {
            console.log(response);
            console.log('FB auth.login ');
        });

        window.FB && window.FB.Event.subscribe('auth.statusChange', function (response) {
            if (response.status == 'connected') {
                //if (!Model.Window.islockedFacebook) {
                //Model.Window.islockedFacebook = true;
                console.log('FB auth.statusChange ');
                //if (Controller.checkStorageSession()) {
                //    return; // Otra sesi�n en progreso.
                //}
                Helper.resetAll(function () {
                    console.log('accederFacebookProcesar');
                    Service.getFbMe(Controller.accederFacebookProcesar);
                });
                //}
            }
        });

        window.FB && window.FB.getLoginStatus(function (response) {
            if (response.status == 'connected') {
                console.log('FB auth.getLoginStatus ');
                //if (!Model.Window.islockedFacebook) {
                //Model.Window.islockedFacebook = true;
                //if (Controller.checkStorageSession()) {
                //    return; // Otra sesi�n en progreso.
                //}
                Helper.resetAll(function () {
                    console.log('accederFacebookProcesar');
                    Service.getFbMe(Controller.accederFacebookProcesar);
                });
                //}
            } else {
                console.log('FB NO logueado');
                window.FB.login(function (response) {
                    console.log("fb.login");
                }, {
                    scope: 'email',
                    return_scopes: true
                });
            }
        });

        Analytics.clickSSO('Facebook');
    };

    Controller.accederFacebookProcesar = function (fbObject) {
        Model.Usuario.UsuarioFacebookId = fbObject.id;
        Model.Usuario.UsuarioDetalleNombre = fbObject.first_name;
        Model.Usuario.UsuarioDetalleApellido = fbObject.last_name;
        Model.Usuario.FbEmail = fbObject.email;
        Model.Usuario.FbFirstName = fbObject.first_name;
        Model.Usuario.FbLastName = fbObject.last_name;
        Model.Usuario.FbGender = fbObject.gender;
        Model.Usuario.FbLocale = fbObject.locale;
        Model.Usuario.AccessToken = window.FB.getAuthResponse()['accessToken'];
        Service.ajaxPost('/Usuario/GestionarRedSocial', Model.Usuario, function (data, status, xhr) {
            if (!Helper.isEmpty(data.code)) {
                var token = xhr.getResponseHeader("X-Token") || Helper.getHeader(data.response, [1]);
                var xvalue = xhr.getResponseHeader("X-Value") || Helper.getHeader(data.response, [2]);

                if (data.code == "0000" && (token == null || xvalue == null || !token || !xvalue)) {
                    logger && logger.error('GestionarRedSocial (FB) ACCEDER | sin headers', { token: token, xvalue: xvalue });
                }
                if (data.code == '0000') Service.storeFB(fbObject);
                Handler.loginResponseHandler(data, status, xhr);
            }
        }, false, {
            showPreloader: true
        });
    };

    Controller.accederFacebookAutomatico = function (id) {
        window.FB && FB.getLoginStatus(function (response) {
            if (response.status == 'connected') {
                //if (!Model.Window.islockedFacebook) {
                //Model.Window.islockedFacebook = true;
                //if (Controller.checkStorageSession()) {
                //    return; // Otra sesi�n en progreso.
                //}
                Helper.resetAll(function () {
                    Service.getFbMe(Controller.accederFacebookProcesar);
                });
                //}
            }
        });
    };

    Controller.asociarFacebook = function () {
        window.FB && window.FB.login(function (response) {
            if (response.authResponse) {
                window.FB.api('/me?fields=name,email,age_range,currency,first_name,last_name,gender,locale,birthday,hometown,location', function (response) {
                    Controller.asociarFacebookProcesar(response);
                });
            }
        }, {
            scope: 'email'
        });
    };

    Controller.asociarFacebookProcesar = function (fbObject) {
        Model.Usuario.UsuarioFacebookId = fbObject.id;
        Model.Usuario.AccessToken = window.FB.getAuthResponse()['accessToken'];
        Model.Usuario.xToken = Helper.readCookie('token');
        Model.Usuario.xKey = Math.random();
        Service.ajaxPost('/Usuario/AsociarFacebook', Model.Usuario, function (data, status, xhr) {
            if (!Helper.isEmpty(data.code)) {
                var token = xhr.getResponseHeader("X-Token");
                var xvalue = xhr.getResponseHeader("X-Value");

                if (data.code == "0000" && (token == null || xvalue == null || !token || !xvalue)) {
                    logger && logger.error('GestionarRedSocial (FB) ASOCIAR | sin headers', { token: token, xvalue: xvalue });
                }
                Handler.asociarRedSocialResponseHandler(data, status, xhr);
            }
        }, false, {
            showPreloader: true,
            sentHeader: true
        });
    };
})(LN.Controller, LN.Helper, LN.Config, LN.Model, LN.Service, LN.Handler, LN.Analytics, window.FB, LN.LocalStorage, jQuery);

/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    if (!LN.Core || !LN.Config) throw new Error("LN.Core || LN.Config missing");
})();

(function (Controller, Config, Service, Helper, Model, Handler, Analytics, gapi, LocalStorage, $) {
    'use strict';

    Controller.accederGmail = function () {
        Analytics.clickSSO('Google');
        console.log('Google');

        Service.onGmailLogin(function (isSignedIn) {
            if (isSignedIn && !Model.Window.islockedGmail) {
                Model.Window.islockedGmail = true;
                console.log('LN Login GM onGmailLogin');
                if (Controller.checkStorageSession()) {
                    return; // Otra sesi�n en progreso.
                }
                Helper.resetAll(function () {
                    Controller.accederGmailProcesar();
                });
            }
        });

        if (gapi) {
            console.log('gapi ok');
            if (!gapi.auth2.getAuthInstance().isSignedIn.get()) {
                console.log('LN Login GM No esta autenticado');
                gapi.auth2.getAuthInstance().signIn().then(function () {});
            } else {
                if (Controller.checkStorageSession()) {
                    return; // Otra sesi�n en progreso.
                }
                if (!Model.Window.islockedGmail) {
                    Model.Window.islockedGmail = true;
                    console.log('LN Login GM Esta autenticado en gmail');
                    Helper.resetAll(function () {
                        Controller.accederGmailProcesar();
                    });
                }
            }
        }
    };

    Controller.accederGmailProcesar = function () {
        var response = gapi.auth2.getAuthInstance().currentUser.get();
        var profile = response.getBasicProfile();
        Model.Usuario.UsuarioGmailId = profile.getId();
        Model.Usuario.UsuarioDetalleNombre = profile.getGivenName();
        Model.Usuario.UsuarioDetalleApellido = profile.getFamilyName();
        Model.Usuario.GMail = profile.getEmail();
        Model.Usuario.AccessToken = response.getAuthResponse().id_token;
        Model.Usuario.GGivenName = profile.getGivenName();
        Model.Usuario.GFamilyName = profile.getFamilyName();
        Service.ajaxPost('/Usuario/GestionarRedSocial', Model.Usuario, function (data, status, xhr) {
            if (!Helper.isEmpty(data.code)) {
                var token = xhr.getResponseHeader("X-Token") || Helper.getHeader(data.response, [1]);
                var xvalue = xhr.getResponseHeader("X-Value") || Helper.getHeader(data.response, [2]);

                if (data.code == "0000" && (token == null || xvalue == null || !token || !xvalue)) {
                    logger && logger.error('GestionarRedSocial (GM) ACCEDER | sin headers', { token: token, xvalue: xvalue });
                }
                if (data.code == '0000') Service.storeGM(profile);
                Handler.loginResponseHandler(data, status, xhr);
            }
        }, false, {
            showPreloader: true
        });
    };

    Controller.accederGmailAutomatico = function (id) {
        if (gapi) {
            if (!gapi.auth2.getAuthInstance().isSignedIn.get()) {
                gapi.auth2.getAuthInstance().signIn().then(function (sign) {
                    if (sign.isSignedIn()) {
                        Helper.resetAll(function () {
                            Controller.accederGmailProcesar();
                        });
                    }
                });
            } else {

                if (!Model.Window.islockedGmail) {
                    Model.Window.islockedGmail = true;

                    var response = gapi.auth2.getAuthInstance().currentUser.get();
                    var profile = response.getBasicProfile();

                    if (profile && id == profile.getEmail()) {
                        Helper.resetAll(function () {
                            Controller.accederGmailProcesar();
                        });
                    }
                }
            }
        }
    };

    Controller.asociarGmail = function () {
        console.log('LN Login GM asociarGmail');
        gapi && gapi.auth.authorize({
            client_id: Config.gmId,
            scope: "https://www.googleapis.com/auth/plus.login https://www.googleapis.com/auth/userinfo.email",
            immediate: false
        }, function (gpSignInResponse) {
            var access = gapi.auth.getToken();
            if (gpSignInResponse['g-oauth-window'] !== undefined) {
                gapi.client.load('oauth2', 'v2', function () {
                    gapi.client.oauth2.userinfo.get().execute(function (response) {
                        Controller.asociarGmailProcesar(response);
                    });
                });
            } else {
                // USUARIO YA LOGUEADO PERO SIN ACCION		    	
            }
        });
    };

    Controller.asociarGmailProcesar = function (response) {
        console.log('LN Login GM asociarGmailProcesar');
        gapi && gapi.client.load('plus', 'v1', function () {
            var request = gapi.client.plus.people.get({ 'userId': 'me' });
            request.execute(function (profile) {
                Model.Usuario.UsuarioGmailId = profile.id;
                Model.Usuario.AccessToken = gapi.auth.getToken().access_token;
                Model.Usuario.xToken = Helper.readCookie('token');
                Model.Usuario.xKey = Math.random();
                Service.ajaxPost('/Usuario/AsociarGmail', Model.Usuario, function (data, status, xhr) {
                    if (!Helper.isEmpty(data.code)) {
                        var token = xhr.getResponseHeader("X-Token");
                        var xvalue = xhr.getResponseHeader("X-Value");

                        if (data.code == "0000" && (token == null || xvalue == null || !token || !xvalue)) {
                            logger && logger.error('GestionarRedSocial (GM) ASOCIAR | sin headers', { token: token, xvalue: xvalue });
                        }
                        Handler.asociarRedSocialResponseHandler(data, status, xhr);
                    }
                }, false, {
                    showPreloader: true,
                    sentHeader: true
                });
            });
        });
    };
})(LN.Controller, LN.Config, LN.Service, LN.Helper, LN.Model, LN.Handler, LN.Analytics, window.gapi, LN.LocalStorage, jQuery);

/***/ }),

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  if (!LN.Core || !LN.Config) throw new Error("LN.Core || LN.Config missing");
})();

(function (Controller, Config, Helper, Service, Handler, Model, Message, $, Password, CustomDimension, LocalStorage) {
  'use strict';

  Controller.inicioView = function (error, cb) {
    error !== undefined ? error = error.trim() : error = "";

    /* Antes que nada, si el modo es GLA y hay un error en la URL, muestro la vista de error. */
    if (Model.Window.modo === "GLA" && Model.Window.googleParams.errorGLA) {
      Service.mostrarError(Model.Window.googleParams.errorGLA);
      return;
    }

    Helper.callView('INICIO', {
      Error: error
    }, function () {

      if (Model.Window.modo !== 'CLA') {
        Service.getGmailInfo();
        Service.getFacebookInfo();
      }

      var username = $("#acceder_nativo_username");
      username.on('paste', function () {
        setTimeout(function () {
          return Helper.checkNextButton(username);
        }, 1);
      });
      username.focus();

      Helper.checkNextButton(username);

      switch (Model.Window.modo) {
        case 'D':
          $('.top-content').addClass('default');
          break;
        case 'S':
          break;
        case 'P':
          $('.top-content').addClass('default');
          $('.top-content p').css('display', 'none');
          break;
        case 'CLA':
          $('.next-step').data('step', 'validar_tipo_asociacion_club');
          break;
      }

      if (Helper.checkFirstStart() && Model.Window.modo !== 'CLA') {
        // Solo intenta obtener y logear con la credencial al cargar por primera vez.
        Service.autoLogin();
      }

      if (cb) cb();
    }, true, true);
  };

  Controller.accederNativo = function () {
    var username = $("#acceder_nativo_username");
    if (Helper.Validators.username.test(username.val()) || Helper.Validators.email.test(username.val())) {
      Helper.changeStatus(username, true);
      Model.Usuario.UsuarioUsuario = Helper.Validators.username.test(username.val()) ? username.val() : Helper.Validators.email.test(username.val()) ? username.val() : null;
      Model.Usuario.Email = Helper.Validators.email.test(username.val()) ? username.val() : null;
      Service.ajaxPost('/Usuario/ExisteMailUsuario', Model.Usuario, function (res, status, xhr) {
        Handler.existeMailUsuarioResponseHandler(res, status, xhr);
        //Helper.hidePreloader();
      }, false, {
        showPreloader: true
        //hidePreloader: true,
      });
    } else {
      Helper.changeStatus(username, false, Message.Usuario['USUARIO_INVALIDO'], Message.Analytics.Usuario['USUARIO_INVALIDO']);
    }
  };

  Controller.accederNativoIngresarPasswordView = function () {
    Helper.callView('ACCEDER_NATIVO_INGRESAR_PASSWORD', null, function () {
      $("#acceder_nativo_password").focus().click();
      console.log('init-pass');
      if (Model.Usuario.NeedRecaptchaValidation) {
        Helper.Recaptcha.render('acceder_nativo_ingresar_password_recaptcha');
        $('#captcha-validation').show();
      }
      Helper.checkNextButton($('#acceder_nativo_password'));
      // Helper.checkCapsLock();
    });
  };

  Controller.accederRedSocialView = function () {
    Helper.callView('ACCEDER_RED_SOCIAL', null, function () {
      Service.getGmailInfo();
      Service.getFacebookInfo();
    });
  };

  Controller.accerNativoAutomatico = function (email, password) {
    Model.Usuario.Clave = password;
    Model.Usuario.UsuarioUsuario = email;
    Service.ajaxPost('/Usuario/Login', Model.Usuario, function (res, status, xhr) {
      var token = xhr.getResponseHeader("X-Token") || Helper.getHeader(res.response, [1]);
      var xvalue = xhr.getResponseHeader("X-Value") || Helper.getHeader(res.response, [2]);

      if (res.code == "0000" && (token == null || xvalue == null || !token || !xvalue)) {
        logger && logger.error('Login Nativo (Smartlock) | sin headers', { token: token, xvalue: xvalue });
      }
      Handler.loginResponseHandler(res, status, xhr, true);
    }, false, {
      showPreloader: true
    });
  };

  Controller.accederNativoIngresarPassword = function (message) {
    var password = $("#acceder_nativo_password");

    if (!Model.Usuario.NeedRecaptchaValidation || Helper.Recaptcha.isSubmitted()) {
      Model.Usuario.Clave = password.val();
      Model.Usuario.Recaptcha = Model.Usuario.NeedRecaptchaValidation ? Helper.Recaptcha.getResponse() : '';

      Helper.changeStatus(password, true);
      Helper.cleanCustomMessageError($('#recaptcha-mensaje'));

      Service.ajaxPost('/Usuario/Login', Model.Usuario, function (res, status, xhr) {
        var token = xhr.getResponseHeader("X-Token") || Helper.getHeader(res.response, [1]);
        var xvalue = xhr.getResponseHeader("X-Value") || Helper.getHeader(res.response, [2]);

        if (res.code == "0000" && (token == null || xvalue == null || !token || !xvalue)) {
          logger && logger.error('Login Nativo | sin headers ', { token: token, xvalue: xvalue });
        }

        Handler.loginResponseHandler(res, status, xhr);
      }, false, {
        showPreloader: true
      });
    } else {
      Helper.displayCustomMessageFormError($('#recaptcha-mensaje'), Message.Usuario['CAPTCHA_REQUERIDO'], Message.Analytics.Usuario['CAPTCHA_REQUERIDO']);
    }
  };

  Controller.finalizarAcceder = function () {
    Service.ajaxPost('/Usuario/Me', false, function (res, status, xhr) {
      if (!Helper.isEmpty(res.response)) {
        var usuario = JSON.parse(res.response);
        Model.Usuario.ClubNacion = usuario.Usuario.ClubNacion === undefined ? "" : usuario.Usuario.ClubNacion;
        Model.Usuario.Avatar = usuario.Usuario.Usuario_detalle_foto_perfil;
        Model.Usuario.Email = usuario.Usuario.usuarioemail;
        Model.Usuario.UsuarioDetalleApellido = usuario.Usuario.UsuarioDetalleApellido;
        Model.Usuario.UsuarioDetalleNombre = usuario.Usuario.UsuarioDetalleNombre;

        Helper.setupCookies(usuario.Usuario);

        /* Si es modo GLA, acá tengo que modificar el window.pagina para corregir la url de callback */
        if (Model.Window.modo === "GLA") {
          Model.Window.pagina = Model.Window.googleParams.redirect_uri + "#access_token=" + usuario.Usuario.TokenJWT + "&token_type=bearer&state=" + Model.Window.googleParams.state;
          console.log(Model.Window.pagina);
        }

        CustomDimension.setUserId(usuario.Usuario.UsuarioId);
        CustomDimension.save();

        //Lanzo evento en localstorage
        LocalStorage.setItem('userLogedIn', true);
        localStorage.removeItem('userLogedIn');

        // Busco el producto y lo asigno al CustomDimension
        Service.ajaxPost('/1/SuscripcionV1/ObtenerSuscripcionDigitalAnalytics', {}, function (res, status, xhr) {
          if (res.code && res.code == '0000') {
            CustomDimension.setSuscriptorType(res.response.nombre);
          } else {
            CustomDimension.setSuscriptorType('N/A');
          }
          CustomDimension.setRegistrado('yes');
          CustomDimension.save();

          Service.createCustomDimension();
        }, null, {
          paywallApi: true,
          sentHeader: true
        });

        Handler.finalizarAccederHandler();
      }
    }, null, {
      sentHeader: true
    });
  };

  /* LM */
  // Se ejecuta luego de asociar credencial en caso black, para validad que la credencial que se asoci� corresponde a Black, u a otro tipo . 
  Controller.validarCredencialBlack = function () {
    Helper.updateToken();
    Service.ajaxPost('/Usuario/Me', false, function (res, status, xhr) {
      if (!Helper.isEmpty(res.response)) {
        var usuario = JSON.parse(res.response);
        Model.Usuario.ClubNacion = usuario.Usuario.ClubNacion === undefined ? "" : usuario.Usuario.ClubNacion; // Actualizo tipo de credencial que tiene le usuario asociada . 
        Handler.validarCredencialBlackHandler();
      }
    }, null, {
      sentHeader: true
    });
  };

  Controller.reestablecerPassword = function () {

    // Si viene desde inicio (primera pantalla de login), valido el mail y se envia a reestablecer password precargardo.
    var email = Model.Usuario.Email || "";
    var usuario = Model.Usuario.UsuarioUsuario || "";
    if (email == "" && usuario == "") {
      var username = $("#acceder_nativo_username");
      if (Helper.Validators.username.test(username.val()) || Helper.Validators.email.test(username.val())) {
        Helper.changeStatus(username, true);
        Model.Usuario.UsuarioUsuario = Helper.Validators.username.test(username.val()) ? username.val() : Helper.Validators.email.test(username.val()) ? username.val() : null;
        Model.Usuario.Email = Helper.Validators.email.test(username.val()) ? username.val() : null;
      }
    }

    Helper.callView('REESTABLECER_PASSWORD', null, function () {
      Helper.Recaptcha.render('restablecer_password_recaptcha');
      // Autocompleto campo mail si lo tengo ingresado desde antes . 
      var email = $("#reestablecer_password_email");
      email.val(Model.Usuario.Email).focus();
      // Muestro activo el bot�n "Confirmar" si el mail ingresado es correcto . 
      if (Model.Usuario.Email != null && Model.Usuario.Email != "") {
        Helper.Validators.email.test(Model.Usuario.Email) ? $("button.login").addClass("active") : Helper.changeStatus(email, false, 'Ingresá un e-mail válido', 'Ingresá un e-mail válido');
      }
    });
  };
  /* LM */

  Controller.reestablecerPasswordProcesar = function () {
    var email = $("#reestablecer_password_email");
    Helper.cleanCustomMessageError($('#recaptcha-mensaje'));
    if (Helper.Validators.email.test(email.val()) && Helper.Recaptcha.isSubmitted()) {
      Helper.changeStatus(email, true);
      Model.Usuario.Email = email.val();
      Model.Usuario.Recaptcha = Helper.Recaptcha.getResponse();
      Model.Usuario.Retorno = window.location.href;

      Service.ajaxPost('/Usuario/ExisteMailUsuario', Model.Usuario, function (res) {
        if (res.code != '0000') {
          Helper.changeStatus(email, false, 'Ingresá un e-mail válido', 'Ingresá un e-mail válido');
          Helper.Recaptcha.reset();
        } else {
          Service.ajaxPost('/Usuario/ValidarUsuarioOlvidoClaveMailRecaptcha', Model.Usuario, function (res, status, xhr) {
            Handler.olvidoClaveHandler(res, status, xhr);
            Helper.Recaptcha.reset();
          }, null, {
            showPreloader: true,
            hidePreloader: true
          });
        }
      });
    } else {
      if (Helper.Validators.email.test(email.val())) Helper.changeStatus(email, true);else Helper.changeStatus(email, false, 'Ingresá un e-mail válido', 'Ingresá un e-mail válido');

      if (recaptcha.val() == '') {
        Helper.displayCustomMessageFormError($('#recaptcha-mensaje'), Message.Usuario['CAPTCHA_REQUERIDO'], Message.Analytics.Usuario['CAPTCHA_REQUERIDO']);
      } else Helper.Recaptcha.reset();
    }
  };

  Controller.reestablecerPasswordCodigoLoad = function () {
    Service.ajaxPost('/Usuario/ValidarCambioContrasenia', Model.Usuario, function (res, status, xhr) {
      Handler.olvidoClaveCodigoLoadHandler(res, status, xhr);
    }, null, {
      showPreloader: true,
      hidePreloader: true
    });
  };

  Controller.reestablecerPasswordEnvioView = function (message) {
    Helper.callView('REESTABLECER_PASSWORD_ENVIO', {
      Message: message
    }, function () {}, true);
  };

  Controller.reestablecerPasswordCodigoView = function (message) {
    Helper.callView('REESTABLECER_PASSWORD_CODIGO', {
      Message: message
    }, function () {
      $(".val-nueva-clave").strongpass(); // LM : Agrego en callback el listener para el keyup de clave nueva . 
      Helper.disableNextButton();
    }, true);
  };

  Controller.reestablecerPasswordExpiradoView = function (message) {
    Helper.callView('REESTABLECER_PASSWORD_EXPIRADO', {
      Message: message
    }, function () {
      Helper.Recaptcha.render('restablecer_password_recaptcha');
      $("#reestablecer_password_codigo_password").focus();
      $(".val-nueva-clave").strongpass(); // LM : Agrego en callback el listener para el keyup de clave nueva . 
    }, true);
  };

  Controller.reestablecerPasswordCodigo = function () {
    var password = $("#reestablecer_password_codigo_password");
    var repetirPassword = $("#reestablecer_password_codigo_repetir_password");
    if (Password.canSubmit(true) && Helper.Validators.passwordRegistro.test(password.val()) && Helper.Validators.passwordRegistro.test(repetirPassword.val())) {
      if (password.val() === repetirPassword.val()) {
        Helper.changeStatus(password, Helper.Validators.password.test(password.val()));
        Helper.changeStatus(repetirPassword, Helper.Validators.password.test(repetirPassword.val()));
        Model.Usuario.Clave = password.val();
        Service.ajaxPost('/Usuario/ActualizarClaveUsuario', Model.Usuario, function (res, status, xhr) {
          Handler.olvidoClaveCodigoHandler(res, status, xhr);
        }, null, {
          showPreloader: true
        });
      }
    } else {
      //if (!Helper.Validators.passwordRegistro.test(password.val())) {
      //    Helper.changeStatus(password, Helper.Validators.passwordRegistro.test(password.val()), Message.Usuario['CARACTER_INVALIDO_PASS_REG']);
      //}

      //if (!Helper.Validators.passwordRegistro.test(repetirPassword.val())) {
      //    Helper.changeStatus(repetirPassword, Helper.Validators.passwordRegistro.test(repetirPassword.val()), Message.Usuario['CARACTER_INVALIDO_PASS_REG']);
      //}
    }
  };

  Controller.reestablecerPasswordExpiradoCodigo = function () {
    var password = $("#reestablecer_password_codigo_password");
    var repetirPassword = $("#reestablecer_password_codigo_repetir_password");

    if (Password.canSubmit(true) && Helper.Validators.passwordRegistro.test(password.val()) && Helper.Validators.passwordRegistro.test(repetirPassword.val())) {
      if (password.val() === repetirPassword.val()) {
        Helper.changeStatus(password, Helper.Validators.password.test(password.val()));
        Helper.changeStatus(repetirPassword, Helper.Validators.password.test(repetirPassword.val()));
        var data = {
          ClaveVieja: Model.Usuario.Clave,
          ClaveNueva: password.val(),
          Recaptcha: Helper.Recaptcha.getResponse()
        };
        Model.Usuario.xKey = Math.random(); // Este parámetro solo va para requests de token temporal 
        Service.ajaxPost('/Usuario/ActualizarClave', data, function (res, status, xhr) {
          Handler.olvidoClaveCodigoHandler(res, status, xhr);
          Model.Usuario.xKey = "";
        }, null, {
          showPreloader: true,
          sentHeader: true
        });
      }
    } else {
      if (!Helper.Validators.passwordRegistro.test(password.val())) {
        Helper.changeStatus(password, Helper.Validators.passwordRegistro.test(password.val()), Message.Usuario['CARACTER_INVALIDO_PASS_REG'], Message.Analytics.Usuario['CARACTER_INVALIDO_PASS_REG']);
      }

      if (!Helper.Validators.passwordRegistro.test(repetirPassword.val())) {
        Helper.changeStatus(repetirPassword, Helper.Validators.passwordRegistro.test(repetirPassword.val()), Message.Usuario['CARACTER_INVALIDO_PASS_REG'], Message.Analytics.Usuario['CARACTER_INVALIDO_PASS_REG']);
      }
    }
  };

  Controller.reestablecerPasswordCodigoGraciasView = function () {
    Helper.callView('REESTABLECER_PASSWORD_CODIGO_GRACIAS');
  };

  /* HANDLER CALLBACKS */
  Controller.accederNativoIngresarPasswordErrorCallBack = function (message) {
    $('#acceder_nativo_ingresar_password .mostrar').addClass('error');
    $('#mostrar_error_mensaje').html(message);
  };

  Controller.reestablecerPasswordSuccessCallBack = function () {
    $('.sinCaptcha').show();
    $(".confirmar-hidden").hide(); // LM
  };

  Controller.retornarAcceder = function () {
    !Helper.isEmpty(Model.Window.pagina) ? Helper.redirectUrl(Model.Window.pagina) : Helper.redirectUrl(Config.defaultUrl);
  };

  Controller.logout = function (options) {
    Helper.resetAll(function () {
      Model.Usuario.xToken = Helper.readCookie("token");
      Model.Usuario.xValue = Helper.readCookie("xvalue");
      Service.ajaxPost('/Usuario/Logout', Model.Usuario, function (res, status, xhr) {
        Handler.logoutHandler(res, status, xhr, options);
        Service.smartlockSignOut();
      }, function () {
        Helper.returnBackLogout(options);
      }, {
        sentHeader: true
      });
    });
  };

  Controller.logoutV2 = function (options) {
    var reset = function reset() {
      Helper.resetAll(function () {});
    };
    try {
      Model.Usuario.xToken = Helper.readCookie("token");
      Model.Usuario.xValue = Helper.readCookie("xvalue");
      if (Model.Usuario.xToken != null && Model.Usuario.xValue != null && Model.Usuario.xToken && Model.Usuario.xValue) {
        Service.ajaxPost('/Usuario/Logout', Model.Usuario, function (res, status, xhr) {
          reset();
          Service.smartlockSignOut();
          Handler.logoutHandler(res, status, xhr, options);
        }, function () {
          reset();
          Helper.returnBackLogout(options);
        }, {
          sentHeader: true
        });
      } else {
        reset();
      }
    } catch (ex) {
      reset();
    }
  };

  Controller.facilitarAccesoGoogle = function () {
    Helper.callView('FACILITAR_ACCESO_GOOGLE', null, function () {
      Service.getGmailInfo();
    });
  };
})(LN.Controller, LN.Config, LN.Helper, LN.Service, LN.Handler, LN.Model, LN.Message, jQuery, Password.Validator, LN.CustomDimension, LN.LocalStorage);

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    if (!LN.Core || !LN.Config) throw new Error("LN.Core || LN.Config missing");
})();

(function (Controller, Helper, Config, Model, Service, Handler, Message, $, Password) {

    /* CREAR CUENTA PASO 1 */
    Controller.crearCuentaNativoView = function (error) {
        Helper.callView('CREAR_CUENTA_NATIVO', {
            Error: error
        }, function () {
            if ($("#crear_cuenta_nativo_email").val()) $("button.login").addClass("active");
        }, true);
    };

    Controller.crearCuentaDirectaView = function (error) {
        Helper.callView('CREAR_CUENTA_DIRECTO', {
            Error: error
        }, function () {
            Helper.Recaptcha.render('crear_cuenta_directo_recaptcha', function submit() {}, function expired() {
                //Helper.displayCustomMessageError($('#recaptcha-mensaje'), Message.Usuario['CAPTCHA_EXPIRADO']);
                //Helper.Recaptcha.reset();
            });
            $(".val-nueva-clave").strongpass();
            if ($("#crear_cuenta_directa_email").val()) $("button.login").addClass("active");
        }, true);
    };

    Controller.crearCuentaNativo = function () {
        var email = $("#crear_cuenta_nativo_email");
        Helper.checkNextButton(email);
        if (Helper.Validators.email.test(email.val())) {
            Helper.changeStatus(email, true);
            Model.Usuario.Email = email.val();
            Service.ajaxPost('/Usuario/ExisteMailUsuario', Model.Usuario, function (res, status, xhr) {
                Handler.existeMailUsuarioCrearCuentaResponseHandler(res, status, xhr);
            }, false, {
                showPreloader: true
            });
        } else {
            Helper.changeStatus(email, false, Message.Usuario['EMAIL_INVALIDO'], Message.Analytics.Usuario['EMAIL_INVALIDO']);
        }
    };

    Controller.crearCuentaDirecta = function () {
        var email = $("#crear_cuenta_directa_email");
        var password = $("#crear_cuenta_directo_password");

        Helper.cleanCustomMessageError($('#recaptcha-mensaje'));
        Helper.checkNextButton(email);
        if (Helper.Validators.email.test(email.val())) {
            if (Password.canSubmit(true) && Helper.Recaptcha.isSubmitted() && Helper.Validators.passwordRegistro.test(password.val())) {

                Helper.changeStatus(email, true);
                Model.Usuario.UsuarioUsuario = Helper.Validators.username.test(email.val()) ? email.val() : Helper.Validators.email.test(email.val()) ? email.val() : null;
                Model.Usuario.Email = Helper.Validators.email.test(email.val()) ? email.val() : null;
                Service.ajaxPost('/Usuario/ExisteMailUsuario', Model.Usuario, function (res, status, xhr) {
                    Handler.existeMailUsuarioCrearCuentaDirectaResponseHandler(res, status, xhr);
                }, false, {
                    showPreloader: true
                });
            } else if (!Helper.Recaptcha.isSubmitted()) {
                Helper.displayCustomMessageFormError($('#recaptcha-mensaje'), Message.Usuario['CAPTCHA_REQUERIDO'], Message.Analytics.Usuario['CAPTCHA_REQUERIDO']);
            } else {
                // Viene por password
                //if (password.val().length < 8 || password.val().length > 20) {
                //    LN.Helper.changeStatus(password, LN.Helper.Validators.passwordRegistro.test(password.val()), Message.Usuario['LONGITUD_INVALIDO_PASS_LOG']);
                //} else {
                //    if (!Helper.Validators.passwordRegistro.test(password.val())) {
                //        LN.Helper.changeStatus(password, Helper.Validators.passwordRegistro.test(password.val()), Message.Usuario['CARACTER_INVALIDO_PASS_REG']);
                //    }
                //}

                //if (Helper.Recaptcha.isSubmitted())
                //    Helper.Recaptcha.reset();
            }
        } else {
            Helper.changeStatus(email, false, Message.Usuario['EMAIL_INVALIDO'], Message.Analytics.Usuario['EMAIL_INVALIDO']);
        }
    };

    Controller.crearCuentaDirectaPassword = function () {
        var password = $("#crear_cuenta_directo_password");

        Helper.cleanCustomMessageError($('#recaptcha-mensaje'));
        //if (Password.canSubmit(true) && Helper.Recaptcha.isSubmitted() && Helper.Validators.passwordRegistro.test(password.val())) {
        Model.Usuario.Clave = password.val();
        Model.Usuario.Recaptcha = Helper.Recaptcha.getResponse();

        // Todo OK
        Helper.changeStatus(password, Helper.Validators.passwordRegistro.test(password.val()));
        Service.ajaxPost('/Usuario/AltaUsuario', Model.Usuario, function (res, status, xhr) {
            Handler.altaUsuarioResponseHandler(res, status, xhr);
        }, false, {
            showPreloader: true,
            hidePreloader: true
        });
    };
    /* FIN CREAR CUENTA PASO 1 */

    /* CREAR CUENTA PASO 2 */
    Controller.crearCuentaDatosView = function (nativo) {
        Helper.callView('CREAR_CUENTA_DATOS', {
            isNativo: nativo || nativo == true
        }, Controller.crearCuentaBindings, true);
    };

    Controller.crearCuentaBindings = function () {
        // Solo permitir inputs de letras y keys de navegaci�n
        $(document).on("keydown", "#crear_cuenta_datos_nombre, #crear_cuenta_datos_apellido", function (e) {
            var keycode = event.which;
            if (!(keycode == 13 || keycode == 32 || keycode == 8 || keycode == 9 || keycode == 37 || keycode == 39 || keycode == 46 || keycode >= 65 && keycode <= 90)) {
                e.preventDefault();
            }
        });
    };

    Controller.crearCuentaDatos = function () {
        var nombre = $("#crear_cuenta_datos_nombre");
        var apellido = $("#crear_cuenta_datos_apellido");
        if (Helper.Validators.name.test(nombre.val()) && nombre.val().trim() != "" && Helper.Validators.lastname.test(apellido.val()) && apellido.val().trim() != "") {
            Helper.changeStatus(nombre, true);
            Helper.changeStatus(apellido, true);
            Model.Usuario.UsuarioDetalleNombre = Helper.cleanSpecialCharsInput(nombre.val());
            Model.Usuario.UsuarioDetalleApellido = Helper.cleanSpecialCharsInput(apellido.val());
            Controller.crearCuentaPasswordView();
        } else {
            Helper.changeStatus(nombre, Helper.Validators.name.test(nombre.val()), Message.Usuario['NOMBRE_APELLIDO_INCORRECTO'], Message.Analytics.Usuario['NOMBRE_APELLIDO_INCORRECTO']);
            Helper.changeStatus(apellido, Helper.Validators.lastname.test(apellido.val()), Message.Usuario['NOMBRE_APELLIDO_INCORRECTO'], Message.Analytics.Usuario['NOMBRE_APELLIDO_INCORRECTO']);
            Helper.changeStatus(nombre, Helper.Validators.name.test(nombre.val().trim()), Message.Usuario['NOMBRE_APELLIDO_INCORRECTO'], Message.Analytics.Usuario['NOMBRE_APELLIDO_INCORRECTO']);
            Helper.changeStatus(apellido, Helper.Validators.lastname.test(apellido.val().trim()), Message.Usuario['NOMBRE_APELLIDO_INCORRECTO'], Message.Analytics.Usuario['NOMBRE_APELLIDO_INCORRECTO']);
        }
    };

    /* CREAR CUENTA PASO 2 */

    /* CREAR CUENTA PASO 3 */
    Controller.crearCuentaPasswordView = function () {
        Helper.callView('CREAR_CUENTA_PASSWORD', null, function () {
            Helper.Recaptcha.render('crear_cuenta_password_recaptcha');
            $(".val-nueva-clave").strongpass(); // LM : Agrego en callback el listener para el keyup de clave nueva . 
        });
    };

    Controller.crearCuentaPassword = function () {
        var password = $("#crear_cuenta_password_password");
        var repetirPassword = $("#crear_cuenta_password_repetir_password");

        Helper.cleanCustomMessageError($('#recaptcha-mensaje'));
        if (Password.canSubmit(true) && Helper.Recaptcha.isSubmitted() && Helper.Validators.passwordRegistro.test(password.val()) && Helper.Validators.passwordRegistro.test(repetirPassword.val())) {
            //if (Password.canSubmit()) { LM la proxima te corto los dedos AD
            Model.Usuario.Clave = password.val();
            Model.Usuario.Recaptcha = Helper.Recaptcha.getResponse();
            if (password.val() === repetirPassword.val()) {
                // Todo OK
                Helper.changeStatus(password, Helper.Validators.passwordRegistro.test(password.val()));
                Helper.changeStatus(repetirPassword, Helper.Validators.passwordRegistro.test(repetirPassword.val()));
                Service.ajaxPost('/Usuario/AltaUsuario', Model.Usuario, function (res, status, xhr) {
                    Handler.altaUsuarioResponseHandler(res, status, xhr);
                }, false, {
                    showPreloader: true,
                    hidePreloader: true
                });
            } else {
                // Las passwords no coinciden
                if (Helper.Validators.password.test(password.val())) {
                    Helper.changeStatus(password, false);
                }
            }
        } else {
            if (password.val().length > 20) {
                LN.Helper.changeStatus(password, LN.Helper.Validators.passwordRegistro.test(password.val()), Message.Usuario['LONGITUD_INVALIDO_PASS_LOG']);
            } else {
                if (!Helper.Validators.passwordRegistro.test(password.val())) {
                    LN.Helper.changeStatus(password, Helper.Validators.passwordRegistro.test(password.val()), Message.Usuario['CARACTER_INVALIDO_PASS_REG']);
                } else {
                    if (password.val() != repetirPassword.val()) {
                        LN.Helper.changeStatus(password, false, Message.Usuario['CLAVE_DIFIERE']);
                    }
                    //else {
                    //    Helper.changeStatus(password, false);
                    //}
                }
            }

            if (repetirPassword.val().length < 8 || repetirPassword.val().length > 20) {
                LN.Helper.changeStatus(repetirPassword, LN.Helper.Validators.passwordRegistro.test(repetirPassword.val()), Message.Usuario['LONGITUD_INVALIDO_PASS_LOG']);
            } else {
                if (!Helper.Validators.passwordRegistro.test(repetirPassword.val())) {
                    //LN.Helper.changeStatus(repetirPassword, Helper.Validators.passwordRegistro.test(repetirPassword.val()), Message.Usuario['CARACTER_INVALIDO_PASS_REG']);
                    LN.Helper.changeStatus(repetirPassword, Helper.Validators.passwordRegistro.test(repetirPassword.val()), Message.Usuario['CLAVE_DIFIERE']);
                } else {
                    if (password.val() != repetirPassword.val()) {
                        LN.Helper.changeStatus(repetirPassword, false, Message.Usuario['CLAVE_DIFIERE']);
                    }
                    //else {
                    //    Helper.changeStatus(password, false);
                    //}
                }
            }

            if (!Helper.Recaptcha.isSubmitted()) {
                Helper.displayCustomMessageFormError($('#recaptcha-mensaje'), Message.Usuario['CAPTCHA_REQUERIDO'], Message.Analytics.Usuario['CAPTCHA_REQUERIDO']);
            } else Helper.Recaptcha.reset();
        }
    };

    /* CREAR CUENTA PASO 3 */

    Controller.crearCuentaValidarCodigoView = function (error) {
        Helper.callView('CREAR_CUENTA_VALIDAR_CODIGO', {
            Error: error
        }, function () {
            LN.Wcentrix && LN.Wcentrix.initChat();
            $('#crear_cuenta_validar_codigo_codigo').focus();
            //$("#usuario_email").html(Model.Usuario.Email);	
        }, true);
    };

    Controller.crearCuentaGracias = function () {
        Helper.callView('CREAR_CUENTA_GRACIAS');
    };
    Controller.grabarTokenTemporal = function (res, status, xhr) {
        var token = xhr.getResponseHeader("X-Token");
        Helper.setToken(token);
        Controller.crearCuentaValidarCodigoView();
    };

    Controller.crearCuentaReenviarCodigo = function () {
        Service.ajaxPost('/Usuario/ReenviarCodigo', Model.Usuario, function (res, status, xhr) {
            $('.atencion').hide(); //  Oculto todas las advertencias
            $('#aviso-reenvio').show();
            $('#crear_cuenta_validar_codigo_codigo').val('');
            $('#crear_cuenta_validar_codigo_codigo').focus();
            Helper.hidePreloader();
        }, null, {
            sentHeader: true,
            showPreloader: true,
            hidePreloader: true
        });
    };

    Controller.crearCuentaValidarCodigo = function () {
        var codigo = $("#crear_cuenta_validar_codigo_codigo");
        if (!Helper.Validators.confirmCode.test(codigo.val().trim())) {
            Helper.changeStatus(codigo, Helper.Validators.confirmCode.test(codigo.val()));
            return false;
        }

        Model.Usuario.Codigo = codigo.val();

        var request = {
            'UsuarioDetalleNombre': Model.Usuario.UsuarioDetalleNombre,
            'UsuarioDetalleApellido': Model.Usuario.UsuarioDetalleApellido,
            'Email': Model.Usuario.Email,
            'Clave': Model.Usuario.Clave,
            'Codigo': Model.Usuario.Codigo,
            'AutenticacionTipoId': '1',
            'SitioId': '1'
        };

        Service.ajaxPost('/Usuario/ValidarCodigoMailLogin', request, function (response, status, xhr) {
            Handler.validarCodigoMailLoginResponseHandler(response, status, xhr);
        }, null, {
            sentHeader: true,
            showPreloader: true,
            hidePreloader: true
        });
    };

    Controller.crearCuentaRedSocial = function () {
        Model.setXKey();
        var email = $("#crear_cuenta_red_social_email");
        if (Helper.Validators.email.test(email.val())) {
            Helper.changeStatus(email, true);
            Model.Usuario.Email = email.val();
            Service.ajaxPost('/Usuario/ExisteMailUsuario', Model.Usuario, function (data, status, xhr) {
                if (data.code == '0000') {
                    // El email ya existe
                    Helper.changeStatus(email, false, Message.Usuario['EMAIL_EXISTE'], Message.Analytics.Usuario['EMAIL_EXISTE']);
                } else {
                    // Continuar
                    Service.ajaxPost('/Usuario/GestionarRedSocial', Model.Usuario, function (data, status, xhr) {
                        var token = xhr.getResponseHeader("X-Token");
                        var xvalue = xhr.getResponseHeader("X-Value");

                        if (data.code == "0000" && (token == null || xvalue == null || !token || !xvalue)) {
                            logger && logger.error('GestionarRedSocial (Crear Cuenta) | sin headers ', { token: token, xvalue: xvalue });
                        }
                        Model.unsetXKey();
                        Handler.loginResponseHandler(data, status, xhr);
                    }, null, {
                        sentHeader: true,
                        showPreloader: true,
                        hidePreloader: true
                    });
                }
            }, null, {
                showPreloader: true,
                hidePreloader: true
            });
        } else {
            Helper.changeStatus(email, false, Message.Usuario['EMAIL_INVALIDO'], Message.Analytics.Usuario['EMAIL_INVALIDO']);
        }
    };
})(LN.Controller, LN.Helper, LN.Config, LN.Model, LN.Service, LN.Handler, LN.Message, jQuery, Password.Validator);

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  if (!LN.Core) throw new Error("LN.Core missing");
})();
(function (App, Handler, Service, Controller, Config, Helper, Message, Model, Analytics, Hotjar, LocalStorage, CustomDimension, Constantes, $) {
  'use strict';

  // ==================================================
  // Manejador de eventos step
  // ==================================================  

  Handler.setOrigin = function () {
    if (Config.ingresarPrefix.test(window.location.pathname)) {
      Model.updateAccesoWindowModel();
    } else if (Config.cambiarClavePrefix.test(window.location.pathname)) {
      Model.updateCambioClaveWindowModel();
      Model.updateCambioClaveUsuarioModel();
    }
  };

  Handler.router = function () {
    Handler.setOrigin();
    var modo = Model.Window.modo;
    Helper.setupPrevious();
    switch (modo) {
      case 'C':
        Helper.addBackground(function () {
          Helper.addHeader();
          Controller.reestablecerPasswordCodigoLoad();
          Helper.resizeHandler();
          Helper.placeHolder();
        });
        break;
      case 'V':
        Helper.addBackground(function () {
          Helper.addHeader();
          Controller.validarCredencialBlack();
          Helper.resizeHandler();
          Helper.placeHolder();
        });
        break;
      case 'A':
        Helper.addBackground(function () {
          Helper.addHeader();
          Controller.validarTipoAsociacionClub();
          Helper.resizeHandler();
          Helper.placeHolder();
        });
        break;
      case 'S':
        Helper.addBackground(function () {
          Helper.addHeader();
          Controller.inicioView();
          Helper.resizeHandler();
          Helper.placeHolder();
          /* Funcion automatica que retorna al origen si detecto que esta logueado*/
          Service.ifLoggedReturnBack();
        });
        break;
      case 'P':
        Helper.addBackground(function () {
          Helper.addHeader();
          Controller.inicioView();
          Helper.resizeHandler();
          Helper.placeHolder();
          Hotjar.callTrigger(Config.HotjarHeatmapLogin);
        });
        break;
      case 'CLA':
        Helper.addBackground(function () {
          Helper.addHeader();
          Controller.inicioView("", Service.ifLoggedNextStep);
          Helper.resizeHandler();
          Helper.placeHolder();
        });
        break;
      default:
        Helper.addBackground(function () {
          Helper.addHeader();
          Controller.inicioView();
          Helper.resizeHandler();
          Helper.placeHolder();
        });
    }
  };

  // ==================================================
  // Manejador de eventos step
  // ==================================================  
  Handler.stepHandler = function (step, obj) {
    switch (step) {
      case 'inicio':
        Controller.inicioView();
        break;
      case 'acceder_nativo':
        Controller.accederNativo();
        break;
      case 'acceder_facebook':
        Controller.accederFacebook();
        break;
      case 'acceder_gmail':
        Controller.accederGmail();
        break;
      case 'asociar_gmail':
        Controller.asociarGmail();
        break;
      case 'asociar_facebook':
        Controller.asociarFacebook();
        break;
      case 'porque_redsocial':
        Controller.accederRedSocialView();
        break;
      case 'acceder_nativo_ingresar_password':
        Controller.accederNativoIngresarPassword();
        break;
      case 'crear_cuenta_nativo':
        Analytics.crearCuentaNativoClick();
        Controller.crearCuentaNativo();
        break;
      case 'crear_cuenta_nativo_view':
        //Aca                
        Controller.crearCuentaNativoView(true);
        break;
      case 'crear_cuenta_directo':
        Controller.crearCuentaDirecta();
        break;
      case 'crear_cuenta_directo_view':
        Analytics.crearCuentaNativoLink();
        Controller.crearCuentaDirectaView();
        break;
      case 'crear_cuenta_datos':
        Controller.crearCuentaDatos();
        break;
      case 'crear_cuenta_datos_view':
        Controller.crearCuentaDatosView(Helper.getCurrentStep() == 'crear_cuenta_nativo');
        break;
      case 'crear_cuenta_password':
        Controller.crearCuentaPassword();
        break;
      case 'crear_cuenta_password_view':
        Controller.crearCuentaPasswordView();
        break;
      case 'crear_cuenta_validar_codigo':
        Controller.crearCuentaValidarCodigo();
        break;
      case 'crear_cuenta_reenviar_codigo':
        Controller.crearCuentaReenviarCodigo();
        break;
      case 'crear_cuenta_red_social':
        Controller.crearCuentaRedSocial();
        break;
      case 'reestablecer_password':
        Controller.reestablecerPassword();
        break;
      case 'reestablecer_password_procesar':
        Controller.reestablecerPasswordProcesar();
        break;
      case 'reestablecer_password_codigo':
        Controller.reestablecerPasswordCodigo();
        break;
      case 'reestablecer_password_expirado_codigo':
        Controller.reestablecerPasswordExpiradoCodigo();
        break;
      case 'reestablecer_password_expirado':
        Controller.reestablecerPasswordExpiradoView();
        break;
      case 'logout-facebook':
        Service.logoutFacebook();
        break;
      case 'logout-gmail':
        Service.logoutGmail();
        break;
      case 'volver_a_ingresar':
        App.reload();
        break;
      case 'retornar_acceder':
        Controller.retornarAcceder();
        break;
      case 'volver_a_origen':
        Helper.returnBack();
        break;
      case 'volver':
        Helper.returnBack({
          url: document.referrer || Constantes.Sitios[Model.Usuario.SitioId]
        });
        break;
      case 'asociar_tarjeta_corto':
        Controller.asociarCredencialCorto(); // Asociar corto
        break;
      case 'asociar_tarjeta_largo':
        Controller.asociarCredencialLargo(); // Asociar largo
        break;
      case 'validar_tipo_asociacion_club':
        Controller.validarTipoAsociacionClub();
        break;
      default:
    }
  };

  // ==================================================
  // Manejador de respustas ajax
  // ================================================== 
  Handler.loginResponseHandler = function (obj, status, xhr, isSmartlock) {
    console.log('LoginHandler | ' + obj.code);

    isSmartlock = isSmartlock || false;
    var token = xhr.getResponseHeader("X-Token") || Helper.getHeader(obj.response, [1]);
    var xvalue = xhr.getResponseHeader("X-Value") || Helper.getHeader(obj.response, [2]);

    switch (obj.code) {
      //Caso Todo OK
      case '0000':
        Helper.deleteAllCookies();
        Helper.setToken(token);
        Helper.setXValue(xvalue);
        Controller.finalizarAcceder();

        // Si esta cargada la Password (vino por nativo), ejecuto el store nativo.
        if (Model.Usuario.Clave) Service.storeNativo(Model.Usuario);
        break;
      case '0003':
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        Helper.callView('CREAR_CUENTA_RED_SOCIAL');
        break;
      //Alta red social OK
      case '0010':
        Model.Usuario.IsNewUser = true;
        Helper.setToken(token);
        Helper.setXValue(xvalue);
        Controller.finalizarAcceder();
        break;
      //Asociacion OK
      case '0020':
        Helper.setToken(token);
        Helper.setXValue(xvalue);
        Controller.finalizarAcceder();
        break;
      //Usuario inexistente (No se le pasa Usuario)
      case '0110':
        Service.smartlockSignOut();
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        var message = Message.Usuario['USUARIO_NO_EXISTE'];
        Service.mostrarError(message, Message.Analytis.Usuario['USUARIO_NO_EXISTE'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      //Usuario o contraseña inválidos. Por favor, ingresalos nuevamente. (No se le pasa Contraseña)                
      case '0120':
        if (isSmartlock) {
          Service.smartlockSignOut();
          Service.mostrarError(Message.Usuario['CLAVE_FAIL'], Message.Analytics.Usuario['CLAVE_FAIL'], {
            'text': Message.Usuario['VOLVER_A_INTENTARLO'],
            'stepBack': 'volver_a_ingresar'
          });
        } else {
          $('.atencion').hide(); //Oculto los mensajes de aviso
          $('#aviso-mensaje').show();
          if (obj.response) {
            Model.Usuario.NeedRecaptchaValidation = true;
            if (Helper.Recaptcha.isSubmitted()) {
              Helper.Recaptcha.reset();
            } else {
              Helper.Recaptcha.render('acceder_nativo_ingresar_password_recaptcha');
            }
            $('#captcha-validation').show();
          }
          Helper.changeStatus($('#acceder_nativo_username'), true, null);
          Helper.changeStatus($('#acceder_nativo_password'), true, null);
          Helper.cleanInputs();
        }
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        break;
      //Usuario o contraseña inválidos. Por favor, ingresá con tu cuenta de red social. (Existe usuario pero o tiene SHA1)
      case '0130':
        $('#aviso-mensaje').show();
        Helper.changeStatus($('#acceder_nativo_username'), true, null);
        Helper.changeStatus($('#acceder_nativo_password'), true, null);
        Helper.cleanInputs();
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        break;

      /*SE DESHABILITO EL VENCIMIENTOD DE CLAVE. DE ACA PARA ABAJO NINGUN HANDLER DEBERIA EJECUTARSE NUNCA*/
      //Tu clave expiró - Logueate con tu cuenta de Facebook (Tiene SHA1 y Red social pero el SHA1 está vencido)
      case '0140':
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        Helper.callView('ACCEDER_NATIVO_CASO_1', obj, function () {
          Service.getGmailInfo();
          Service.getFacebookInfo();
        });
        break;
      //Tu clave expiró - Logueate con tu cuenta de G+ (Tiene SHA1 y Red social pero el SHA1 está vencido)
      case '0145':
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        Helper.callView('ACCEDER_NATIVO_CASO_1', obj, function () {
          Service.getGmailInfo();
          Service.getFacebookInfo();
        });
        break;
      //Tu clave expiró - Logueate con tu cuenta de G+ o de Facebook (Tiene SHA1 y ambas redes  sociales pero el SHA1 está vencido)
      case '0150':
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        Helper.callView('ACCEDER_NATIVO_CASO_1', obj, function () {
          Service.getGmailInfo();
          Service.getFacebookInfo();
        });
        break;
      //Tu clave expiró - (Default de clave expirada)
      case '0155':
        Helper.setToken(obj.message);
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        Helper.callView('ACCEDER_NATIVO_CASO_1', obj, function () {
          Service.getGmailInfo();
          Service.getFacebookInfo();
        });
        break;
      /*SE DESHABILITO EL VENCIMIENTOD DE CLAVE. HASTA ACA NINGUN HANDLER DEBERIA EJECUTARSE NUNCA*/

      //Suspendido por abuso
      case '0160':
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        Service.mostrarError(Message.Usuario['SUSPENDIDO_POR_ABUSO'], Message.Analytics.Usuario['SUSPENDIDO_POR_ABUSO'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      //Eliminado Logico
      case '0170':
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        Service.mostrarError(Message.Usuario['ELIMINADO_LOGICO'], Message.Analytics.Usuario['ELIMINADO_LOGICO'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      case '0175':
        //
        break;
      //Suspendido definitivo
      case '0180':
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        Service.mostrarError(Message.Usuario['SUSPENDIDO_DEFINITIVO'], Message.Analytics.Usuario['SUSPENDIDO_DEFINITIVO'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      case '0185':
        if (isSmartlock) {
          Service.smartlockSignOut();
          Service.mostrarError(obj.message, obj.message, {
            'text': Message.Usuario['VOLVER_A_INTENTARLO'],
            'stepBack': 'volver_a_ingresar'
          });
        } else {
          Helper.changeStatus($('#acceder_nativo_password'), false, obj.message, obj.message);
          Model.Usuario.NeedRecaptchaValidation = false;
          $('#captcha-validation').hide();
        }
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        break;
      //El usuario no confirmó la casilla --> Token_Temporal                
      case '0190':
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        Controller.grabarTokenTemporal(obj, status, xhr);
        break;
      //Se controla un error que puede dar clave duplicada
      case '0195':
        logger && logger.error('Login | Alta red invalida', { Response: obj, Modelo: Model });
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        Service.mostrarError(Message.Usuario['ALTA_RED_INVALIDA'], Message.Analytics.Usuario['ALTA_RED_INVALIDA'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      case '0282':
        Helper.cleanInputs();
        Helper.changeStatus($('#acceder_nativo_password'), false, obj.message, obj.message);
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        break;
      case '0001':
        logger && logger.fatal('Login | Error General', { Response: obj, Modelo: Model });
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;

      default:
        logger && logger.error('Login | No existe codigo respuesta (' + obj.code + ')', { Response: obj, Modelo: Model });
        LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        throw new Error("No existe el tipo de estado");
    }
  };

  // ==================================================
  // Manejador de respustas ajax
  // ================================================== 
  Handler.loginCrearCuentaResponseHandler = function (obj, status, xhr) {
    console.log('CuentaHandler | ' + obj.code);

    var token = xhr.getResponseHeader("X-Token") || Helper.getHeader(obj.response, [1]);
    var xvalue = xhr.getResponseHeader("X-Value") || Helper.getHeader(obj.response, [2]);
    //if(!code ==)
    switch (obj.code) {
      //Caso Todo OK
      case '0000':
        Helper.deleteAllCookies();
        Helper.setToken(token);
        Helper.setXValue(xvalue);
        Controller.finalizarAcceder();
        break;
      //Usuario o contraseña inválidos. Por favor, ingresalos nuevamente. (No se le pasa Contraseña)                
      case '0110':
      case '0120':
        $('.atencion').hide(); //Oculto los mensajes de aviso
        $('#aviso-mensaje').show();
        Helper.changeStatus($('#acceder_nativo_username'), true, null);
        Helper.changeStatus($('#acceder_nativo_password'), true, null);
        Helper.cleanInputs();
        break;
      //Usuario o contraseña inválidos. Por favor, ingresá con tu cuenta de red social. (Existe usuario pero o tiene SHA1)
      case '0130':
        $('#aviso-mensaje').show();
        Helper.changeStatus($('#acceder_nativo_username'), true, null);
        Helper.changeStatus($('#acceder_nativo_password'), true, null);
        Helper.cleanInputs();
        break;
      //Tu clave expiró - Logueate con tu cuenta de Facebook (Tiene SHA1 y Red social pero el SHA1 está vencido)
      case '0140':
        Helper.callView('ACCEDER_NATIVO_CASO_1', obj, function () {
          Service.getGmailInfo();
          Service.getFacebookInfo();
        });
        break;
      //Tu clave expiró - Logueate con tu cuenta de G+ (Tiene SHA1 y Red social pero el SHA1 está vencido)
      case '0145':
        Helper.callView('ACCEDER_NATIVO_CASO_1', obj, function () {
          Service.getGmailInfo();
          Service.getFacebookInfo();
        });
        break;
      //Tu clave expiró - Logueate con tu cuenta de G+ o de Facebook (Tiene SHA1 y ambas redes  sociales pero el SHA1 está vencido)
      case '0150':
        Helper.callView('ACCEDER_NATIVO_CASO_1', obj, function () {
          Service.getGmailInfo();
          Service.getFacebookInfo();
        });
        break;
      //Tu clave expiró - (Default de clave expirada)
      case '0155':
        Helper.setToken(obj.message);
        Helper.callView('ACCEDER_NATIVO_CASO_1', obj, function () {
          Service.getGmailInfo();
          Service.getFacebookInfo();
        });
        break;
      //Suspendido por abuso
      case '0160':
        Service.mostrarError(Message.Usuario['SUSPENDIDO_POR_ABUSO'], Message.Analytics.Usuario['SUSPENDIDO_POR_ABUSO'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      //Eliminado Logico
      case '0170':
        Service.mostrarError(Message.Usuario['ELIMINADO_LOGICO'], Message.Analytics.Usuario['ELIMINADO_LOGICO'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      case '0175':
        //
        break;
      //Suspendido definitivo
      case '0180':
        Service.mostrarError(Message.Usuario['SUSPENDIDO_DEFINITIVO'], Message.Analytics.Usuario['SUSPENDIDO_DEFINITIVO'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      case '0185':
        Helper.changeStatus($('#acceder_nativo_password'), false, obj.message, obj.message);
        break;
      //El usuario no confirmó la casilla --> Token_Temporal                
      case '0190':
        Controller.grabarTokenTemporal(obj, status, xhr);
        break;
      //Se controla un error que puede dar clave duplicada
      case '0195':
        logger && logger.error('Crear Usuario (ExisteMailUsuario) | Alta red invalida', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Usuario['ALTA_RED_INVALIDA'], Message.Analytics.Usuario['ALTA_RED_INVALIDA'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      case '0001':
        logger && logger.fatal('Crear Usuario (ExisteMailUsuario) | Error General', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      default:
        logger && logger.error('Crear Usuario (ExisteMailUsuario) | No existe el codigo de respuesta (' + obj.code + ')', { Response: obj, Modelo: Model });
        throw new Error("No existe el tipo de estado");
    }
  };

  // ==================================================
  // Manejador de respustas ajax
  // ================================================== 
  Handler.asociarRedSocialResponseHandler = function (obj, status, xhr) {
    console.log('AsociarRedHandler | ' + obj.code);

    var token = xhr.getResponseHeader("X-Token");
    var xvalue = xhr.getResponseHeader("X-Value");

    //if(!code ==)
    switch (obj.code) {
      //Caso Todo OK
      case '0000':
        Helper.setToken(token);
        Helper.setXValue(xvalue);
        Controller.finalizarAcceder();
        break;
      //Asociacion OK
      case '0020':
        Helper.setToken(token);
        Helper.setXValue(xvalue);
        Controller.finalizarAcceder();
        break;
      //asociarRedSocialNoOk generico
      case '0025':
        Helper.changeStatus($('#mostrar_error_mensaje'), false, obj.message, obj.message, function () {
          Helper.cleanInputs();
        });
        break;
      //Ya existe un usuario con el perfil de Facebook ingresado.
      case '0026':
        Helper.changeStatus($('#mostrar_error_mensaje'), false, obj.message, obj.message, function () {
          Helper.cleanInputs();
        });
        break;
      //Ya existe un usuario con el perfil de Google ingresado.
      case '0027':
        Helper.changeStatus($('#mostrar_error_mensaje'), false, obj.message, obj.message, function () {
          Helper.cleanInputs();
        });
        break;
      //Ya existe un usuario registrado con el email ingresado.
      case '0028':
        Helper.changeStatus($('#mostrar_error_mensaje'), false, obj.message, obj.message, function () {
          Helper.cleanInputs();
        });
        break;
      //exception
      case '0001':
        logger && logger.fatal('GestionarRedSocial | Error general', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      default:
        logger && logger.error('GestionarRedSocial | No existe codigo respuesta (' + obj.code + ')', { Response: obj, Modelo: Model });
        throw new Error("No existe el tipo de estado");
    }
  };

  // ==================================================
  // Manejador de respustas ajax
  // ================================================== 
  Handler.existeMailUsuarioResponseHandler = function (obj, status, xhr) {
    console.log('MailHandler | ' + obj.code);

    switch (obj.code) {
      //Caso Todo OK
      case '0000':
        Model.Usuario.NeedRecaptchaValidation = obj.response;
        Controller.accederNativoIngresarPasswordView();
        break;
      // Excepcion
      case '0001':
        logger && logger.fatal("ExisteMailUsuario | Error General", { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Error['GENERAL']);
        break;
      //Usuario inexistente.
      case '0110':
        // Si se quiso ingresar con un email inexistente, cargo view de crear cuenta 
        // Si se quiso ingresar con un nick, muestro mensaje de error 
        if (Helper.Validators.email.test(Model.Usuario.UsuarioUsuario)) Helper.changeStatus($("#acceder_nativo_username"), false, Message.Usuario['EMAIL_NO_EXISTE'], Message.Analytics.Usuario['EMAIL_NO_EXISTE']);
        //Controller.crearCuentaNativoView(); 
        else Helper.changeStatus($("#acceder_nativo_username"), false, Message.Usuario['USUARIO_INVALIDO'], Message.Analytics.Usuario['USUARIO_INVALIDO']);
        break;
      //usuario existe, tiene mail y no contraseña por lo cual tiene red social.
      case '0195':
        Helper.changeStatus($("#acceder_nativo_username"), false, Message.Usuario['LOGUEATE_RED_SOCIAL'], Message.Analytics.Usuario['LOGUEATE_RED_SOCIAL']);
        break;
      case '0196':
        handleFacilitarAccesoGoogle('acceder_nativo_username');
        break;
      case '0197':
        Helper.changeStatus($("#acceder_nativo_username"), false, Message.Usuario['LOGUEATE_RED_SOCIAL_FACEBOOK'], Message.Analytics.Usuario['LOGUEATE_RED_SOCIAL_FACEBOOK']);
        break;
      // Dominio no permitido
      case '0255':
        Helper.changeStatus($("#acceder_nativo_username"), false, Message.Usuario['CARACTER_INVALIDO_MAIL'], Message.Analytics.Usuario['CARACTER_INVALIDO_MAIL']);
        break;
      case '0300':
        Helper.changeStatus($("#acceder_nativo_username"), false, Message.Usuario['USUARIO_DOMINIO_INVALIDO'], Message.Analytics.Usuario['USUARIO_DOMINIO_INVALIDO']);
        break;

      default:
        logger && logger.error('ExisteMailUsuario | No existe codigo de respuesta (' + obj.code + ')', { Response: obj, Modelo: Model });
        throw new Error("No existe el tipo de estado");
    }
  };

  // ==================================================
  // Manejador de respustas ajax
  // ================================================== 
  Handler.existeMailUsuarioCrearCuentaResponseHandler = function (obj, status, xhr) {
    console.log('MailCuentaHandler | ' + obj.code);

    switch (obj.code) {
      //Caso Todo OK
      case '0000':
        Controller.crearCuentaNativoView(Message.Usuario['USUARIO_EXISTE']);
        break;
      // Excepcion
      case '0001':
        logger && logger.fatal("ExisteMailUsuario | Error General", { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      //Usuario inexistente.
      case '0110':
        Controller.crearCuentaDatosView(true);
        break;
      //usuario existe, tiene mail y no contraseña por lo cual tiene red social.
      case '0195':
        Controller.crearCuentaNativoView(Message.Usuario['USUARIO_EXISTE']);
        break;
      case '0196':
        alert(obj.message);
        break;
      case '0197':
        alert(obj.message);
        break;
      default:
        logger && logger.error('ExisteMailUsuario | No existe codigo de respuesta (' + obj.code + ')', { Response: obj, Modelo: Model });
        throw new Error("No existe el tipo de estado");
    }
  };

  // ==================================================
  // Manejador de respustas ajax
  // ================================================== 
  Handler.existeMailUsuarioCrearCuentaDirectaResponseHandler = function (obj, status, xhr) {
    console.log('MailCuentaHandler | ' + obj.code);

    var $input = $("#crear_cuenta_directa_email");

    switch (obj.code) {
      //Caso Todo OK
      case '0000':
        Analytics.formError('crear_cuenta_directa_email-' + Message.Analytics.Usuario['USUARIO_EXISTE']);
        Controller.crearCuentaDirectaView(Message.Usuario['USUARIO_EXISTE']);
        break;
      // Excepcion
      case '0001':
        logger && logger.fatal("ExisteMailUsuario (Cuenta Directa)| Error General", { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      //Usuario inexistente.
      case '0110':
        Controller.crearCuentaDirectaPassword();
        //Controller.crearCuentaDatosView(false);
        break;
      //usuario existe, tiene mail y no contraseña por lo cual tiene red social.
      case '0195':
        Helper.changeStatus($input, false, Message.Usuario['LOGUEATE_RED_SOCIAL'], Message.Analytics.Usuario['LOGUEATE_RED_SOCIAL']);
        break;
      case '0196':
        handleFacilitarAccesoGoogle('crear_cuenta_directa_email');
        break;
      case '0197':
        Helper.changeStatus($input, false, Message.Usuario['LOGUEATE_RED_SOCIAL_FACEBOOK'], Message.Analytics.Usuario['LOGUEATE_RED_SOCIAL_FACEBOOK']);
        break;
      // Dominio no permitido
      case '0255':
        Helper.changeStatus($("#crear_cuenta_directa_email"), false, Message.Usuario['CARACTER_INVALIDO_MAIL'], Message.Analytics.Usuario['CARACTER_INVALIDO_MAIL']);
        break;
      case '0300':
        Helper.changeStatus($("#crear_cuenta_directa_email"), false, Message.Usuario['USUARIO_DOMINIO_INVALIDO'], Message.Analytics.Usuario['USUARIO_DOMINIO_INVALIDO']);
        break;
      default:
        logger && logger.error('ExisteMailUsuario (Cuenta Directa)| No existe codigo de respuesta (' + obj.code + ')', { Response: obj, Modelo: Model });
        throw new Error("No existe el tipo de estado");
    }
  };

  // ==================================================
  // Manejador de respustas ajax
  // ================================================== 
  Handler.altaUsuarioResponseHandler = function (obj, status, xhr) {
    console.log('AltaHandler | ' + obj.code);

    Helper.Recaptcha.reset();

    switch (obj.code) {
      //Caso Todo OK
      case '0000':
        var userId = obj.response;
        Model.Usuario.IsNewUser = true;

        Analytics.createAccount();
        CustomDimension.setUserId(userId);
        CustomDimension.save();
        Service.createCustomDimension();

        Controller.grabarTokenTemporal(obj, status, xhr);
        break;
      case '0004':
        Service.mostrarError(Message.Usuario['USUARIO_CAMPO_FALTANTE'], Message.Analytics.Usuario['USUARIO_CAMPO_FALTANTE'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      // El usuario ya existe
      case '0115':
        Helper.displayCustomMessageFormError($('#recaptcha-mensaje'), Message.Usuario['CAPTCHA_INVALIDO'], Message.Analytics.Usuario['CAPTCHA_INVALIDO']);
        Helper.Recaptcha.reset();
        break;
      // El usuario ya existe                
      case '0210':
        Service.mostrarError(Message.Usuario['USUARIO_EXISTE_MAIL'], Message.Analytics.Usuario['USUARIO_EXISTE_MAIL'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      //Error de captcha
      case '0215':

        break;
      //Error al enviar el email
      case '0250':
        logger && logger.error("AltaUsuario | Email envio Error", { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Usuario['ALTA_MAIL_NO_ENVIO'], Message.Analytics.Usuario['ALTA_MAIL_NO_ENVIO'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      case '0260':
        Service.mostrarError(Message.Usuario['CODIGO_INVALIDO'], Message.Analytics.Usuario['CODIGO_INVALIDO'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      case '0001':
        logger && logger.fatal("AltaUsuario | Error General", { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;

      default:
        logger && logger.error('AltaUsuario | No existe codigo de respuesta (' + obj.code + ')', { Response: obj, Modelo: Model });
        throw new Error("No existe el tipo de estado");
    }
  };

  // ==================================================
  // Manejador de respustas ajax
  // ================================================== 
  Handler.obtenerDatosClubHandler = function (obj, status, xhr) {
    console.log('ObtenerHandler | ' + obj.code);

    //if(!code ==)
    switch (obj.code) {
      //Caso Todo OK
      case '1':
      case '2':
        Model.Usuario.Credenciales = obj.response !== null ? obj.response : [];
        if (Model.Usuario.TipoAsociarCredencial == "") Model.Usuario.TipoAsociarCredencial = obj.code;
        Controller.asociarCredencialView();
        break;
      case '0001':
        logger && logger.fatal('ObtenerDatosClub | Error General', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      default:
        logger && logger.error('ObtenerDatosClub | No existe codigo de respuesta (' + obj.code + ')', { Response: obj, Modelo: Model });
        throw new Error("No existe el tipo de estado");
    }
  };

  // ==================================================
  // Manejador de respustas ajax
  // ================================================== 
  Handler.validarCodigoMailLoginResponseHandler = function (object, status, xhr) {
    console.log('CodigoHandler | ' + object.code);

    //if(!code ==)
    switch (object.code) {
      // Caso de éxito.
      case '0000':
        var token = xhr.getResponseHeader("X-Token") || Helper.getHeader(object.response, [1]);
        var xvalue = xhr.getResponseHeader("X-Value") || Helper.getHeader(object.response, [2]);

        Helper.deleteAllCookies();
        Helper.setToken(token);
        Helper.setXValue(xvalue);

        if (object.code == "0000" && (token == null || xvalue == null || !token || !xvalue)) {
          logger && logger.error("ValidarCodigoMailLogin | sin headers", { Response: object, Modelo: Model });
        }

        Handler.loginResponseHandler(object, status, xhr);
        break;
      case '0121':
        // Usuario o password incorrecto. Cuando crea usuario con FB.
        if (!Helper.isEmpty(Model.Usuario.UsuarioFacebookId)) {
          Model.Window.islockedFacebook = false;
          Controller.accederFacebook();
        } else if (!Helper.isEmpty(Model.Usuario.UsuarioGmailId)) {
          Model.Window.islockedGmail = false;
          Controller.accederGmail();
        }
        break;
      case '0190':
        logger && logger.error("ValidarCodigoMailLogin | Falla replicacion", { Response: object, Modelo: Model });
        Controller.crearCuentaGracias();
        break;
      // El usuario ya existe.
      case '0260':
        Controller.crearCuentaValidarCodigoView(object.message);
        break;
      case '0001':
      case '0002':
        logger && logger.fatal("ValidarCodigoMailLogin | Error General", { Response: object, Modelo: Model });
        Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      default:
        logger && logger.error('ValidarCodigoMailLogin | No existe codigo de respuesta (' + object.code + ')', { Response: object, Modelo: Model });
        throw new Error("No existe el tipo de estado");
    }
  };

  // ==================================================
  // Manejador de respustas ajax
  // ================================================== 
  Handler.validarCodigoMailResponseHandler = function (obj, status, xhr) {
    console.log('CodigoHandler | ' + obj.code);

    //if(!code ==)
    switch (obj.code) {
      //Caso Todo OK
      case '0000':
        Helper.callView('CREAR_CUENTA_GRACIAS');
        break;
      // El usuario ya existe
      case '0260':
        Controller.crearCuentaValidarCodigoView(obj.message);
        break;
      case '0001':
      case '0002':
        logger && logger.fatal('validarCodigoMailResponseHandler | Error General', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      default:
        logger && logger.error('validarCodigoMailResponseHandler | No existe codigo de respuesta (' + obj.code + ')', { Response: obj, Modelo: Model });
        throw new Error("No existe el tipo de estado");
    }
  };

  // ==================================================
  // Manejador de respustas ajax
  // ================================================== 
  Handler.olvidoClaveHandler = function (obj, status, xhr) {
    console.log('OlvidoHandler | ' + obj.code);

    //if(!code ==)
    switch (obj.code) {
      //Caso Todo OK
      case '0000':
        Controller.reestablecerPasswordEnvioView();
        break;
      //Usuario inexistente (No se le pasa Usuario)
      case '0110':
        Helper.changeStatus($('#reestablecer_password_email'), false, Message.Usuario['USUARIO_NO_EXISTE'], Message.Analytics.Usuario['USUARIO_NO_EXISTE']);
        break;
      // El usuario ya existe
      case '0115':
        Service.mostrarErrorTrackeaForm(Message.Usuario['CAPTCHA_INVALIDO'], Message.Analytics.Usuario['CAPTCHA_INVALIDO'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        Helper.Recaptcha.reset();
        break;
      // Se produjo un error al enviar el mail al nuevo usuario registrado.​
      case '0250':
        logger && logger.error('ValidarUsuarioOlvidoClaveMailRecaptcha | Error al enviar email', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Usuario['USUARIO_EXISTE'], Message.Analytics.Usuario['USUARIO_EXISTE'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;
      case '0001':
        logger && logger.fatal('ValidarUsuarioOlvidoClaveMailRecaptcha | Error General', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        break;

      default:
        logger && logger.error('ValidarUsuarioOlvidoClaveMailRecaptcha | No existe codigo de respuesta (' + obj.code + ')', { Response: obj, Modelo: Model });
        throw new Error("No existe el tipo de estado");
    }
  };

  // ==================================================
  // Manejador de respustas ajax
  // ================================================== 
  Handler.olvidoClaveCodigoLoadHandler = function (obj, status, xhr) {
    console.log('OlvidoLoadHandler | ' + obj.code);

    switch (obj.code) {
      //Caso Todo OK
      case '0000':
        Controller.reestablecerPasswordCodigoView();
        break;
      //Usuario inexistente (No se le pasa Usuario)
      case '0110':
        logger && logger.error('ValidarCambioContrasenia | No se le pasa usuario (0110)', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Usuario['USUARIO_NO_EXISTE'], Message.Analytics.Usuario['USUARIO_NO_EXISTE'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'retornar_acceder'
        });
        break;
      //Usuario inexistente (No se le pasa Usuario)
      case '0135':
        logger && logger.error('ValidarCambioContrasenia | No se le pasa usuario (0135)', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Usuario['USUARIO_NO_EXISTE'], Message.Analytics.Usuario['USUARIO_NO_EXISTE'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'retornar_acceder'
        });
        break;
      //Usuario inexistente (No se le pasa Usuario)
      case '0175':
        Service.mostrarError(Message.Error['ENLACE_CADUCADO'], Message.Analytics.Error['ENLACE_CADUCADO'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'retornar_acceder'
        });
        break;
      //Usuario inexistente (No se le pasa Usuario)
      case '0165':
        logger && logger.error('ValidarCambioContrasenia | No se le pasa usuario (0165)', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'retornar_acceder'
        });
        break;
      case '0001':
        logger && logger.fatal('ValidarCambioContrasenia | Error General', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'retornar_acceder'
        });
        break;

      default:
        logger && logger.error('ValidarCambioContrasenia | No existe codigo de respuesta (' + obj.code + ')', { Response: obj, Modelo: Model });
        throw new Error("No existe el tipo de estado");
    }
  };

  // ==================================================
  // Manejador de respustas ajax
  // ================================================== 
  Handler.olvidoClaveCodigoHandler = function (obj, status, xhr) {
    console.log('OlvidoCodigoHandler | ' + obj.code);

    //if(!code ==)
    switch (obj.code) {
      //Caso Todo OK
      case '0':
      case '0000':
        Helper.setToken("");
        Controller.reestablecerPasswordCodigoGraciasView();
        break;
      //Usuario inexistente (No se le pasa Usuario)
      case '0110':
        logger && logger.error('ActualizarClave | No se le pasa usuario (0110)', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Usuario['USUARIO_NO_EXISTE'], Message.Analytics.Usuario['USUARIO_NO_EXISTE'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'retornar_acceder'
        });
        break;
      //Usuario inexistente (No se le pasa Usuario)
      case '0125':
        logger && logger.error('ActualizarClave | No se pudo actualizar la contraseña', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Usuario['NO_ACTUALIZA'], Message.Analytics.Usuario['NO_ACTUALIZA'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'retornar_acceder'
        });
        break;
      //Usuario inexistente (No se le pasa Usuario)
      case '0135':
        logger && logger.error('ActualizarClave | No se le pasa usuario (0135)', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Usuario['USUARIO_NO_EXISTE'], Message.Analytics.Usuario['USUARIO_NO_EXISTE'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'retornar_acceder'
        });
        break;
      //Usuario inexistente (No se le pasa Usuario)
      case '0270':
        Controller.reestablecerPasswordCodigoView(obj.message);
        break;
      case '0280':
        Service.mostrarError(Message.Error['CLAVE_ACTUAL_INVALIDA'], Message.Analytics.Error['CLAVE_ACTUAL_INVALIDA'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'retornar_acceder'
        });
        break;
      case '0281':
        Service.mostrarError(Message.Error['CLAVE_ANTERIOR_INVALIDA'], Message.Analytics.Error['CLAVE_ANTERIOR_INVALIDA'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'retornar_acceder'
        });
        break;
      case '0282':
        Service.mostrarErrorTrackeaForm(Message.Usuario['CAPTCHA_INVALIDO'], Message.Analytics.Usuario['CAPTCHA_INVALIDO'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'volver_a_ingresar'
        });
        Helper.Recaptcha.reset();
        break;
      case '0305':
        Helper.changeStatus($('#reestablecer_password_codigo_password'), false, Message.Usuario['USUARIO_CLAVE_REPETIDA'], Message.Analytics.Usuario['USUARIO_CLAVE_REPETIDA']);
        Helper.Recaptcha.reset();
        //Service.mostrarError(Message.Usuario['USUARIO_CLAVE_REPETIDA'], {
        //    'text': Message.Usuario['VOLVER_A_INTENTARLO'],
        //});
        break;
      case '0001':
        logger && logger.fatal('ActualizarClave | Error General', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL'], {
          'text': Message.Usuario['VOLVER_A_INTENTARLO'],
          'stepBack': 'retornar_acceder'
        });
        break;
      default:
        logger && logger.error('ActualizarClave | No existe codigo de respuesta (' + obj.code + ')', { Response: obj, Modelo: Model });
        throw new Error("No existe el tipo de estado");
    }
  };

  // ==================================================
  // Manejador de respustas ajax
  // ================================================== 
  // NO SE USA
  //Handler.asociarTarjetaResponseHandler = function (obj) {
  //    //if(!code ==)
  //    switch (obj.code) {
  //        //Caso Todo OK
  //        case '0000':
  //            //Controller.finalizarAcceder();            
  //            break;

  //        default:
  //            throw new Error("No existe el tipo de estado");
  //    }
  //}


  // ==================================================
  // Manejador de respustas ajax
  // ================================================== 
  Handler.logoutHandler = function (obj, status, xhr, options) {
    console.log('LogoutHandler | ' + obj.code);

    //if(!code ==)
    switch (obj.code) {
      //Caso Todo OK
      case '0000':
        Helper.returnBackLogout(options);
        break;
      default:
        logger && logger.error('Logout | No existe codigo de respuesta (' + obj.code + ')', { Response: obj, Modelo: Model });
        Helper.returnBackLogout(options);
    }
  };

  // ==================================================
  // Manejador de errores http
  // ================================================== 
  Handler.failHandler = function (code) {
    console.log('FallaHandler | ' + code);

    switch (code) {
      case 500:
        Service.mostrarError(Message.Error['500'], Message.Analytics.Error['500']);
        break;
      case 400:
        Service.mostrarError(Message.Error['400'], Message.Analytics.Error['400']);
        break;
      case 401:
        Service.mostrarError(Message.Error['401'], Message.Analytics.Error['401']);
        break;
      case 402:
        Service.mostrarError(Message.Error['402'], Message.Analytics.Error['402']);
        break;
      case 403:
        Service.mostrarError(Message.Error['403'], Message.Analytics.Error['403']);
        break;
      case 200:
        ///
        break;
      case 'parsererror':
        Service.mostrarError(Message.Error['PARSER_ERROR'], Message.Analytics.Error['PARSER_ERROR']);
        break;
      case 'timeout':
        Service.mostrarError(Message.Error['TIMEOUT'], Message.Analytics.Error['TIMEOUT']);
        break;
      case 'abort':
        Service.mostrarError(Message.Error['ABORT'], Message.Analytics.Error['ABORT']);
        break;
      case 0:
        break;
      default:
        logger && logger.error('FailHandler | No existe codigo de respuesta (' + code + ')', { Modelo: Model });
      //throw new Error("No existe el error");
    }
  };

  // ==================================================
  // Manejador de tipo de credencial nota Black
  // ================================================== 
  Handler.validarCredencialBlackHandler = function () {
    switch (Model.Usuario.ClubNacion) {
      case 'B':
        Helper.returnBack(); // Credencial Black . Voy a url de callback . 
        break;
      case 'P':
      case 'C':
      case 'S':
      case 'D':
        Helper.callView('ASOCIAR_TARJETA_NO_BLACK'); // Diseño credencial no permite acceder a la nota . 
        break;
      case '':
      case '0':
        Controller.validarTipoAsociacionClub(); // No tengo credencial asignada . Pido asignar . 
        break;
      default:
        logger && logger.error('ValidarCredencialBlack | Error General', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']); // Error en Usuario/Me . 
        break;
    }
  };

  // ==================================================
  // Manejador de tipo de credencial para asociacion post-login
  // ================================================== 
  Handler.validarCredencialHandler = function () {
    switch (Model.Usuario.ClubNacion) {
      case 'B':
      case 'P':
      case 'C':
      case 'S':
      case 'D':
        Helper.returnBack(); // Tengo credencial . Voy a url de callback . 
        break;
      case '':
      case '0':
        Controller.validarTipoAsociacionClub(); // No tengo credencial asignada . Pido asignar . 
        break;
      default:
        logger && logger.error('ValidarCredencial | Error General', { Response: obj, Modelo: Model });
        Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']); // Error en Usuario/Me . 
        break;
    }
  };

  Handler.asociarResponseHandler = function (obj, status, xhr) {
    console.log('AsociarHandler | ' + obj.code);

    switch (obj.code) {
      case '1':
        var usuarioDetalleClubNacion = Helper.readCookie("usuarioDetalleClubNacion");
        Analytics.asociacionExitosa(usuarioDetalleClubNacion, Model.Window.currentStep);
        Controller.finalizarAsociar();
        break;
      case '-1':
        logger && logger.error('AsociarCredencial | Error al asociar', { Response: obj, Modelo: Model });
        Controller.asociarCredencialView(Message.Credencial['ERROR_ASOCIAR'], 'error'); // Ocurrió un error al querer asociar . 
        Hotjar.callTrigger('vinculacion-default-error');
        break;
      case '-2':
        Controller.asociarCredencialView(Message.Credencial['ERROR_NO_COINCIDEN'], 'error'); // Ocurrió un error al querer asociar . 
        break;
      case '-3':
        var mensaje = Message.Credencial['ERROR_YA_ASOCIADO'];
        mensaje = mensaje.replace("{{email}}", obj.response);
        Controller.asociarCredencialView(mensaje, 'advertencia'); // Ocurrió un error al querer asociar .  
        Hotjar.callTrigger('vinculacion-ya-asociado');
        break;
      default:
        logger && logger.error('AsociarCredencial | Error al asociar', { Response: obj, Modelo: Model });
        Controller.asociarCredencialView(Message.Credencial['ERROR_ASOCIAR'], 'error'); // Ocurrió un error al querer asociar . 
        Hotjar.callTrigger('vinculacion-default-error');
    }
  };

  Handler.finalizarAccederHandler = function () {
    var newUser = Model.Usuario.IsNewUser || false;

    if (!Helper.isEmpty(Model.Usuario.UsuarioFacebookId)) {
      Analytics.login(newUser, 'Facebook', Helper.readCookie("usuario%5Fid"));
    } else if (!Helper.isEmpty(Model.Usuario.UsuarioGmailId)) {
      Analytics.login(newUser, 'Google', Helper.readCookie("usuario%5Fid"));
    } else {
      Analytics.login(newUser, 'Nativo', Helper.readCookie("usuario%5Fid"));
    }

    switch (Model.Window.modo) {
      case "B":
        Handler.validarCredencialBlackHandler();
        return;
        break;
    }

    LocalStorage.setExpiredItem(Config.LoginFlagKey, false);

    // Handler por sitioid
    // Dependiendo el sitioid, veo si dsp del login tengo que validar el asociado de credencial 
    if (Config.SitiosAsociarCredencial.indexOf(Model.Window.SitioId) != -1) {
      Handler.validarCredencialHandler();
      return;
    }

    Helper.returnBackPassport();
  };
  /* LM */

  Handler.keypressHandler = function (object, event) {

    if (event.which !== 13) {
      Helper.checkNextButton(object);
    }

    if (event.which === 13) {
      if (Model.Window.keyPress <= Config.keyPressLimit) {
        Model.Window.keyPress++;
      } else {
        Helper.showPreloader();
        setTimeout(function () {
          Helper.cleanKeyPress();
          Helper.hidePreloader();
        }, Config.freezeTime);
      }
    }

    if (event.which === 20) {
      Helper.checkCapsLock(event);
    }
  };

  Handler.OnFaildefaultErrorMessage = function () {
    Service.mostrarError(Message.DefaultErrorMessage, Message.Analytics.DefaultErrorMessage);
  };

  function handleFacilitarAccesoGoogle(inputId) {
    //const experimentId = Constantes.FacilitarAccesoGoogleExperimentId;

    var messageKey = 'LOGUEATE_RED_SOCIAL_GOOGLE';
    //const friendlyMessage = Message.Usuario[messageKey];
    var analyticsMessage = Message.Analytics.Usuario[messageKey];

    //Helper.StartExperiment(experimentId);

    //let experiment = Model.Usuario.Experiments.filter(e => e.id === experimentId);

    //if (experiment.length > 0 && experiment[0].variation == '1') {
    Analytics.formError(inputId + '-' + analyticsMessage);
    Controller.facilitarAccesoGoogle();
    //}
    //else {
    //    Helper.changeStatus($(`#${inputId}`), false, friendlyMessage, analyticsMessage);
    //}
  }
})(LN.App, LN.Handler, LN.Service, LN.Controller, LN.Config, LN.Helper, LN.Message, LN.Model, LN.Analytics, LN.Hotjar, LN.LocalStorage, LN.CustomDimension, window.config.Constantes, jQuery);

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
  if (!LN.Core) throw new Error("LN.Core missing");
})();

(function (Helper, Config, Model, Handlebars, Constantes, Analytics, Message, $) {
  'use strict';

  // ==================================================
  // Objeto con validaciones basicas
  // ==================================================    

  Helper.Validators = {
    username: /^[A-Za-z0-9_.-]{4,24}$/,
    email: /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"\%]+\.)+[^<>()[\]\.,;:\s@\"\%]{2,})$/i,
    password: /^[A-Za-z0-9 !@#$%^&*()_.-]{1,20}$/,
    passwordRegistro: /^[A-Za-z0-9 _]{8,20}$/,
    name: /^[A-Za-zÀ-ÿ ]{2,50}$/,
    lastname: /^[A-Za-zÀ-ÿ ]{2,50}$/,
    confirmCode: /^[A-Za-z0-9]{3,24}$/,
    credencialClub: /^[0-9]{15}?/,
    credencialClub1: /^[0-9]{6}?/,
    credencialClub2: /^[0-9X]{8}?/,
    credencialClub3: /^[0-9]{2}?/,
    dni: /^[0-9]{7,8}$/,
    passport: /^[A-Za-z0-9]{6,10}?/,
    temporary: /loginTemporalKey/
  };

  Helper.Validators.Max = {
    username: 9,
    password: 20,
    name: 50,
    lastname: 50,
    confirmCode: 24,
    credencialClub: 15,
    credencialClub1: 5,
    credencialClub2: 7,
    credencialClub3: 1,
    dni: 8,
    passport: 10
  };

  var isNewUser = false;

  // ==================================================
  // Setea el titulo de la pagina
  // Params : {string}
  // ==================================================    
  Helper.setPageTitle = function (title) {
    document.title = title;
  };

  Helper.setFirstStart = function (bool) {
    Model.Window.firstStart = bool;
  };

  Helper.checkFirstStart = function () {
    return Model.Window.firstStart;
  };

  // ==================================================
  // Redireccion
  // Params : {string}
  // ==================================================   
  Helper.redirectUrl = function (url) {
    window.location = url;
  };

  // ==================================================
  // Redireccion Passport
  // Params : {string}
  // ==================================================   
  Helper.redirectPassport = function (url) {
    logger && logger.debug('redirectPassport (url =' + url + ' )');

    console.log("Redirect passport", url);
    window.location = Config.urlPassport + encodeURIComponent(url);
  };

  // ==================================================
  // Muestra preloader
  // ==================================================
  Helper.showPreloader = function () {
    $('#main-view').addClass("loading").each(function () {
      Helper.disableNextButton();
      $('.preloader-right').css("display", "block");
    });
  };

  // ==================================================
  // Oculta preloader
  // ==================================================
  Helper.hidePreloader = function () {
    $('#main-view').removeClass("loading").each(function () {
      Helper.enableNextButton();
      $('.preloader-right').css("display", "none");
    });
  };

  Helper.removeBlur = function () {
    $('#main-view').removeClass("loading");
  };

  // ==================================================
  // Valida si esta vacio cualquier tipo de dato
  // Params : {obj} || {arr} || {str}
  // ==================================================
  Helper.isEmpty = function (obj) {
    if (obj == null) return true;
    if (obj.length > 0) return false;
    if (obj.length === 0) return true;
    for (var key in obj) {
      if (hasOwnProperty.call(obj, key)) return false;
    }
    return true;
  };

  Helper.setToken = function (token) {
    if (Helper.isEmpty(token)) return;
    Helper.createCookie('token', token, Config.cookieExpirationTime, Config.dominioCookie);
    Model.Usuario.xToken = token;
    if (typeof Storage !== "undefined") {
      sessionStorage.setItem("token", token);
    }
    Model.Usuario.xToken = token;
  };

  Helper.updateToken = function () {
    Model.Usuario.xToken = Helper.readCookie("token");
  };

  Helper.setXValue = function (xvalue) {
    if (Helper.isEmpty(xvalue)) return;
    Helper.createCookie('xvalue', xvalue, Config.cookieExpirationTime, Config.dominioCookie);
    Model.Usuario.xValue = xvalue;
    if (typeof Storage !== "undefined") {
      sessionStorage.setItem("xvalue", xvalue);
    }
  };

  // ==================================================
  // Setea en cookies todo un objeto
  // ==================================================
  Helper.setupCookies = function (obj) {
    for (var key in obj) {
      var aux;
      var cookie;

      // Busco si la key se encuentra en el diccionario de cookies para ver si la grabo o no . 
      if (Config.DiccionarioCookiesAGuardar.indexOf(key) > -1 && typeof obj[key] == "string") {
        switch (key) {
          case 'UsuarioDetalleGuid':
            var valor = Helper.readCookie('token');
            if (Model.Usuario) {
              if (Helper.isEmpty(Model.Usuario.xToken)) {
                var email = Helper.isEmpty(Model.Usuario.Email) ? Helper.isEmpty(Model.Usuario.GMail) ? Model.Usuario.FbEmail : Model.Usuario.GMail : Model.Usuario.Email;
                Model.Usuario.xToken = Helper.readCookie('token');
                if (Helper.isEmpty(Model.Usuario.xToken)) {
                  if (typeof Storage !== "undefined") {
                    Model.Usuario.xToken = sessionStorage.token;
                    if (Helper.isEmpty(Model.Usuario.xToken)) {
                      logger && logger.error("setupCookies token null y NO lo recupero de storage =>  Email: " + email);
                    } else {
                      Helper.createCookie('token', Model.Usuario.xToken, Config.cookieExpirationTime, Config.Constantes.dominioCookie);
                      logger && logger.warn("setupCookies token null y ok en storage =>  Email: " + email);
                    }
                  } else {
                    logger && logger.error("setupCookies token null y no permite storage =>  Email: " + email);
                  }
                }
              }
              valor = Model.Usuario.xToken;
            }
            aux = "usuario%5Fdetalle%5Fguid";
            cookie = '{' + valor + '}';
            break;
          case 'UsuarioDetalleNick':
            aux = "usuario%5Fdetalle%5Fnick";
            cookie = obj[key];
            break;
          case 'UsuarioId':
            aux = "usuario%5Fid";
            cookie = obj[key];
            break;
          case 'UsuarioUsuario':
            aux = "usuario%5Fusuario";
            cookie = obj[key];
            break;
          case 'usuarioLogTkn':
            aux = "usuario%5Flogtkn";
            cookie = obj[key];
            break;
          case 'TokenJWT':
            aux = "PersoTKN";
            cookie = obj[key];
            break;
          default:
            if (key == 'token') {
              // no deberia setear token por aca, envio log error si se da el caso.
              var email = Helper.isEmpty(Model.Usuario.Email) ? Helper.isEmpty(Model.Usuario.GMail) ? Model.Usuario.FbEmail : Model.Usuario.GMail : Model.Usuario.Email;
              logger && logger.error('setupCookies token default => Email: ' + email);
            }

            aux = key;
            cookie = obj[key];
        }
        Helper.createCookie(aux, cookie, Config.cookieExpirationTime, Config.dominioCookie);
      }
    }
    if (typeof Storage !== "undefined") {
      sessionStorage.clear();
    }
  };

  Helper.areCookiesEnabled = function () {
    if (navigator.cookieEnabled) return true;

    var CookieName = 'CookiesEnabledCheck';

    try {
      document.cookie = CookieName + '=1';

      var enabled = document.cookie.indexOf(CookieName + '=') != -1;

      document.cookie = CookieName + '=1; expires=Thu, 01-Jan-1970 00:00:01 GMT';

      return enabled;
    } catch (e) {
      return false;
    }
  };

  // ==================================================
  // Crea una cookie
  // Params : {str} {str} {str} {str}
  // ==================================================
  Helper.createCookie = function (name, value, seconds, domain) {
    logger && logger.debug('createCookie [' + name + ']=' + value);
    var expires;
    if (seconds) {
      var date = new Date();
      date.setTime(date.getTime() + seconds * 1000);
      expires = "; expires=" + date.toGMTString();
    } else {
      expires = "";
    }

    if (document.domain === 'localhost') {
      document.cookie = name + "=" + value + expires + "; path=/";
    } else {
      document.cookie = name + "=" + value + expires + ";domain=" + domain + "; path=/";
    }
  };

  // ==================================================
  // Lee el valor de una cookie
  // Params : {str}
  // ==================================================   
  Helper.readCookie = function (name) {
    logger && logger.debug('readCookie [' + name + ']');
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1, c.length);
      }if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  };

  // ==================================================
  // Borra todas las cookies
  // ==================================================   
  Helper.deleteAllCookies = function () {
    logger && logger.debug('deleteAllCookies');
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf("=");
      var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      if (Config.DiccionarioCookiesAGuardar.indexOf(name.trim()) > -1) {
        if (document.domain === 'localhost') {
          //console.log("Delete Cookie - Name : " + name);
          document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
        } else {
          //console.log("Delete Cookie - Name : " + name);
          document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=" + Config.dominioCookie;
        }
      }
    }
  };

  Helper.deleteCookieName = function (n) {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf("=");
      var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;

      if (n == name.trim()) {
        if (document.domain === 'localhost') {
          document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
        } else {
          //console.log("Delete Cookie - Name : " + name);
          document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=" + Config.dominioCookie;
        }
      }
    }
  };

  // ==================================================
  // Borra cookie según nombre dado 
  // ==================================================   
  Helper.deleteCookie = function (name) {
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=" + Config.dominioCookie;
  };

  // ==================================================       
  Helper.setCanSubmit = function (bool) {
    Model.Window.canSubmit = bool;
  };

  Helper.canSubmit = function () {
    return Model.Window.canSubmit;
  };

  // ==================================================
  // Trae Todos los inputs del dom
  // ==================================================   
  Helper.getAllInputs = function () {
    var inputs = $(':input');
    var values = {};
    inputs.each(function () {
      values[this.name] = $(this).val();
    });
    return values;
  };

  // ==================================================
  // Trae Todos los inputs del dom y los convierte a un objeto
  // ==================================================   
  Helper.getAllInputsObject = function () {
    var inputs = $(':input');
    return inputs;
  };

  // ==================================================
  // Extrae un parametro de la current url
  // ==================================================   
  Helper.getURLParameter1 = function (n) {
    return decodeURIComponent((new RegExp('[?|&]' + n + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
  };

  Helper.getURLParameter = function (n) {
    var pathArray = window.location.pathname.replace("/ingresar/", "").replace("/clave/", "").split('/');
    debugger;
    switch (n) {
      case 'param1':
        return !Helper.isEmpty(pathArray[0]) ? pathArray[0] : null;
        break;
      case 'param2':
        return !Helper.isEmpty(pathArray[1]) ? pathArray[1] : null;
        break;
      case 'param3':
        return !Helper.isEmpty(pathArray[2]) ? pathArray[2] : null;
        break;
      case 'param4':
        return !Helper.isEmpty(pathArray[3]) ? pathArray[3] : null;
        break;
      default:
        return null;
        break;
    }
  };

  Helper.getURLQueryString = function () {
    return window.location.search.replace("?", "");
  };

  Helper.findGetParameter = function (url, parameterName) {
    var result = null,
        tmp = [];
    url.search.substr(1).split("&").forEach(function (item) {
      tmp = item.split("=");
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
    return result;
  };

  // ==================================================
  // Helpers Custom
  // ================================================== 

  // ==================================================
  // Setea el step actual en el modelo Window
  // ==================================================     
  Helper.setCurrentStep = function (step) {
    Model.Window.currentStep = step;
  };

  Helper.getCurrentStep = function () {
    return Model.Window.currentStep;
  };

  Helper.callView = function (view, data, cb, reload) {
    Helper.addStep(view, data, cb, reload);
  };

  // ==================================================
  // Valida si el modo en la URL esta permitido (Se saca desde config.js)
  // ================================================== 
  Helper.modoPermitido = function (modo) {
    if (Config.Modos.indexOf(modo) == -1) return false;
    return true;
  };

  // ==================================================
  // Valida si el sitio en la URL esta permitido (Se saca desde config.js)
  // ================================================== 
  Helper.sitioPermitido = function (sitio) {
    if (Config.Sitios[sitio] == null) return false;
    return true;
  };

  Helper.ocultarMail = function (email) {
    if (email != null && email != "" && email != "undefined") {

      var hasta = email.indexOf('@');
      var dominio = email.substring(hasta, email.length);
      var nombreMail = email.substring(0, 1) + "****";

      nombreMail += dominio;

      return nombreMail;
    }

    return "";
  };

  Helper.getTemplateAjax = function (path, data, cb) {
    var source;
    var template;
    Model.Usuario.EmailCodificado = Helper.ocultarMail(Model.Usuario.Email);
    var viewContent = {
      Config: Config,
      Model: Model,
      Data: data,
      Message: Message,
      Constantes: Constantes
    };
    $.ajax({
      url: path,
      cache: true
    }).done(function (res, status, xhr) {
      source = res;
      template = Handlebars.compile(source);
      $('#main-view').html(template(viewContent)).each(function () {
        Helper.setCanSubmit(true);
        cb && cb();
      });
    });
  };

  Helper.getBackgroundAjax = function (path, cb, data) {
    var source;
    var template;
    var viewContent = {
      Config: Config,
      Data: data,
      Message: Message,
      Constantes: Constantes
    };
    $.ajax({
      url: path,
      cache: true
    }).done(function (data, status, xhr) {
      source = data;
      template = Handlebars.compile(source);
      $('#background').html(template(viewContent)).each(function () {
        Helper.setCanSubmit(true);
        cb && cb();
      });
    });
  };

  Helper.guid = function () {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  };

  Helper.getHeaderAjax = function (path, cb, data) {
    var source;
    var template;
    var viewContent = {
      Config: Config,
      Data: data,
      Message: Message,
      Constantes: Constantes
    };
    $.ajax({
      url: path,
      cache: true
    }).done(function (data, status, xhr) {
      source = data;
      template = Handlebars.compile(source);
      $('#header').html(template(viewContent)).each(function () {
        Helper.setCanSubmit(true);
        cb && cb();
      });
    });
  };

  // ==================================================
  // Agrega una nueva vista reemplazando la actual
  // step = Step valido sacado de config.js
  // data = Todas las vistas tienen objeto de referencia llamado Data para ser usado por handlebars al compilar, se envia en forma de objeto 
  // cb = callback post ejecucion
  // reload = true / false Esto permite forzar el reload de una pantalla si lo requisiera
  // ==================================================     
  Helper.addStep = function (step, data, cb, reload) {
    var currentStep = Helper.getCurrentStep();
    var stepFile = Config.Step[step].file;
    var flow = Config.Step[step].flow;
    var data = data || {};
    Helper.setPageTitle(Config.Step[step].title);
    if (flow.length > 0 && flow.indexOf(currentStep) == -1) throw new Error("Flow no permitido");
    Helper.setCurrentStep(stepFile);
    console.log('STEP:' + stepFile);
    if (document.getElementById(stepFile) === null || reload) {
      $('#main-view').fadeOut('fast', function () {
        Helper.getTemplateAjax(Config.urlViews + 'steps/' + stepFile, data, function () {
          $('.steps').addClass('hide').each(function (index, el) {

            Helper.cleanKeyPress();
            Helper.hidePreloader();
            Helper.explorador();
            Helper.disableTop();
            Helper.addResponsiveText();
            Helper.addReturnBackArrow();
            Helper.placeHolderAnimationOnStepLoad();
            Helper.customSetup();
            $('#main-view').fadeIn('fast');
            $('.top-content p').css('display', 'block');
            Analytics.paginaVirtual(stepFile);

            if (Model.Window.modo == 'S') Analytics.paginaVirtualSignWall(stepFile);
            /* Set Analitycs event*/
            if (Helper.checkFirstStart() === false) {
              typeof ga !== "undefined" && ga('set', 'page', '/' + stepFile);
              typeof ga !== "undefined" && ga('send', 'pageview');
            }

            cb && cb();

            Helper.setFirstStart(false);
          });
        });
      });
    }
  };

  // Retorna un entero aleatorio entre min (incluido) y max (excluido)    
  Helper.getRandomInt = function (min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  };

  Helper.addReturnBackArrow = function () {
    if ($(".atras-form").length) $('#atras-header').attr('data-step', $(".atras-form").data('step'));
  };

  Helper.explorador = function () {
    // NAVEGADOR FIX
    var BrowserDetect = {
      init: function init() {
        this.browser = this.searchString(this.dataBrowser) || "An unknown browser";
        this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "an unknown version";
        this.OS = this.searchString(this.dataOS) || "an unknown OS";
      },
      searchString: function searchString(data) {
        for (var i = 0; i < data.length; i++) {
          var dataString = data[i].string;
          var dataProp = data[i].prop;
          this.versionSearchString = data[i].versionSearch || data[i].identity;
          if (dataString) {
            if (dataString.indexOf(data[i].subString) != -1) return data[i].identity;
          } else if (dataProp) return data[i].identity;
        }
      },
      searchVersion: function searchVersion(dataString) {
        var index = dataString.indexOf(this.versionSearchString);
        if (index == -1) return;
        return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
      },
      dataBrowser: [{ string: navigator.userAgent, subString: "Chrome", identity: "Chrome" }, { string: navigator.userAgent, subString: "OmniWeb", versionSearch: "OmniWeb/", identity: "OmniWeb" }, { string: navigator.vendor, subString: "Apple", identity: "Safari", versionSearch: "Version" }, { prop: window.opera, identity: "Opera", versionSearch: "Version" }, { string: navigator.vendor, subString: "iCab", identity: "iCab" }, { string: navigator.vendor, subString: "KDE", identity: "Konqueror" }, { string: navigator.userAgent, subString: "Firefox", identity: "Firefox" }, { string: navigator.vendor, subString: "Camino", identity: "Camino" }, { // for newer Netscapes (6+)
        string: navigator.userAgent,
        subString: "Netscape",
        identity: "Netscape"
      }, { string: navigator.userAgent, subString: "MSIE", identity: "Explorer", versionSearch: "MSIE" }, { string: navigator.userAgent, subString: "Gecko", identity: "Mozilla", versionSearch: "rv" }, { // for older Netscapes (4-)
        string: navigator.userAgent,
        subString: "Mozilla",
        identity: "Netscape",
        versionSearch: "Mozilla"
      }],
      dataOS: [{ string: navigator.platform, subString: "Win", identity: "Windows" }, { string: navigator.platform, subString: "Mac", identity: "Mac" }, { string: navigator.userAgent, subString: "iPhone", identity: "iPhone/iPod" }, { string: navigator.platform, subString: "Linux", identity: "Linux" }]

    };
    BrowserDetect.init();
    var browserDetection = BrowserDetect.browser;
    var browserVersion = 'v' + BrowserDetect.version;
    var OSname = BrowserDetect.OS;
    $('body').addClass(browserDetection + ' ' + browserVersion + ' ' + OSname);
    // NAVEGADOR FIX
  };

  Helper.disableTop = function () {
    if ($('.cabezal-black').length) {
      $('main').addClass('login-black');
      $('#main-view').addClass('no-top');
      $(window).on("load", function (event) {
        if ($(this).width() < 999) {
          $(".bottom-content, #contenedor>div").addClass('mobile');
        } else {
          $(".bottom-content, #contenedor>div").removeClass('mobile');
        }
      });
    };
    $('body').scrollTop(0);
  };

  Helper.addResponsiveText = function () {
    if ($(".responsive-content").length) $('.responsive-content-body').html($('.responsive-content').html());
  };

  Helper.addBackground = function (cb) {
    var file = Config.Background[Model.Window.modo].file;
    if (Config.Background[Model.Window.modo].class) $("#background").addClass(Config.Background[Model.Window.modo].class);
    if (!file) throw new Error("No existe el background");
    Helper.getBackgroundAjax(Config.urlViews + "backgrounds/" + file, function () {
      cb && cb();
    });
  };

  Helper.addHeader = function (cb) {
    var file = Config.Header[Model.Window.modo].file;
    if (!file) throw new Error("No existe el header");
    Helper.getHeaderAjax(Config.urlViews + "headers/" + file, function () {
      cb && cb();
    });
  };

  Helper.returnBack = function (options) {
    var pagina = !Helper.isEmpty(options) && !Helper.isEmpty(options.url) ? options.url : Model.Window.pagina;
    if (!Helper.isEmpty(pagina)) Helper.redirectUrl(pagina || Config.defaultRedirectUrl);
  };

  Helper.returnBackPassport = function (options) {

    var pagina = !Helper.isEmpty(options) && !Helper.isEmpty(options.url) ? options.url : Model.Window.pagina;
    if (!Helper.isEmpty(pagina)) Helper.redirectPassport(pagina || Config.defaultRedirectUrl);
  };

  Helper.returnBackLogout = function (options) {
    var pagina = !Helper.isEmpty(options) && !Helper.isEmpty(options.url) ? options.url : Model.Window.pagina;
    if (!Helper.isEmpty(pagina)) Helper.redirectUrl(pagina || Config.defaultRedirectUrl);
  };

  Helper.changeStatus = function (selector, status, message, analyticsMessage, cb) {
    Helper.displayMessage(selector, status);
    Helper.hidePreloader();

    if (!Helper.isEmpty(message)) Analytics.formError(selector.attr('id') + '-' + analyticsMessage);

    if (status == false && message) selector.parent().find('span').html(message);else selector.parent().find('span').html('');
    cb && cb();
  };

  Helper.cleanStatus = function (selector) {
    selector.removeClass("error");
    selector.removeClass("check");
    selector.parent().removeClass("error");
    selector.parent().removeClass("check");
    selector.find("span").html('');
  };

  Helper.displayMessage = function (selector, status) {
    if (status) {
      selector.parent(".input").removeClass('error');
      selector.parent(".input").addClass('check');
    } else {
      selector.parent(".input").addClass('error');
      selector.parent(".input").removeClass('check');
    }
  };

  Helper.displayCustomMessageError = function (selector, message, analyticsError) {
    Analytics.error(analyticsError);
    selector.html('').html(message);
  };

  Helper.displayCustomMessageFormError = function (selector, message, analyticsError) {
    Analytics.formError(Helper.getCurrentStep() + '-' + analyticsError);
    selector.html('').html(message);
  };

  Helper.cleanCustomMessageError = function (selector) {
    selector.html('');
  };

  Helper.placeHolderAnimation = function (obj, method) {
    obj.parent(".input").each(function () {
      $("label", this).css({
        "line-height": "20px",
        "font-size": "12px",
        "top": "0px"
      });
      $(".spin", this).css({
        "width": "100%"
      });
      if (method != "focus") $("input", this).focus();
    });
  };

  Helper.placeHolderAnimationOnStepLoad = function () {
    $('input').each(function () {
      if (!Helper.isEmpty($(this).val())) {
        Helper.changeStatus($(this), true);
        Helper.enableNextButton();
        $(this).parent().find("label").css({
          "line-height": "20px",
          "font-size": "12px",
          "top": "0px"
        });
      }
    });
  };

  Helper.checkNextButton = function (selector) {
    Helper.cleanStatusInputs();
    if (!Helper.isEmpty(selector.val())) Helper.enableNextButton();else Helper.disableNextButton();
  };

  Helper.enableNextButton = function () {
    $('.next-step').addClass('active');
    $('.next-step').prop("disabled", false);
  };

  Helper.disableNextButton = function () {
    $('.next-step').removeClass('active');
    $('.next-step').prop("disabled", true);
  };

  Helper.placeHolder = function () {
    //if ($('.mostrarPass').length > 0) {
    Helper.showHide();
    //}   
    $(document.body).on('click', "div.input label", function (e) {
      e.preventDefault();
      Helper.placeHolderAnimation($(this), "click");
    });

    $(document.body).on('focus', "div.input input", function (e) {
      e.preventDefault();
      Helper.placeHolderAnimation($(this), "focus");
    });

    $(document.body).on('blur', "div.input input", function (e) {
      $(".spin").css({
        "width": "0px"
      });
      if ($(this).val() == "") {
        $(this).parent(".input").each(function () {
          $("label", this).css({
            "line-height": "33px",
            "font-size": "14px",
            "font-weight": "400",
            "top": "15px"
          });
        });
      }
    });
  };

  Helper.cleanSpecialCharsInput = function (str) {
    return Helper.removeDiacritics(Helper.removeSpecialChars(str));
  };

  Helper.removeSpecialChars = function (str) {
    return str.replace(/[^a-zA-ZÀ-ÿ ]/g, "");
  };

  Helper.removeDiacritics = function (str) {
    var defaultDiacriticsRemovalMap = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

    for (var i = 0; i < defaultDiacriticsRemovalMap.length; i++) {
      str = str.replace(defaultDiacriticsRemovalMap[i].letters, defaultDiacriticsRemovalMap[i].base);
    }
    return str;
  };

  Helper.initialpreloader = function () {
    $('.preloader-main').delay(400).fadeOut(500);
  };

  Helper.cleanInputs = function () {
    $('.input input').val('');
  };

  Helper.cleanStatusInputs = function () {
    $(".input").each(function () {
      if (($(this).hasClass("error") || $(this).hasClass("check")) && $(this).hasClass("no-validate-keyup") == false && $(this).find("input").val() !== 0) {
        Helper.cleanStatus($(this));
      }
    });
  };

  Helper.globalResize = function () {
    Model.Window.width = $(window).width();
    Model.Window.height = $(window).height();
  };

  // on resize
  Helper.onResize = function () {
    Model.Window.width = $(window).width();
    Model.Window.height = $(window).height();
  };

  Helper.cleanKeyPress = function () {
    Model.Window.keyPress = 0;
  };

  Helper.checkCapsLock = function (e) {
    var isCapsLock = window.event.getModifierState && window.event.getModifierState('CapsLock');
    if (isCapsLock) {
      $('.aviso-mayuscula').show();
    } else {
      $('.aviso-mayuscula').hide();
    }
  };
  // ==================================================
  // Limpia el modelo, cookies y resetea parametros de URL
  // ==================================================   
  Helper.resetAll = function (cb) {
    var token = Helper.readCookie("token");
    var usuario_detalle_guid = Helper.readCookie("usuario%5Fdetalle%5Fguid");
    var cookieLogin = Helper.readCookie("cookieLogin");

    $(':input').val('');
    for (var index in Model.Usuario) {
      Model.Usuario[index] = '';
    }
    Helper.deleteAllCookies();
    if (!(Helper.isEmpty(usuario_detalle_guid) || Helper.isEmpty(cookieLogin) || Helper.isEmpty(token))) {
      Model.Usuario.HayCookie = 1;
    }
    Model.Usuario.SitioId = Model.Window.SitioId;
    cb && cb();
  };

  // ==================================================
  // Setea el model cuando tenia session anterior
  // ==================================================   
  Helper.setupPrevious = function () {
    var token = Helper.readCookie("token");
    var usuario_detalle_guid = Helper.readCookie("usuario%5Fdetalle%5Fguid");
    var cookieLogin = Helper.readCookie("cookieLogin");

    if (!(Helper.isEmpty(usuario_detalle_guid) || Helper.isEmpty(cookieLogin) || Helper.isEmpty(token))) {
      Model.Usuario.HayCookie = 1;
    }
  };

  Helper.showHide = function () {
    $(document.body).on('click', '.mostrarPass', function (e) {
      var mostrar = $(this);
      mostrar.text(function (i, text) {
        return text === "OCULTAR" ? "MOSTRAR" : "OCULTAR";
      });
      if (mostrar.text() == "OCULTAR") {
        mostrar.parent().find("input").attr("type", "text");
      } else {
        mostrar.parent().find("input").attr("type", "password");
      }
    });
  };

  Helper.resizeHandler = function () {
    Model.Window.width = $(window).width();
    Model.Window.height = $(window).height();
    //Helper.onResize();
    //Helper.globalResize();
    $(window).resize(function () {
      Helper.globalResize();
      $('#main-view').css('display', 'table');
    });

    /*$(window).resize(function() {
        Helper.onResize();
    });*/
  };

  // ==================================================
  // Obtiene la IP local/publica a traves de webrtc
  // ==================================================       

  Helper.getClientIP = function () {
    window.RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
    var client = new RTCPeerConnection({ iceServers: [] }),
        noop = function noop() {};
    client.createDataChannel(""); //create a bogus data channel
    client.createOffer(client.setLocalDescription.bind(client), noop); // create offer and set local description
    client.onicecandidate = function (ice) {
      //listen for candidate events
      if (!ice || !ice.candidate || !ice.candidate.candidate) return;
      var ip = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/.exec(ice.candidate.candidate)[1];
      Model.Window.ip = ip;
      client.onicecandidate = noop;
    };
  };

  Helper.customSetup = function () {
    var modo = Model.Window.modo;

    if (Model.Window.modo == 'D') $('.top-content').addClass('default');
    if (Model.Window.modo == 'S') {
      $('.top-content p').addClass('mobile');
      var topContent = $('.top-content');
      var newText = document.createElement('label');
      newText.className = "mobile";
      newText.innerHTML = "Para seguir leyendo ingresá con tu red social o tu e-mail";
      topContent.append(newText);
    }

    switch (modo) {

      case 'P':
        $('.top-content p').css('display', 'none');
        break;

      default:
      //
    }
  };

  /*********************************************/
  /*     Recaptcha
  /*********************************************/

  Helper.Recaptcha = {
    currentInstance: null,
    render: function render(control, submit, expired) {
      this.currentInstance = grecaptcha.render(control, {
        sitekey: Config.rcId,
        'expired-callback': function expiredCallback() {
          console.log('recaptcha expired! reseting...');
          expired && expired();
          Helper.displayCustomMessageFormError($('#recaptcha-mensaje'), Message.Usuario['CAPTCHA_EXPIRADO'], Message.Analytics.Usuario['CAPTCHA_EXPIRADO']);
          grecaptcha.ready(function () {
            grecaptcha.reset();
          });
        },
        callback: function callback() {
          console.log('recaptcha submit successfuly');
          submit && submit();
          Helper.cleanCustomMessageError($('#recaptcha-mensaje'));
        }
      });
    },
    getResponse: function getResponse(widget) {
      widget = widget || this.currentInstance;
      if (widget == null || widget == undefined) return;
      return grecaptcha.getResponse(widget);
    },
    excecute: function excecute(widget) {
      widget = widget || this.currentInstance;
      if (widget == null || widget == undefined) return;
      grecaptcha.execute(widget);
    },
    reset: function reset(widget) {
      widget = widget || this.currentInstance;
      if (widget == null || widget == undefined) return;
      grecaptcha.reset(widget);
    },
    isSubmitted: function isSubmitted(widget) {
      widget = widget || this.currentInstance;
      if (widget == null || widget == undefined) return false;
      var res = grecaptcha.getResponse(widget);
      return res !== "";
    }
  };

  /*Extension helpers Handlebars*/

  Handlebars.registerHelper('compare', function (lvalue, rvalue, options) {
    if (arguments.length < 3) throw new Error("Handlerbars Helper 'compare' needs 2 parameters");
    var operator = options.hash.operator || "==";
    var operators = {
      '==': function _(l, r) {
        return l == r;
      },
      '===': function _(l, r) {
        return l === r;
      },
      '!=': function _(l, r) {
        return l != r;
      },
      '<': function _(l, r) {
        return l < r;
      },
      '>': function _(l, r) {
        return l > r;
      },
      '<=': function _(l, r) {
        return l <= r;
      },
      '>=': function _(l, r) {
        return l >= r;
      },
      'typeof': function _typeof(l, r) {
        return (typeof l === 'undefined' ? 'undefined' : _typeof2(l)) == r;
      },
      'esMultiplode': function esMultiplode(l, r) {
        return l % r == 0;
      },
      'noEsMultiplode': function noEsMultiplode(l, r) {
        return l % r != 0;
      }
    };
    if (!operators[operator]) throw new Error("Handlerbars Helper 'compare' doesn't know the operator " + operator);
    var result = operators[operator](lvalue, rvalue);
    if (result) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    }
  });

  Handlebars.registerHelper('ContextEmbedHide', function (options) {
    if (Model.Embed.Mobile || Model.Embed.Article) {
      return options.inverse(this);
    } else {
      return options.fn(this);
    }
  });

  Handlebars.registerHelper('ContextEmbedShow', function (options) {
    if (Model.Embed.Mobile || Model.Embed.Article) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    }
  });

  Handlebars.registerHelper('ArticleContextHide', function (options) {
    if (Model.Embed.Article) {
      return options.inverse(this);
    } else {
      return options.fn(this);
    }
  });

  Handlebars.registerHelper('ArticleContextShow', function (options) {
    if (Model.Embed.Article) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    }
  });

  Helper.getHeader = function (res, position) {
    try {
      return res.split("|")[position];
    } catch (ex) {
      return null;
    }
  };

  Helper.StartExperiment = function (experimentId) {
    var experiment = null;

    for (var i in Constantes.Experiments) {
      var item = Constantes.Experiments[i];

      if (item.id !== experimentId || !item.active) continue;

      experiment = item;

      break;
    }

    if (experiment) {
      var experimentCookieName = 'exp_' + experiment.id;
      var experimentCookieValue = Helper.readCookie(experimentCookieName);

      if (!experimentCookieValue) {
        Helper.createCookie(experimentCookieName, experiment.variations[Helper.getRandomInt(0, Object.keys(experiment.variations).length)], Config.cookieExpirationTime, Config.dominioCookie);
        experimentCookieValue = Helper.readCookie(experimentCookieName);
      }

      var hasExperiment = Model.Usuario.Experiments.filter(function (x) {
        return x.id === experiment.id;
      }).length > 0;

      if (!hasExperiment) {
        Model.Usuario.Experiments.push({
          id: experiment.id,
          variation: experimentCookieValue
        });
      }

      try {
        if (typeof ga !== 'undefined') {
          ga('set', 'exp', experiment.id + '.' + experimentCookieValue);
          ga('send', 'pageview');
        }
      } catch (e) {
        console.log('ERROR', e);
      }
    }
  };
})(LN.Helper, LN.Config, LN.Model, Handlebars, window.config.Constantes, LN.Analytics, LN.Message, jQuery);

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(193);

var _core2 = _interopRequireDefault(_core);

var _config = __webpack_require__(84);

var _config2 = _interopRequireDefault(_config);

var _config3 = __webpack_require__(189);

var _config4 = _interopRequireDefault(_config3);

var _localstorage = __webpack_require__(127);

var _localstorage2 = _interopRequireDefault(_localstorage);

var _smartlock = __webpack_require__(128);

var _smartlock2 = _interopRequireDefault(_smartlock);

var _customDimension = __webpack_require__(126);

var _customDimension2 = _interopRequireDefault(_customDimension);

var _message = __webpack_require__(544);

var _message2 = _interopRequireDefault(_message);

var _helper = __webpack_require__(532);

var _helper2 = _interopRequireDefault(_helper);

var _model = __webpack_require__(190);

var _model2 = _interopRequireDefault(_model);

var _handler = __webpack_require__(531);

var _handler2 = _interopRequireDefault(_handler);

var _analytics = __webpack_require__(540);

var _analytics2 = _interopRequireDefault(_analytics);

var _service = __webpack_require__(191);

var _service2 = _interopRequireDefault(_service);

var _hotjar = __webpack_require__(542);

var _hotjar2 = _interopRequireDefault(_hotjar);

var _wcentrix = __webpack_require__(129);

var _wcentrix2 = _interopRequireDefault(_wcentrix);

var _logger = __webpack_require__(543);

var _logger2 = _interopRequireDefault(_logger);

var _userTracker = __webpack_require__(537);

var _userTracker2 = _interopRequireDefault(_userTracker);

var _validarClaveLib = __webpack_require__(545);

var _validarClaveLib2 = _interopRequireDefault(_validarClaveLib);

var _credencial = __webpack_require__(526);

var _credencial2 = _interopRequireDefault(_credencial);

var _facebook = __webpack_require__(527);

var _facebook2 = _interopRequireDefault(_facebook);

var _gmail = __webpack_require__(528);

var _gmail2 = _interopRequireDefault(_gmail);

var _redes = __webpack_require__(539);

var _redes2 = _interopRequireDefault(_redes);

var _nativo = __webpack_require__(529);

var _nativo2 = _interopRequireDefault(_nativo);

var _registro = __webpack_require__(530);

var _registro2 = _interopRequireDefault(_registro);

var _app = __webpack_require__(538);

var _app2 = _interopRequireDefault(_app);

var _jquery = __webpack_require__(131);

var _jquery2 = _interopRequireDefault(_jquery);

var _jquery3 = __webpack_require__(130);

var _jquery4 = _interopRequireDefault(_jquery3);

__webpack_require__(184);

__webpack_require__(186);

__webpack_require__(482);

__webpack_require__(185);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _userTracker = __webpack_require__(552);

var tracker = _interopRequireWildcard(_userTracker);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

LN.UserTracker = new function (Hotjar) {
    var UsersToTrack = tracker.usuarios || [];
    this.verifyUserToTrackHotjar = function (userId) {
        for (var i = 0; i < UsersToTrack.length; i++) {
            if (UsersToTrack[i].id == userId) {
                console.log('user-tracking');
                Hotjar.startRecording(['UserId', userId]);
                return;
            }
        }
    };
}(LN.Hotjar);

/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _config = __webpack_require__(189);

var _config2 = _interopRequireDefault(_config);

var _service = __webpack_require__(191);

var _service2 = _interopRequireDefault(_service);

var _helper = __webpack_require__(532);

var _helper2 = _interopRequireDefault(_helper);

var _model = __webpack_require__(190);

var _model2 = _interopRequireDefault(_model);

var _handler = __webpack_require__(531);

var _handler2 = _interopRequireDefault(_handler);

var _credencial = __webpack_require__(526);

var _credencial2 = _interopRequireDefault(_credencial);

var _facebook = __webpack_require__(527);

var _facebook2 = _interopRequireDefault(_facebook);

var _gmail = __webpack_require__(528);

var _gmail2 = _interopRequireDefault(_gmail);

var _nativo = __webpack_require__(529);

var _nativo2 = _interopRequireDefault(_nativo);

var _registro = __webpack_require__(530);

var _registro2 = _interopRequireDefault(_registro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function (App, Controller, Service, Handler, Helper, Config, Model, LocalStorage, $) {
    'use strict';

    // ==================================================
    // Ejecicion inicial
    // ==================================================  	

    App.init = function () {
        if (!Helper.areCookiesEnabled()) {
            Service.displayCookiesDeshabilitadasView();
            return;
        }

        /*if(Config.SentryIngresar)
          Sentry && Sentry.init({ dsn: Config.SentryIngresar });*/
        Service.startGmailApi();
        Service.startFacebookApi();
        Service.startComscore();
        Service.startEstadisticas();
        Service.createCustomDimension();
        Service.startGoogleTagManager();
        Service.initializeGoogleAnalytics();
        Service.startHotjar();
        Handler.router();

        if (LocalStorage.checkIfExists(Config.LoginFlagKey) && LocalStorage.checkExpiration(Config.LoginFlagKey)) {
            LocalStorage.renew(Config.LoginFlagKey);
        } else {
            LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        }
    };

    App.reload = function () {
        Helper.resetAll(function () {
            App.init();
        });
    };

    // ==================================================
    // Step Handler Event
    // ==================================================  
    $(document.body).on('click', '.next-button', function (event) {
        var t = $(this);
        var step = t.data('step');
        Handler.stepHandler(step, t);
        event.preventDefault();
        return false;
    });

    $('form').on('submit', function (e) {
        e.preventDefault();
        var step = $('.next-step').data('step');
        var isDisabled = $('.next-step').is(":disabled");
        if (Helper.canSubmit() && isDisabled == false) {
            Helper.setCanSubmit(false);
            Handler.stepHandler(step);
        }
    });

    $(document.body).on('keyup keypress', 'input', function (event) {
        Handler.keypressHandler($(this), event);
    });

    //$(document.body).on('keyup keypress', function (event) {
    //    Handler.keypressHandler($(this), event);
    //});

    $(window).on('load', Helper.initialpreloader);
})(LN.App, LN.Controller, LN.Service, LN.Handler, LN.Helper, LN.Config, LN.Model, LN.LocalStorage, jQuery);

// ONLOAD
(function (LN) {
    try {
        LN.App.init();
    } catch (err) {
        LN.Service.mostrarError(err, err);
    }
})(LN);

/***/ }),

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (Controller, Helper, Config, Model, Service, Handler, Analytics, LocalStorage, $) {
    'use strict';

    Controller.checkStorageSession = function () {
        // Chequeo el tiempo de vida del storage, si expira lo re-inicializo.
        if (LocalStorage.checkExpiration(Config.LoginFlagKey) == null) {
            LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
        }

        if (LocalStorage.getItem(Config.LoginFlagKey).value) {
            Helper.showPreloader();
            Controller.activateSessionPull();
            return true;
        } else {
            LocalStorage.setExpiredItem(Config.LoginFlagKey, true);
        }

        return false;
    };

    Controller.activateSessionPull = function () {
        if (Model.Window.modo == 'D') {
            setInterval(function () {
                if (LocalStorage.checkExpiration(Config.LoginFlagKey) == null) {
                    LocalStorage.setExpiredItem(Config.LoginFlagKey, false);
                    Helper.hidePreloader();
                }

                Service.isLogged();
            }, Config.returnBackInterval);
        }
    };
})(LN.Controller, LN.Helper, LN.Config, LN.Model, LN.Service, LN.Handler, LN.Analytics, LN.LocalStorage, jQuery);

/***/ }),

/***/ 540:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    if (!LN.Core) throw new Error("LN.Core missing");
})();

(function (Analytics, Helper, Config, Model) {
    'use strict';

    Analytics.paginaVirtualSignWall = function (page) {
        Analytics.pushData({
            'event': 'trackPageView',
            'pageName': page // Pagina actual   
        });
    };

    Analytics.clickSSO = function (method) {
        Analytics.pushData({
            'event': 'trackClickSSO',
            'login-method': method // Google, Facebook  
        });
    };

    Analytics.crearCuentaNativoClick = function () {
        Analytics.pushData({
            'event': 'trackClick',
            'eventLabel': 'Crear cuenta button'
        });
    };

    Analytics.crearCuentaNativoLink = function () {
        Analytics.pushData({
            'event': 'trackClick',
            'eventLabel': 'Crear cuenta link'
        });
    };

    Analytics.formError = function (label) {
        Analytics.pushData({
            'event': 'trackEvent',
            'eventCategory': 'autenticacion',
            'eventAction': 'error-form',
            'eventLabel': label
        });
    };

    Analytics.error = function (error) {
        Analytics.pushData({
            'event': 'trackErrorPageV',
            'flow': 'autenticacion',
            'errorType': error,
            'errorPage': true
        });
    };

    Analytics.login = function (isNew, method, id) {
        Analytics.pushData({
            'event': 'trackLogin',
            'newUser': isNew,
            'loginMethod': method, // Facebook,Google,Mail
            'userID': id
        });
    };

    Analytics.paginaVirtual = function (name) {
        Analytics.pushData({
            'event': 'trackPage',
            'pageName': name // Pagina actual   
        });
    };

    Analytics.asociacionExitosa = function (type, started) {
        Analytics.pushData({
            'event': 'trackAccountLink',
            'accountType': type, // Indicar� un string con el nombre del servicio que tiene el usuario, por ejemplo: Black       
            'started': started // Indicar� con un string la letra del flujo por el cual inici�. Por ejemplo: B
        });
    };

    Analytics.createAccount = function (name) {
        Analytics.pushData({
            'event': 'trackCreateAccount'
        });
    };

    /* CALL */
    Analytics.pushData = function (data) {
        typeof dataLayer !== 'undefined' && dataLayer && dataLayer.push(data);
    };
})(LN.Analytics, LN.Helper, LN.Config, LN.Model);

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
    if (!LN.Core) throw new Error("LN.Core missing");
})();

(function (Hotjar, Config, $) {
    'use strict';

    Hotjar.callTrigger = function (label) {
        console.log('hotjar-trigger: ' + label);
        hj('trigger', label);
    };

    Hotjar.startRecording = function (tag) {
        hj('trigger', Config.HotjarRecordingTrigger);
        hj('tagRecording', tag);
    };
})(LN.Hotjar, LN.Config, jQuery);

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

window.logger = new function IngresarLogger() {
    var self = this;
    var types = {
        info: { name: 'info', level: 2 },
        trace: { name: 'trace', level: 0 },
        warn: { name: 'warn', level: 3 },
        debug: { name: 'debug', level: 1 },
        error: { name: 'error', level: 4 },
        fatal: { name: 'fatal', level: 5 }
    };
    var elmahLevel = LN.Config.elmahLevel;

    function post(data) {

        $.ajax({
            url: LN.Config.dominioMiCuenta + '/lgn-log',
            type: 'POST',
            data: JSON.stringify(data),
            async: true,
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            }

        });
    }

    function log(type, message, ex) {
        try {

            if (ex != null && (typeof ex === 'undefined' ? 'undefined' : _typeof(ex)) == "object") {
                ex = JSON.stringify(ex);
            }

            var values = {
                type: type,
                message: message,
                exception: ex
            };

            if (types[type].level >= types[elmahLevel].level) {
                post(values);
            }
            return self;
        } catch (exp) {
            console.log('Error logueando');
        }
    }

    this.error = function (message, ex) {
        return log(types.error.name, message, ex);
    };

    this.info = function (message, ex) {
        return log(types.info.name, message, ex);
    };

    this.trace = function (message, ex) {
        return log(types.trace.name, message, ex);
    };

    this.warn = function (message, ex) {
        return log(types.warn.name, message, ex);
    };
    this.debug = function (message, ex) {
        return log(types.debug.name, message, ex);
    };
    this.fatal = function (message, ex) {
        return log(types.fatal.name, message, ex);
    };
    this.exception = function (message, ex) {
        return log(types.fatal.name, message, ex);
    };
}();

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  if (!LN.Core) throw new Error("LN.Core missing");
})();

(function (Message) {
  'use strict';
  // ==================================================
  // Mensajes de error
  // ==================================================  

  Message.Error = {
    '500': "Internal Server Error",
    '400': "Bad Request",
    '401': "Unauthorized",
    '403': "Forbidden",
    '404': "Not Found",
    '405': "Method Not Allowed",
    'TIMEOUT': "Connection Timeout",
    'ABORT': "Aborted",
    'GENERAL': "Error",
    'ENLACE_CADUCADO': "El link no se encuentra vigente."
  };

  Message.Analytics.Error = {
    '500': "Internal Server Error",
    '400': "Bad Request",
    '401': "Unauthorized",
    '403': "Forbidden",
    '404': "Not Found",
    '405': "Method Not Allowed",
    'TIMEOUT': "Connection Timeout",
    'ABORT': "Aborted",
    'GENERAL': "Error",
    'ENLACE_CADUCADO': "El link no se encuentra vigente."
  };

  // ==================================================
  // Mensajes de error
  // ==================================================  
  Message.Usuario = {
    'CAPTCHA_INVALIDO': 'Captcha inválido',
    'CAPTCHA_REQUERIDO': 'Confirmá el captcha para poder continuar',
    'CAPTCHA_EXPIRADO': 'La verificación ha caducado. Vuelve a marcar la casilla de verificación.',
    'USUARIO_INVALIDO': 'Ingresá un e-mail o un usuario válido',
    'EMAIL_INVALIDO': 'Ingresá un e-mail válido',
    'EMAIL_NO_EXISTE': 'El e-mail no corresponde a una cuenta existente. Verificalo o registrate con una nueva cuenta.',
    'CLAVE_INVALIDA': 'La contraseña que ingresaste es incorrecta',
    'CLAVE_INCORRECTA': 'Contraseña incorrecta. Por favor, ingresala nuevamente',
    'CLAVE_DIFIERE': 'Las contraseñas no coinciden.',
    'CLAVE_FAIL': 'La contraseña es incorrecta.',
    'SUSPENDIDO_POR_ABUSO': 'Tu usuario fue suspendido. Para ingresar creá una cuenta con otro e-mail',
    'ELIMINADO_LOGICO': 'Tu usuario fue eliminado. Para ingresar creá una cuenta con otro e-mail',
    'SUSPENDIDO_DEFINITIVO': 'Suspendido definitivo',
    'USUARIO_EXISTE_MAIL': 'Se produjo un error al enviar el mail al nuevo usuario registrado',
    'USUARIO_EXISTE': 'El Email ya existe',
    'USUARIO_NO_EXISTE': 'El usuario no existe',
    'USUARIO_O_GUID_NO_EXISTE': 'El usuario o GUID no existe',
    'NO_ACTUALIZA': 'No pudimos actualizar tu contraseña, por favor intentá nuevamente',
    'LOGUEATE_RED_SOCIAL': 'El mail ingresado ya se encuentra registrado con Google y Facebook, ingresá utilizando el botón de Google o Facebook.',
    'LOGUEATE_RED_SOCIAL_GOOGLE': 'El mail ingresado ya se encuentra registrado con Google, ingresá utilizando el botón de Google.',
    'LOGUEATE_RED_SOCIAL_FACEBOOK': 'El mail ingresado ya se encuentra registrado con Facebook, ingresá utilizando el botón de Facebook.',
    'NOMBRE_APELLIDO_INCORRECTO': 'Tenés que incluir al menos 2 caracteres sin números ni símbolos',
    'DOMINIO_INVALIDO': 'Dominio no permitido.',
    'FACEBOOK_EXISTE': 'Ya existe un usuario con el perfil de Facebook ingresado.',
    'GMAIL_EXISTE': 'Ya existe un usuario con la cuenta de Google ingresada.',
    'CLAVE_ACTUAL_INVALIDA': 'La clave actual ingresada es incorrecta',
    'CLAVE_ANTERIOR_INVALIDA': 'Su clave anterior es incorrecta',
    'VOLVER_A_INTENTARLO': 'Volver a intentarlo',
    'USUARIO_DOMINIO_INVALIDO': 'El dominio está inhabilitado. Intentá con otro.',
    'USUARIO_CLAVE_REPETIDA': 'La nueva contraseña no puede ser igual a una contraseña utilizada previamente.',
    'USUARIO_CAMPO_FALTANTE': 'Debe completar todos los datos para darse de alta.',
    'ALTA_RED_INVALIDA': 'El usuario ya esta registrado o asociado por redes sociales.',
    'ALTA_MAIL_NO_ENVIO': 'Se produjo un error al enviar el mail al nuevo usuario registrado.',
    'CODIGO_INVALIDO': 'Codigo verificacion invalido.',
    'CARACTER_INVALIDO_MAIL': 'El E-mail no puede contener caracteres especiales.',
    'CARACTER_INVALIDO_PASS_REG': 'Tu contraseña incluye caracteres especiales no permitidos. Intentá nuevamente evitando; acentos, ñ, comillas y otros símbolos.',
    'CARACTER_INVALIDO_PASS_LOG': 'Tu contraseña incluye caracteres no permitidos. Por favor inicia ingresa en Olvidé mi contraseña para modificarla.',
    'LONGITUD_INVALIDO_PASS_LOG': 'La contraseña excede la cantidad de caracteres permitidos (8-20).'
  };

  Message.Analytics.Usuario = {
    'CAPTCHA_INVALIDO': 'Captcha inválido',
    'CAPTCHA_REQUERIDO': 'Confirmá el captcha para poder continuar',
    'CAPTCHA_EXPIRADO': 'La verificación ha caducado. Vuelve a marcar la casilla de verificación.',
    'USUARIO_INVALIDO': 'Ingresá un e-mail o un usuario válido',
    'EMAIL_INVALIDO': 'Ingresá un e-mail válido',
    'EMAIL_NO_EXISTE': 'El e-mail no corresponde a una cuenta existente. Verificalo o registrate con una nueva cuenta.',
    'CLAVE_INVALIDA': 'La contraseña que ingresaste es incorrecta',
    'CLAVE_INCORRECTA': 'Contraseña incorrecta. Por favor, ingresala nuevamente',
    'CLAVE_DIFIERE': 'Las contraseñas no coinciden.',
    'CLAVE_FAIL': 'La contraseña es incorrecta.',
    'SUSPENDIDO_POR_ABUSO': 'Tu usuario fue suspendido. Para ingresar creá una cuenta con otro e-mail',
    'ELIMINADO_LOGICO': 'Tu usuario fue eliminado. Para ingresar creá una cuenta con otro e-mail',
    'SUSPENDIDO_DEFINITIVO': 'Suspendido definitivo',
    'USUARIO_EXISTE_MAIL': 'Se produjo un error al enviar el mail al nuevo usuario registrado',
    'USUARIO_EXISTE': 'Ya existe el email ingresado',
    'USUARIO_NO_EXISTE': 'El usuario no existe',
    'USUARIO_O_GUID_NO_EXISTE': 'El usuario o GUID no existe',
    'NO_ACTUALIZA': 'No pudimos actualizar tu contraseña, por favor intentá nuevamente',
    'LOGUEATE_RED_SOCIAL': 'Email Registrado RedesSociales',
    'LOGUEATE_RED_SOCIAL_GOOGLE': 'Email Registrado Google',
    'LOGUEATE_RED_SOCIAL_FACEBOOK': 'Email Registrado Facebook',
    'NOMBRE_APELLIDO_INCORRECTO': 'Tenés que incluir al menos 2 caracteres sin números ni símbolos',
    'DOMINIO_INVALIDO': 'Dominio no permitido.',
    'FACEBOOK_EXISTE': 'Ya existe un usuario con el perfil de Facebook ingresado.',
    'GMAIL_EXISTE': 'Ya existe un usuario con la cuenta de Google ingresada.',
    'CLAVE_ACTUAL_INVALIDA': 'La clave actual ingresada es incorrecta',
    'CLAVE_ANTERIOR_INVALIDA': 'Su clave anterior es incorrecta',
    'VOLVER_A_INTENTARLO': 'Volver a intentarlo',
    'USUARIO_DOMINIO_INVALIDO': 'El dominio está inhabilitado. Intentá con otro.',
    'USUARIO_CLAVE_REPETIDA': 'La nueva contraseña no puede ser igual a una contraseña utilizada previamente.',
    'USUARIO_CAMPO_FALTANTE': 'Debe completar todos los datos para darse de alta.',
    'ALTA_RED_INVALIDA': 'El usuario ya esta registrado o asociado por redes sociales.',
    'ALTA_MAIL_NO_ENVIO': 'Se produjo un error al enviar el mail al nuevo usuario registrado.',
    'CODIGO_INVALIDO': 'Codigo verificacion invalido.',
    'CARACTER_INVALIDO_MAIL': 'El E-mail no puede contener caracteres especiales.',
    'CARACTER_INVALIDO_PASS_REG': 'Tu contraseña incluye caracteres especiales no permitidos. Intentá nuevamente evitando; acentos, ñ, comillas y otros símbolos.',
    'CARACTER_INVALIDO_PASS_LOG': 'Tu contraseña incluye caracteres no permitidos. Por favor inicia ingresa en Olvidé mi contraseña para modificarla.',
    'LONGITUD_INVALIDO_PASS_LOG': 'La contraseña excede la cantidad de caracteres permitidos (8-20).'
  };

  // ==================================================
  // Mensajes de error
  // ==================================================  
  Message.Credencial = {
    'ERROR_ASOCIAR': 'No se pudo vincular tu tarjeta correctamente.',
    'ERROR_NO_COINCIDEN': 'Los números de DNI y Tarjeta que ingresaste no coinciden.  Cargalos nuevamente. <br> ¿Tenés dudas? Llamanos al 5199-4787 o escribinos desde el exterior a <b>accesodigital@lanacion.com.ar</b> ',
    'ERROR_YA_ASOCIADO': 'La cuenta está creada con el e-mail: <b>{{email}}</b> <br>' + 'Si es tuya, ingresá con ese e-mail.<br><br>' + '¿Tenés dudas? Llamanos al 5199-4787 o escribinos desde el exterior a <b>accesodigital@lanacion.com.ar</b> <br><br>' + '<a href="https://goo.gl/K3gZWY" target="_blank">¿cómo desvincular la credencial para usarla en mi nueva cuenta?</a>',
    'DNI_INCOMPLETO': 'Revisá que el número de documento esté completo',
    'INCORRECTA': 'Credencial incorrecta'
  };

  Message.Analytics.Credencial = {
    'ERROR_ASOCIAR': 'No se pudo vincular tu tarjeta correctamente.',
    'ERROR_NO_COINCIDEN': 'DNI_TARJETA_NO_COINCIDEN',
    'ERROR_YA_ASOCIADO': 'ERROR_YA_ASOCIADO',
    'DNI_INCOMPLETO': 'Revisá que el número de documento esté completo',
    'INCORRECTA': 'Credencial incorrecta'
  };

  Message.DefaultErrorMessage = 'Ha ocurrido un error. Por favor, intentá nuevamente.';
  Message.Analytics.DefaultErrorMessage = 'Ha ocurrido un error. Por favor, intentá nuevamente.';
})(LN.Message);

/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


window.Password = window.Password || {};
Password.Validator = Password.Validator || {};
Password.Validator.NuevaClave = Password.Validator.NuevaClave || {};

Password.Validator.Variacion = Password.Validator.Variacion || {};
Password.Validator.Variacion.Digit = false;
Password.Validator.Variacion.Lower = false;
Password.Validator.Variacion.Upper = false;
Password.Validator.Variacion.NonWords = false;

Password.Validator.PassComplex = "weak";

Password.Validator.RepetirClave = false; // Valor para ver si tengo que validar repetición de clave
Password.Validator.ActualClave = false; // Valor para ver si tengo que validar el ingreso de la clave actual
Password.Validator.NuevaClave = false; // Valor para ver si tengo que validar el ingreso de la nueva clave
Password.Validator.Captcha = false; // Valor para ver si tengo que validar el ingreso del captcha

Password.Validator.submitActive = true;

Password.Validator.STR_PASS_DIFERENTES = "Las contraseñas no coinciden. Por favor, ingresalas nuevamente";
Password.Validator.STR_PASS_ACTUAL_VACIA = "Debe ingresar la clave actual";
Password.Validator.STR_PASS_ACTUAL_REPETIDA = "La nueva clave no debe ser la misma que la clave actual";
Password.Validator.STR_PASS_CANT_CARACTERES = "La contraseña tiene que tener al menos 8 caracteres";
Password.Validator.STR_NO_CAPTCHA = "Debés ingresar el captcha";
Password.Validator.STR_PASS_VACIO = "El campo no puede estar vacío";
Password.Validator.STR_PASS_NUEVA_VACIO = "Por favor, confirmá la contraseña";

Password.Validator.STR_PASS_FLAG_ROJO = "Contraseña insegura. Evitá repetición de números y caracteres";
Password.Validator.STR_PASS_FLAG_AMARILLO = "Contraseña poco segura";
Password.Validator.STR_PASS_FLAG_VERDE = "Contraseña válida";

Password.Validator.scorePassword = function (pass) {
    var score = 0;

    if (!pass || pass.length < 8) // Si no hay pass o si es menor a 8 caracteres score = 0 
        return score;

    var letters = new Object();
    for (var i = 0; i < pass.length; i++) {
        letters[pass[i]] = (letters[pass[i]] || 0) + 1;
        score += 5.0 / letters[pass[i]];
    }

    Password.Validator.Variacion.Digit = /\d/.test(pass);
    Password.Validator.Variacion.Lower = /[a-z]/.test(pass);
    Password.Validator.Variacion.Upper = /[A-Z]/.test(pass);
    Password.Validator.Variacion.NonWords = /\W/.test(pass);
    Password.Validator.Variacion.LowerAndUpper = /[a-zA-Z]/.test(pass);

    var variationCount = 0;
    for (var check in Password.Validator.Variacion) {
        variationCount += Password.Validator.Variacion[check] == true ? 1 : 0;
    }
    score += (variationCount - 1) * 10;

    // Valido que se hayan "activado" las variaciones obligatorias, sino devuelvo score = 0 
    if (Password.Validator.Variacion.Digit && Password.Validator.Variacion.LowerAndUpper /*&& Password.Validator.Variacion.Lower && Password.Validator.Variacion.Upper*/) return parseInt(score);else return 0;
};

Password.Validator.checkPassStrength = function (pass) {
    var score = Password.Validator.scorePassword(pass);

    if (score > 80) Password.Validator.PassComplex = "strong";else if (score >= 55) Password.Validator.PassComplex = "strong";else if (score < 55) Password.Validator.PassComplex = "weak";

    score < 55 ? Password.Validator.submitActive = false : Password.Validator.submitActive = true;

    return Password.Validator.PassComplex;
};

Password.Validator.MostrarTextoErrorPassword = function () {
    var variationCount = 0;
    var stringError = "";

    if ($(".val-nueva-clave").val().length < 8) {
        stringError = Password.Validator.STR_PASS_CANT_CARACTERES;
        $(".val-nueva-clave-mensaje").html(stringError).addClass("error").removeClass("check");
    } else {
        // Cuento las variaciones que estÃ¡n activas . Tienen que ser 3 en total porque no cuento la de sÃ­mbolos "NonWords" . 
        for (var check in Password.Validator.Variacion) {
            variationCount += Password.Validator.Variacion[check] == true && check != "NonWords" ? 1 : 0;
            //variationCount += (Password.Validator.Variacion[check] == true) ? 1 : 0;
        }

        if (variationCount < 3) {
            var i = 0;
            for (var check in Password.Validator.Variacion) {
                if (Password.Validator.Variacion[check] != true && check != "NonWords") {
                    //if (Password.Validator.Variacion[check] != true) {
                    i++;

                    if (check == "Digit") {
                        stringError += "Tenés que incluir un número";
                    } else if (check == "LowerAndUpper") {
                        stringError += "Tenés que incluir al menos una letra.";
                    }
                }
            }

            $(".val-nueva-clave-mensaje").show();
        }
    }

    // Muestro mensaje de clave correspondiente a la complejidad de la clave
    switch (Password.Validator.PassComplex) {
        case "weak":

            $(".val-guardar").prop("disabled", true).addClass("btn-inactivo"); // Desactivo botón submit
            $(".val-nueva-clave").parent().addClass("error").removeClass("check"); // Agrego flag rojo

            if (stringError != "") stringError = stringError; // Si la clave no cumple los requerimientos mÃ­nimos
            else stringError = Password.Validator.STR_PASS_FLAG_ROJO; // La clave cumple los requerimientos mÃ­nimos pero no pondera lo suficiente 

            $(".val-nueva-clave-mensaje").html(stringError).addClass("error").removeClass("check");

            break;

        //case "good":
        //    $(".val-guardar").prop("disabled", false).removeClass("btn-inactivo");	// Habilito botón submit
        //    $(".val-nueva-clave").addClass("pass-amarillo").removeClass("pass-verde").removeClass("pass-rojo");	// Agrego flag amarillo
        //    $(".val-nueva-clave-mensaje").html(Password.Validator.STR_PASS_FLAG_AMARILLO)
        //        .addClass("mensaje-contrasena-amarillo")
        //        .removeClass("mensaje-contrasena-rojo")
        //        .removeClass("mensaje-contrasena-verde");// Texto flag amarillo
        //    break;

        case "strong":
            $(".val-guardar").prop("disabled", false).removeClass("btn-inactivo"); // Habilito botón submit
            $(".val-nueva-clave").parent().addClass("check").removeClass("error"); // Agrego flag verde
            $(".val-nueva-clave-mensaje").html(Password.Validator.STR_PASS_FLAG_VERDE).addClass("check").removeClass("error"); // Texto flag verde
            break;
    }
};

Password.Validator.canSubmit = function (validateCaptchaNow) {
    var nuevaClave = $(".val-nueva-clave").val();
    var repetirClave = $(".val-repetir-clave").val();
    var actualClave = $(".val-actual-clave").val();

    var canSubmit = true;

    // Limpio los errores y sus mensajes en los span 
    $(".error").each(function (item, value) {
        $(value).removeClass("error");
        $(value).find("span").html("");
    });

    if (Password.Validator.ActualClave) {
        // Si está el input de clave actual
        if (actualClave == "") {
            // Valido que la clave actua sea diferente de vacío
            $(".val-actual-clave-mensaje").html(Password.Validator.STR_PASS_ACTUAL_VACIA);
            $(".val-actual-clave").parent().addClass("error").removeClass("check");
            return false;
        } else if (actualClave == nuevaClave) {
            $(".val-actual-clave-mensaje").html(Password.Validator.STR_PASS_ACTUAL_REPETIDA);
            $(".val-actual-clave").parent().addClass("error").removeClass("check");
            return false;
        }
    }

    if (Password.Validator.RepetirClave) {
        // Si está el input de repetir clave
        if (nuevaClave == "") {
            $(".val-nueva-clave-mensaje").html(Password.Validator.STR_PASS_VACIO);
            $(".val-nueva-clave").parent().addClass("error").removeClass("check");

            $(".val-repetir-clave-mensaje").html(Password.Validator.STR_PASS_NUEVA_VACIO);
            $(".val-repetir-clave").parent().addClass("error").removeClass("check");
            return false;
        } else if (Password.Validator.checkPassStrength($(".val-nueva-clave").val()) == "weak") {
            Password.Validator.MostrarTextoErrorPassword();
        }

        if (repetirClave == "") {
            $(".val-repetir-clave-mensaje").html(Password.Validator.STR_PASS_NUEVA_VACIO);
            $(".val-repetir-clave").parent().addClass("error").removeClass("check");
            return false;
        }

        if (nuevaClave != repetirClave) {
            // Valido que la clave nueva sea igual a repetir clave
            $(".val-repetir-clave-mensaje").html(Password.Validator.STR_PASS_DIFERENTES);
            $(".val-repetir-clave").parent().addClass("error").removeClass("check");
            return false;
        }
    }

    if (Password.Validator.NuevaClave) {
        // Si está el input de nueva clave
        if (nuevaClave == "") {
            $(".val-nueva-clave-mensaje").html(Password.Validator.STR_PASS_VACIO);
            $(".val-nueva-clave").parent().addClass("error").removeClass("check");

            //$(".val-repetir-clave-mensaje").html(Password.Validator.STR_PASS_VACIO);
            //$(".val-repetir-clave").parent().addClass("error").removeClass("check");
            return false;
        } else if (Password.Validator.checkPassStrength($(".val-nueva-clave").val()) == "weak") {
            Password.Validator.MostrarTextoErrorPassword();
            return false;
        }
    }

    if (validateCaptchaNow) {
        if (Password.Validator.Captcha) {
            if ($("#g-recaptcha-response").val() == "") {
                $("#recaptcha-mensaje").html(Password.Validator.STR_NO_CAPTCHA);
                return false;
            }
        }
    }

    // Validaciones de que la clave nueva esté . (los mensaje de error ya se mostraron anteriormente)
    if (nuevaClave == undefined || nuevaClave == null || nuevaClave == "") {
        return false;
    }

    return true;
};

$.fn.strongpass = function (callback) {
    // Iterate all elements the selector applies to
    this.each(function () {
        var $input = $(this);
        // Can probably make this more obvious by using "is"
        if ($input.is("input")) {
            // Chequeo si existe campo repetir-clave 
            if ($(".val-repetir-clave").length > 0) Password.Validator.RepetirClave = true;

            // Chequeo si existe campo actual-clave
            if ($(".val-actual-clave").length > 0) Password.Validator.ActualClave = true;

            // Chequeo si existe campo actual-clave
            if ($(".val-nueva-clave").length > 0) Password.Validator.NuevaClave = true;

            // Chequeo si existe el captcha
            if ($("#recaptcha_area").length > 0 || $(".g-recaptcha").length > 0) Password.Validator.Captcha = true;

            $(".val-guardar").prop("disabled", true).addClass("btn-inactivo");

            // Muestro los mensajes correspondientes a la validación 
            //Password.Validator.MostrarTextoErrorPassword();

            // Now bind to the keyup event of this individual input
            $input.on("keyup", function () {
                var input_str = $.trim($input.val());

                // Seteo variables de dificultad de password
                Password.Validator.checkPassStrength(input_str);

                // Muestro los mensajes correspondientes a la validación 
                Password.Validator.MostrarTextoErrorPassword();
            });

            var canSubmitfnc = Password.Validator.canSubmit;

            $input.on("focusout", function () {
                canSubmitfnc(false);
            });

            if (Password.Validator.RepetirClave) {
                $(".val-repetir-clave").on("focusout", function () {
                    canSubmitfnc(false);
                });
            }

            if (Password.Validator.ActualClave) {
                $(".val-actual-clave").on("focusout", function () {
                    canSubmitfnc(false);
                });
            }

            if (Password.Validator.NuevaClave) {
                $(".val-nueva-clave").on("focusout", function () {
                    canSubmitfnc(false);
                });
            }
        }
    });
};

/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "settings/userTracker.json";

/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(533);


/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (Config, Constantes) {

    Config.defaultSitioId = Constantes.defaultSitioId;
    Config.apiVersion = Constantes.apiVersion;
    Config.cookieExpirationTime = Constantes.TimeExpiration;
    Config.keyPressLimit = Constantes.keyPressLimit;
    Config.freezeTime = Constantes.freezeTime;
    Config.returnBackInterval = Constantes.returnBackInterval;
    Config.dominioCookie = Constantes.dominioCookie || 'localhost';

    Config.disableValidations = Constantes.disableValidations;
    Config.enableQuickView = Constantes.enableQuickView;
    Config.forceCreateNewAddress = Constantes.forceCreateNewAddress;
    Config.elmahLevel = Constantes.elmahLevel;

    // =================================================
    // Dominios
    // =================================================
    Config.apiLoginUrl = Constantes.Dominios.apiLogin;
    Config.apiPaywallUrl = Constantes.Dominios.apiPaywall;
    Config.urlStatic = Constantes.Dominios.static;
    Config.defaultRedirectUrl = Constantes.Dominios.lanacion;
    Config.urlImages = Constantes.Dominios.static + "/images";
    Config.dominioMiCuenta = Constantes.Dominios.micuenta;
    Config.dominioLaNacion = Constantes.Dominios.lanacion;
    Config.urlPassport = Constantes.Dominios.passport;
    Config.urlMiClub = Constantes.Dominios.miclub;
    Config.urlBucket = Constantes.Dominios.bucket + '/Club.LN/anexos/fotos/productos/';
    // =================================================
    // Api Keys
    // =================================================
    Config.wCentrixTime = Constantes.wCentrixTime;
    Config.idWcentrix = Constantes.idWcentrix;
    Config.hotjarId = Constantes.idHotjar;
    Config.fbId = Constantes.fbId;
    Config.gmId = Constantes.gmId;
    Config.gmRedirect = Constantes.gmRedirect;
    Config.rcId = Constantes.rcId;
    Config.gaId = Constantes.gaId;
    Config.gtmId = Constantes.gtmId;
    Config.SentryPaywall = Constantes.sentry_paywall || null;
    Config.SentryIngresar = Constantes.sentry_ingresar || null;

    // ==================================================
    // Sitios Ids Asociar Tarjeta post-login
    // 6 - Club LN / 7 - Autogestión/MiClub
    // ==================================================  
    Config.SitiosAsociarCredencial = Object.values(Constantes.SitiosAsociarCredencial);

    // ==================================================
    // Sitios Ids Permitidos
    // 1 - webLN / 2 - webCLL / 3 - webOH / 4 - appLN / 6 - Club LN / 7 - Autogestión/MiClub / 8 - Experiencias Black
    // ==================================================
    Config.Sitios = Constantes.Sitios;

    // ==================================================
    // Dominios permitidos a redireccionar
    // ==================================================  
    Config.dominiosPermitidos = RegExp(Constantes.dominiosPermitidos);

    // ========================================================
    // Diccionario de keys de usuario para grabar en cookies
    // ========================================================
    Config.DiccionarioCookiesAGuardar = Object.values(Constantes.DiccionarioCookiesAGuardar);
})(LN.Config, window.config.Constantes);

/***/ })

/******/ });


// WEBPACK FOOTER //
// scripts/login.e9e5eb1.min.js